webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var i18n = function i18n() {
  return i18n.languages[i18n.config.language];
};

if (typeof window != 'undefined') window.i18n = i18n;

i18n.config = {
  language: 'en',
  locale: 'en'
};

i18n.languages = {
  en: __webpack_require__(226)
};

module.exports = i18n;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveDao = __webpack_require__(101);

var _reactiveDao2 = _interopRequireDefault(_reactiveDao);

var _reactiveDaoSockjs = __webpack_require__(100);

var _reactiveDaoSockjs2 = _interopRequireDefault(_reactiveDaoSockjs);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var sessionId = localStorage.sessionId;
if (!sessionId) {
  sessionId = guid();
  localStorage.sessionId = sessionId;
}
document.cookie = "sessionId=" + sessionId;

var api = new _reactiveDao2.default(sessionId, {

  remoteUrl: document.location.protocol + '//' + document.location.host + "/sockjs",

  connectionSettings: {
    requestSendTimeout: 1200,
    queueRequestsWhenDisconnected: true
  },

  protocols: {
    'sockjs': _reactiveDaoSockjs2.default
  },

  user: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  emailPassword: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  session: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  save: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableList
  },
  subscription: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  foxyCart: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  geoip: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  logs: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  config: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableList
  }

});

api.session = new _vue2.default({
  data: {
    session: null
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.session && !!this.session.userId;
    },
    roles: function roles() {
      return this.session && this.session.roles || [];
    },
    premium: function premium() {
      return this.roles && this.roles.indexOf("premium") != -1;
    }
  },
  watch: {
    session: function session(sess) {
      document.querySelector("#preconnect").style.display = sess != null ? "none" : "flex";
    }
  },
  created: function created() {
    api.observable(["session", "currentSession"]).bindProperty(this, 'session');
  }
});

exports.default = api;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _files = __webpack_require__(209);

var _files2 = _interopRequireDefault(_files);

var _view = __webpack_require__(216);

var _view2 = _interopRequireDefault(_view);

var _logic = __webpack_require__(213);

var _logic2 = _interopRequireDefault(_logic);

var _wordsTips = __webpack_require__(217);

var _wordsTips2 = _interopRequireDefault(_wordsTips);

var _input = __webpack_require__(210);

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  files: _files2.default, view: _view2.default, logic: _logic2.default, wordsTips: _wordsTips2.default, input: _input2.default,
  adsTips: []
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _isNan = __webpack_require__(71);

var _isNan2 = _interopRequireDefault(_isNan);

var _map = __webpack_require__(27);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var operators = [{
  name: '=',
  classes: ['compare', 'binary', 'infix', 'bool'],
  left: 'column',
  right: 'const',
  compute: function compute(left, right) {
    if (left && right && left.toLowerCase && right.toLowerCase) return left.toLowerCase() == right.toLowerCase();
    return left == right;
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: 'regex',
  classes: ['compare', 'binary', 'infix', 'bool'],
  left: 'column',
  right: 'regex',
  compute: function compute(left, right) {
    return ("" + left).match(right);
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: '!regex',
  classes: ['compare', 'binary', 'infix', 'bool'],
  left: 'column',
  right: 'regex',
  compute: function compute(left, right) {
    return !("" + left).match(right);
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: '<=',
  classes: ['compare', 'binary', 'infix', 'bool'],
  left: 'column',
  right: 'const',
  compute: function compute(left, right) {
    return left <= right;
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: '>=',
  left: 'column',
  right: 'const',
  classes: ['compare', 'binary', 'infix', 'bool'],
  compute: function compute(left, right) {
    return left >= right;
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: '<',
  left: 'column',
  right: 'const',
  classes: ['compare', 'binary', 'infix', 'bool'],
  compute: function compute(left, right) {
    return left < right;
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: '>',
  left: 'column',
  right: 'const',
  classes: ['compare', 'binary', 'infix', 'bool'],
  compute: function compute(left, right) {
    return left > right;
  },
  defaultArgs: function defaultArgs(columns) {
    return [columns[1] || columns[0], 0];
  }
}, {
  name: 'and',
  element: 'bool',
  classes: ['logical', 'list', 'infix', 'bool'],
  compute: function compute(args) {
    return args.reduce(function (a, b) {
      return a && b;
    }, true);
  },
  defaultArgs: function defaultArgs(columns) {
    return [{
      "type": ">",
      "args": ["Count", 100]
    }];
  }
}, {
  name: 'nand',
  element: 'bool',
  classes: ['logical', 'list', 'infix', 'bool'],
  compute: function compute(args) {
    return !args.reduce(function (a, b) {
      return a && b;
    }, true);
  },
  defaultArgs: function defaultArgs(columns) {
    return [{
      "type": "<",
      "args": ["Count", 100]
    }];
  }
}, {
  name: 'or',
  element: 'bool',
  classes: ['logical', 'list', 'infix', 'bool'],
  compute: function compute(args) {
    return args.reduce(function (a, b) {
      return a || b;
    }, false);
  },
  defaultArgs: function defaultArgs(columns) {
    return [];
  }
}];

var classes = ['logical', 'compare', 'arithmetic', 'unary', 'binary', 'list', 'infix', 'prefix'];

var operatorsByName = new _map2.default();

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = (0, _getIterator3.default)(operators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var definition = _step.value;

    definition.title = definition.name.slice(0, 1).toUpperCase() + definition.name.slice(1);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(classes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var clazz = _step2.value;
        definition['is' + clazz.slice(0, 1).toUpperCase() + clazz.slice(1)] = false;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(definition.classes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _clazz = _step3.value;
        definition['is' + _clazz.slice(0, 1).toUpperCase() + _clazz.slice(1)] = true;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    operatorsByName.set(definition.name, definition);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

function newArg(at, columns) {
  var definition = operatorsByName.get(at.type);
  if (definition.isList) {
    switch (definition.element) {
      case 'bool':
        return {
          type: ">",
          args: [columns[1] || columns[0], 0]
        };
    }
  }
  return {
    type: "and",
    args: []
  };
}

function prepareColumn(arg) {
  if ((0, _isNan2.default)(+arg)) return arg;
  return +arg;
}

function prepareConst(arg) {
  if ((0, _isNan2.default)(+arg)) return arg;
  return +arg * 100 | 0;
}

function prepareRegex(arg) {
  return new RegExp(arg, "ig");
}

function compileFilter(filter, columnIdByName) {
  var declaration = operatorsByName.get(filter.type);
  console.log("COMPILE FILTER", filter.type, declaration, operatorsByName);
  if (declaration.isBinary) {
    var fetchLeft = void 0;
    if (declaration.left == 'column') {
      var leftColumnId = columnIdByName.get(filter.args[0]);
      fetchLeft = function fetchLeft(row) {
        return prepareColumn(row[leftColumnId]);
      };
    }
    if (declaration.left == 'const') {
      fetchLeft = function fetchLeft(row) {
        return prepareConst(filter.args[0]);
      };
    }
    if (declaration.left == 'regex') {
      fetchLeft = function fetchLeft(row) {
        return prepareRegex(filter.args[0]);
      };
    }
    var fetchRight = void 0;
    if (declaration.right == 'column') {
      var rightColumnId = columnIdByName.get(filter.args[1]);
      fetchRight = function fetchRight(row) {
        return prepareColumn(row[rightColumnId]);
      };
    }
    if (declaration.right == 'const') {
      fetchRight = function fetchRight(row) {
        return prepareConst(filter.args[1]);
      };
    }
    if (declaration.right == 'regex') {
      fetchRight = function fetchRight(row) {
        return prepareRegex(filter.args[1]);
      };
    }
    return function (row) {
      var r = declaration.compute(fetchLeft(row), fetchRight(row));
      return r;
    };
  }
  if (declaration.isList) {
    var fetchArgs = filter.args.map(function (arg) {
      return compileFilter(arg, columnIdByName);
    });
    return function (row) {
      return declaration.compute(fetchArgs.map(function (fArg) {
        return fArg(row);
      }));
    };
  }
  if (declaration.isOpList) {
    var _fetchArgs = filter.args.map(function (arg) {
      return compileFilter(arg, columnIdByName);
    });
    return function (row) {
      return declaration.compute(_fetchArgs.map(function (fArg) {
        return fArg(row);
      }), filter.ops);
    };
  }
}

exports.default = {
  classes: classes,
  operators: operators,
  operatorsByName: operatorsByName,
  newArg: newArg,
  compileFilter: compileFilter
};

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayLayer = __webpack_require__(33);

var overlayModel = (0, _overlayLayer.createOverlayModel)();

exports.default = overlayModel;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(43);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _map = __webpack_require__(27);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxLogBuffer = 50;
var maxLogSaveDelay = 600;

var empty = function empty() {};
var oldConsole = {
  log: console.log || empty,
  info: console.info || empty,
  warn: console.warn || empty,
  debug: console.debug || empty,
  error: console.error || empty,
  trace: console.trace || empty,
  table: console.table || empty,
  dir: console.dir || empty,
  _exception: console._exception || empty,

  group: console.group || empty,
  groupCollapsed: console.groupCollapsed || empty,
  groupEnd: console.groupEnd || empty,

  assert: console.assert || empty,
  count: console.count || empty,

  time: console.time || empty,
  timeEnd: console.timeEnd || empty
};

var localConsole = {};
for (var k in oldConsole) {
  localConsole[k] = oldConsole[k].bind(console);
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var windowId = guid();

var savedLogs = [];
var groupStack = [];
var savingLogs = false;

var tags = [];

var lastLogSave = 0;

var logDestinations = [];

var passwords = new _map2.default();

function ajaxSave(logs, path) {
  return new _promise2.default(function (resolve, reject) {
    var xHttp = void 0;
    xHttp = new XMLHttpRequest();
    xHttp.addEventListener('load', function () {
      try {
        var response = JSON.parse(xHttp.responseText);
        if (response.error) return reject(response.error);
        resolve(response);
      } catch (e) {
        reject(e ? e.message || e : e);
      }
    });
    xHttp.addEventListener('error', function () {
      reject(xHttp.statusText);
    });
    xHttp.open("POST", path, true);
    xHttp.setRequestHeader("Content-type", "application/json");
    xHttp.send((0, _stringify2.default)({
      type: "save",
      windowId: windowId,
      sessionId: localStorage.sessionId,
      logs: logs,
      tags: tags
    }));
  });
}

function addTag() {
  for (var _len = arguments.length, ts = Array(_len), _key = 0; _key < _len; _key++) {
    ts[_key] = arguments[_key];
  }

  ts = ts.filter(function (t) {
    return tags.indexOf(t) == -1;
  });
  if (ts.length != 0) return;
  tags = tags.concat(ts);
  saveLog({ type: "tagAdd", tag: t });
  doSaveLogs();
}

function doSaveLogs() {
  var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (savingLogs) return;
  if (savedLogs.length == 0) return;
  savingLogs = true;
  lastLogSave = Date.now();
  var saveCount = savedLogs.length;

  var savePromises = logDestinations.map(function (dest) {
    return dest(savedLogs.slice());
  });
  _promise2.default.all(savePromises).then(function (saved) {
    savedLogs.splice(0, saveCount);
    savingLogs = false;
  }).catch(function (error) {
    localConsole.log("LOGS SAVE ERROR", error);
    savingLogs = false;
    setTimeout(function () {
      return doSaveLogs(retry + 1);
    }, Math.min(2000, 200 * Math.pow(2, retry)));
  });
}

function removePasswords(obj) {
  switch (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) {
    case 'object':
      for (var _k in obj) {
        obj[_k] = removePasswords(obj[_k]);
      }return obj;
    case 'string':
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(passwords.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var password = _step.value;

          obj = obj.replace(password, "***PASSWORD***");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return obj;
    default:
      return obj;
  }
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function addPassword(password) {
  passwords.set(password, new RegExp(escapeRegExp(password), "g"));
}

function removePassword(password) {
  passwords.delete(password);
}

function saveLog() {
  for (var _len2 = arguments.length, logs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    logs[_key2] = arguments[_key2];
  }

  logs.forEach(function (log) {
    log.timestamp = Date.now();
    log.group = groupStack;
    removePasswords(log);
  });
  savedLogs.push.apply(savedLogs, logs);
  if (!lastLogSave) lastLogSave = Date.now();
  if (savedLogs.length > maxLogBuffer || Date.now() - lastLogSave > maxLogSaveDelay) {
    doSaveLogs();
  }
  setTimeout(function () {
    if (savedLogs.length > 0 && Date.now() - lastLogSave > maxLogSaveDelay) {
      doSaveLogs();
    }
  }, maxLogSaveDelay + 22);
}

function normalizeObject(data) {
  try {
    var text = (0, _stringify2.default)(data);
    if (text.length > 255) return data.toString();
    return JSON.parse(text);
  } catch (e) {
    return data.toString();
  }
}

function prepareArg(arg) {
  if (typeof arg == 'string') return arg;
  if (typeof arg == 'number') return arg;
  if (arg instanceof Error) return {
    type: 'error',
    message: arg.message,
    stack: arg.stack
  };
  return normalizeObject(arg);
}

function getStackTrace() {
  try {
    throw new Error("trace");
  } catch (e) {
    return e.stack;
  }
}

function messageLogger(typeName, next, trace) {
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var log = {
      type: typeName,
      message: args.map(prepareArg)
    };
    if (trace) log.trace = getStackTrace();
    saveLog(log);

    if (next) next.apply(undefined, args);
  };
}

var counters = new _map2.default();

function install() {
  var messageFunctions = ['log', 'info', 'warn', 'debug', 'dir', 'table'];

  var _loop = function _loop(funcName) {
    console[funcName] = messageLogger(funcName, function () {
      var _oldConsole$funcName;

      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return (_oldConsole$funcName = oldConsole[funcName]).call.apply(_oldConsole$funcName, [console].concat(args));
    });
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(messageFunctions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var funcName = _step2.value;

      _loop(funcName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var traceFunctions = ['trace', 'error', '_exception'];

  var _loop2 = function _loop2(funcName) {
    console[funcName] = messageLogger(funcName, function () {
      var _oldConsole$funcName2;

      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return (_oldConsole$funcName2 = oldConsole[funcName]).call.apply(_oldConsole$funcName2, [console].concat(args));
    }, true);
  };

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(traceFunctions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var funcName = _step3.value;

      _loop2(funcName);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  console.group = function (groupName) {
    groupStack.push(groupName);
    oldConsole.group.call(console, groupName);
    saveLog({ type: "group", group: groupName, collapsed: false });
  };
  console.groupCollapsed = function (groupName) {
    groupStack.push(groupName);
    oldConsole.group.call(console, groupName);
    saveLog({ type: "group", group: groupName, collapsed: true });
  };
  console.groupEnd = function () {
    groupStack.pop();
    oldConsole.group.call(console);
    saveLog({ type: "groupEnd" });
  };

  console.count = function (label) {
    var counter = counters.get(label);
    counter++;
    saveLog({ type: "count", label: label, count: counter });
    counters.set(label, counter);
    oldConsole.count.call(console, label);
  };

  console.assert = function (expr) {
    var _oldConsole$assert;

    for (var _len4 = arguments.length, msg = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      msg[_key4 - 1] = arguments[_key4];
    }

    if (!expr) {
      saveLog({ type: "assertionFailed", message: msg.map(prepareArg) });
    }
    (_oldConsole$assert = oldConsole.assert).call.apply(_oldConsole$assert, [console, expr].concat(msg));
  };

  var timers = new _map2.default();

  console.time = function (label) {
    timers.set(label, Date.now());
    oldConsole.time.call(console, label);
  };

  console.timeEnd = function (label) {
    var timer = timers.get(label) || Date.now();
    timers.delete(label);
    saveLog({ type: "timer", label: label, time: Date.now() - timer });
    oldConsole.timeEnd.call(console, label);
  };

  localConsole.log("LOGGER INSTALLED");
}

var lagDetectors = new _map2.default();

function stopLagDetector(title, timeout) {
  if (!timeout) console.timeEnd(title);
  var detector = lagDetectors.get(title);
  if (!detector) return;
  clearTimeout(detector.timeout);
  if (Date.now() - detector.start > detector.maxDuration) {
    console.error("LAG DETECTED", title);
    addTag(title + '-lag');
  }
  lagDetectors.delete(title);
}

function startLagDetector(title, maxDuration) {
  console.time(title);
  if (lagDetectors.has(title)) stopLagDetector(title);
  var detector = {
    title: title,
    maxDuration: maxDuration,
    start: Date.now(),
    timeout: setTimeout(function () {
      return stopLagDetector(title, true);
    }, maxDuration + 23)
  };
  lagDetectors.set(title, detector);
}

function addAjaxLogDestination(path) {
  logDestinations.push(function (logs) {
    return ajaxSave(logs, path);
  });
}
function addWorkerParentLogDestination() {
  logDestinations.push(function (logs) {
    postMessage({
      type: "logs",
      logs: logs
    });
  });
}

var logger = {
  localConsole: localConsole,
  addTag: addTag,
  install: install,
  startLagDetector: startLagDetector,
  stopLagDetector: stopLagDetector,
  tags: tags,
  saveLog: saveLog,
  addAjaxLogDestination: addAjaxLogDestination,
  addWorkerParentLogDestination: addWorkerParentLogDestination,
  addPassword: addPassword,
  removePassword: removePassword
};

if (typeof window != "undefined") {
  window.logger = logger;
}

exports.default = logger;

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayActivator = exports.windowDimmensions = exports.OverlayAnchor = exports.createOverlayModel = exports.OverlayComponent = undefined;

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createElement = void 0;

var getElementPosition = function getElementPosition(element) {
  var o = element;
  var x = 0;
  var y = 0;
  while (true) {
    x += o.offsetLeft;
    y += o.offsetTop;
    o = o.offsetParent;
    if (!o) return {
      x: x,
      y: y
    };
    if (o.scrollLeft) x -= o.scrollLeft;
    if (o.scrollTop) y -= o.scrollTop;
  }
};

function createOverlayModel() {
  return new _vue2.default({
    data: {
      overlayStack: [],
      overlayCloseListeners: [],
      createElement: null
    },
    methods: {
      show: function show(_ref) {
        var _this = this;

        var component = _ref.component,
            props = _ref.props,
            on = _ref.on,
            slots = _ref.slots,
            parentId = _ref.parentId;

        parentId = parentId || 0;
        props = props || {};
        on = on || {};
        slots = slots || [];
        this.overlayStack.splice(parentId, Infinity);
        var stackId = this.overlayStack.length + 1;
        props = {
          props: (0, _extends3.default)({}, props, {
            stackId: stackId,
            parentId: parentId
          }),
          attrs: {
            'data-overlay-stack': stackId
          },
          on: (0, _extends3.default)({}, on, {
            close: function close() {
              return _this.close(stackId);
            },
            closeAll: function closeAll() {
              return _this.closeAll();
            },
            overlay: function overlay(definition) {
              return _this.show((0, _extends3.default)({}, definition, { parentId: stackId }));
            }
          }),
          slots: slots
        };
        if (on.close) this.overlayCloseListeners[stackId] = on.close;
        this.overlayStack.push(this.createElement(component, props, slots));
        return stackId;
      },
      close: function close(stackId) {
        if (this.overlayCloseListeners[stackId]) this.overlayCloseListeners[stackId]();
        delete this.overlayCloseListeners[stackId];
        this.overlayStack.splice(stackId - 1, Infinity);
      },
      closeAll: function closeAll() {
        for (var k in this.overlayCloseListeners) {
          this.overlayCloseListeners[k]();
        }
        this.overlayCloseListeners = [];
        this.overlayStack.splice(0, Infinity);
      },
      elementAnchor: function elementAnchor(element) {
        var position = getElementPosition(element);
        return (0, _extends3.default)({}, position, { w: element.clientWidth, h: element.clientHeight });
      }
    }
  });
}

var OverlayComponent = {
  name: 'OverlayLayer',
  props: {
    overlayModel: {
      required: true,
      type: Object
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.focusLostListener = function (ev) {
      var stackId = void 0;
      var tg = ev.target;
      while (tg) {
        stackId = +tg.getAttribute('data-overlay-stack');
        if (stackId) break;
        tg = tg.parentElement;
      }
      if (stackId) {
        _this2.overlayModel.close(stackId + 1);
      } else {
        _this2.overlayModel.closeAll();
      }
    };
    document.body.addEventListener("touch", this.focusLostListener, true);
    document.body.addEventListener("click", this.focusLostListener, true);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener("touch", this.focusLostListener);
    document.body.removeEventListener("click", this.focusLostListener);
  },
  render: function render(createElement) {
    this.overlayModel.createElement = createElement;
    return createElement("div", { class: "overlayLayer" }, this.overlayModel.overlayStack);
  }
};

var allDirections = [{ x: 1, y: 1 }, { x: 1, y: 0 }, { x: 1, y: -1 }, { x: 0, y: 1 }, { x: 0, y: -1 }, { x: -1, y: 1 }, { x: -1, y: 0 }, { x: -1, y: -1 }];

var windowDimmensions = new _vue2.default({
  data: {
    width: window.innerWidth,
    height: window.innerHeight
  }
});
window.addEventListener('resize', function () {
  windowDimmensions.width = window.innerWidth;
  windowDimmensions.height = window.innerHeight;
});

function computeDimmensions(anchor, size, direction) {
  var aw = anchor.w || 0;
  var ah = anchor.h || 0;
  var ax = anchor.x || 0;
  var ay = anchor.y || 0;

  var dx = direction.x || 0;
  var dy = direction.y || 0;
  var dax = direction.ax || 0;
  var day = direction.ay || 0;

  var acx = ax + aw / 2;
  var acy = ay + ah / 2;
  var hx = acx + aw / 2 * dax;
  var hy = acy + ah / 2 * day;

  var mw = size.x || 0;
  var mh = size.y || 0;
  var mcx = -mw / 2;
  var mcy = -mh / 2;

  var xp = hx + mcx + mw / 2 * dx;
  var yp = hy + mcy + mh / 2 * dy;

  return {
    x: xp,
    y: yp,
    x2: xp + mw,
    y2: yp + mh
  };
}

var OverlayAnchor = {
  name: 'OverlayAnchor',
  props: {
    anchor: {
      required: true,
      type: Object
    },
    directions: {
      default: function _default() {
        return allDirections;
      },
      type: Array
    }
  },
  data: function data() {
    return {
      width: 0,
      height: 0
    };
  },

  computed: {
    possibleDirections: function possibleDirections() {
      var _this3 = this;

      var size = { x: this.width, y: this.height };
      return this.directions.map(function (direction) {
        return {
          direction: direction,
          position: computeDimmensions(_this3.anchor, size, direction)
        };
      }).filter(function (dir) {
        if (dir.position.x < 0) return false;
        if (dir.position.x2 > windowDimmensions.width) return false;
        if (dir.position.y < 0) return false;
        if (dir.position.y2 > windowDimmensions.height) return false;
        return true;
      });
    },
    style: function style() {
      var directions = this.possibleDirections;
      if (directions.length == 0) return { display: "none" };
      this.$emit("positioned", directions[0].position);
      return {
        left: directions[0].position.x + 'px',
        top: directions[0].position.y + 'px'
      };
    }
  },
  methods: {
    updateSize: function updateSize() {
      var _this4 = this;

      if (this.finished) return;
      var element = this.$refs.anchor;
      if (!element) return;
      var width = element.clientWidth;
      var height = element.clientHeight;
      if (width != this.width) this.width = width;
      if (height != this.height) this.height = height;
      setTimeout(function () {
        return _this4.updateSize();
      }, 100);
    }
  },
  mounted: function mounted() {
    this.updateSize();
  },
  beforeDestroy: function beforeDestroy() {
    this.finished = true;
  },
  render: function render(createElement) {
    return createElement("div", {
      'class': 'overlayAnchor',
      style: this.style,
      ref: 'anchor'
    }, this.$slots.default);
  }
};

var OverlayActivator = {
  name: "OverlayActivator",
  props: ["model", "directions"],
  render: function render(createElement) {
    var _this5 = this;

    return createElement("div", {
      ref: "button",
      on: {
        click: function click() {
          console.error("OVERLAY SLOT", _this5.$slots.overlay);
          _this5.model.show({
            component: OverlayAnchor,
            props: {
              anchor: _this5.model.elementAnchor(_this5.$refs.button),
              directions: _this5.directions
            },
            on: {
              positioned: function positioned(position) {
                return _this5.$emit('positioned', position);
              }
            },
            slots: _this5.$slots.overlay
          });
        }
      }
    }, this.$slots.button);
  }
};

exports.OverlayComponent = OverlayComponent;
exports.createOverlayModel = createOverlayModel;
exports.OverlayAnchor = OverlayAnchor;
exports.windowDimmensions = windowDimmensions;
exports.OverlayActivator = OverlayActivator;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  "name": "Afghanistan",
  "dial_code": "+93",
  "code": "AF"
}, {
  "name": "Aland Islands",
  "dial_code": "+358",
  "code": "AX"
}, {
  "name": "Albania",
  "dial_code": "+355",
  "code": "AL"
}, {
  "name": "Algeria",
  "dial_code": "+213",
  "code": "DZ"
}, {
  "name": "AmericanSamoa",
  "dial_code": "+1684",
  "code": "AS"
}, {
  "name": "Andorra",
  "dial_code": "+376",
  "code": "AD"
}, {
  "name": "Angola",
  "dial_code": "+244",
  "code": "AO"
}, {
  "name": "Anguilla",
  "dial_code": "+1264",
  "code": "AI"
}, {
  "name": "Antarctica",
  "dial_code": "+672",
  "code": "AQ"
}, {
  "name": "Antigua and Barbuda",
  "dial_code": "+1268",
  "code": "AG"
}, {
  "name": "Argentina",
  "dial_code": "+54",
  "code": "AR"
}, {
  "name": "Armenia",
  "dial_code": "+374",
  "code": "AM"
}, {
  "name": "Aruba",
  "dial_code": "+297",
  "code": "AW"
}, {
  "name": "Australia",
  "dial_code": "+61",
  "code": "AU"
}, {
  "name": "Austria",
  "dial_code": "+43",
  "code": "AT"
}, {
  "name": "Azerbaijan",
  "dial_code": "+994",
  "code": "AZ"
}, {
  "name": "Bahamas",
  "dial_code": "+1242",
  "code": "BS"
}, {
  "name": "Bahrain",
  "dial_code": "+973",
  "code": "BH"
}, {
  "name": "Bangladesh",
  "dial_code": "+880",
  "code": "BD"
}, {
  "name": "Barbados",
  "dial_code": "+1246",
  "code": "BB"
}, {
  "name": "Belarus",
  "dial_code": "+375",
  "code": "BY"
}, {
  "name": "Belgium",
  "dial_code": "+32",
  "code": "BE"
}, {
  "name": "Belize",
  "dial_code": "+501",
  "code": "BZ"
}, {
  "name": "Benin",
  "dial_code": "+229",
  "code": "BJ"
}, {
  "name": "Bermuda",
  "dial_code": "+1441",
  "code": "BM"
}, {
  "name": "Bhutan",
  "dial_code": "+975",
  "code": "BT"
}, {
  "name": "Bolivia, Plurinational State of bolivia",
  "dial_code": "+591",
  "code": "BO"
}, {
  "name": "Bosnia and Herzegovina",
  "dial_code": "+387",
  "code": "BA"
}, {
  "name": "Botswana",
  "dial_code": "+267",
  "code": "BW"
}, {
  "name": "Brazil",
  "dial_code": "+55",
  "code": "BR"
}, {
  "name": "British Indian Ocean Territory",
  "dial_code": "+246",
  "code": "IO"
}, {
  "name": "Brunei Darussalam",
  "dial_code": "+673",
  "code": "BN"
}, {
  "name": "Bulgaria",
  "dial_code": "+359",
  "code": "BG"
}, {
  "name": "Burkina Faso",
  "dial_code": "+226",
  "code": "BF"
}, {
  "name": "Burundi",
  "dial_code": "+257",
  "code": "BI"
}, {
  "name": "Cambodia",
  "dial_code": "+855",
  "code": "KH"
}, {
  "name": "Cameroon",
  "dial_code": "+237",
  "code": "CM"
}, {
  "name": "Canada",
  "dial_code": "+1",
  "code": "CA"
}, {
  "name": "Cape Verde",
  "dial_code": "+238",
  "code": "CV"
}, {
  "name": "Cayman Islands",
  "dial_code": "+ 345",
  "code": "KY"
}, {
  "name": "Central African Republic",
  "dial_code": "+236",
  "code": "CF"
}, {
  "name": "Chad",
  "dial_code": "+235",
  "code": "TD"
}, {
  "name": "Chile",
  "dial_code": "+56",
  "code": "CL"
}, {
  "name": "China",
  "dial_code": "+86",
  "code": "CN"
}, {
  "name": "Christmas Island",
  "dial_code": "+61",
  "code": "CX"
}, {
  "name": "Cocos (Keeling) Islands",
  "dial_code": "+61",
  "code": "CC"
}, {
  "name": "Colombia",
  "dial_code": "+57",
  "code": "CO"
}, {
  "name": "Comoros",
  "dial_code": "+269",
  "code": "KM"
}, {
  "name": "Congo",
  "dial_code": "+242",
  "code": "CG"
}, {
  "name": "Congo, The Democratic Republic of the Congo",
  "dial_code": "+243",
  "code": "CD"
}, {
  "name": "Cook Islands",
  "dial_code": "+682",
  "code": "CK"
}, {
  "name": "Costa Rica",
  "dial_code": "+506",
  "code": "CR"
}, {
  "name": "Cote d'Ivoire",
  "dial_code": "+225",
  "code": "CI"
}, {
  "name": "Croatia",
  "dial_code": "+385",
  "code": "HR"
}, {
  "name": "Cuba",
  "dial_code": "+53",
  "code": "CU"
}, {
  "name": "Cyprus",
  "dial_code": "+357",
  "code": "CY"
}, {
  "name": "Czech Republic",
  "dial_code": "+420",
  "code": "CZ"
}, {
  "name": "Denmark",
  "dial_code": "+45",
  "code": "DK"
}, {
  "name": "Djibouti",
  "dial_code": "+253",
  "code": "DJ"
}, {
  "name": "Dominica",
  "dial_code": "+1767",
  "code": "DM"
}, {
  "name": "Dominican Republic",
  "dial_code": "+1849",
  "code": "DO"
}, {
  "name": "Ecuador",
  "dial_code": "+593",
  "code": "EC"
}, {
  "name": "Egypt",
  "dial_code": "+20",
  "code": "EG"
}, {
  "name": "El Salvador",
  "dial_code": "+503",
  "code": "SV"
}, {
  "name": "Equatorial Guinea",
  "dial_code": "+240",
  "code": "GQ"
}, {
  "name": "Eritrea",
  "dial_code": "+291",
  "code": "ER"
}, {
  "name": "Estonia",
  "dial_code": "+372",
  "code": "EE"
}, {
  "name": "Ethiopia",
  "dial_code": "+251",
  "code": "ET"
}, {
  "name": "Falkland Islands (Malvinas)",
  "dial_code": "+500",
  "code": "FK"
}, {
  "name": "Faroe Islands",
  "dial_code": "+298",
  "code": "FO"
}, {
  "name": "Fiji",
  "dial_code": "+679",
  "code": "FJ"
}, {
  "name": "Finland",
  "dial_code": "+358",
  "code": "FI"
}, {
  "name": "France",
  "dial_code": "+33",
  "code": "FR"
}, {
  "name": "French Guiana",
  "dial_code": "+594",
  "code": "GF"
}, {
  "name": "French Polynesia",
  "dial_code": "+689",
  "code": "PF"
}, {
  "name": "Gabon",
  "dial_code": "+241",
  "code": "GA"
}, {
  "name": "Gambia",
  "dial_code": "+220",
  "code": "GM"
}, {
  "name": "Georgia",
  "dial_code": "+995",
  "code": "GE"
}, {
  "name": "Germany",
  "dial_code": "+49",
  "code": "DE"
}, {
  "name": "Ghana",
  "dial_code": "+233",
  "code": "GH"
}, {
  "name": "Gibraltar",
  "dial_code": "+350",
  "code": "GI"
}, {
  "name": "Greece",
  "dial_code": "+30",
  "code": "GR"
}, {
  "name": "Greenland",
  "dial_code": "+299",
  "code": "GL"
}, {
  "name": "Grenada",
  "dial_code": "+1473",
  "code": "GD"
}, {
  "name": "Guadeloupe",
  "dial_code": "+590",
  "code": "GP"
}, {
  "name": "Guam",
  "dial_code": "+1671",
  "code": "GU"
}, {
  "name": "Guatemala",
  "dial_code": "+502",
  "code": "GT"
}, {
  "name": "Guernsey",
  "dial_code": "+44",
  "code": "GG"
}, {
  "name": "Guinea",
  "dial_code": "+224",
  "code": "GN"
}, {
  "name": "Guinea-Bissau",
  "dial_code": "+245",
  "code": "GW"
}, {
  "name": "Guyana",
  "dial_code": "+592",
  "code": "GY"
}, {
  "name": "Haiti",
  "dial_code": "+509",
  "code": "HT"
}, {
  "name": "Holy See (Vatican City State)",
  "dial_code": "+379",
  "code": "VA"
}, {
  "name": "Honduras",
  "dial_code": "+504",
  "code": "HN"
}, {
  "name": "Hong Kong",
  "dial_code": "+852",
  "code": "HK"
}, {
  "name": "Hungary",
  "dial_code": "+36",
  "code": "HU"
}, {
  "name": "Iceland",
  "dial_code": "+354",
  "code": "IS"
}, {
  "name": "India",
  "dial_code": "+91",
  "code": "IN"
}, {
  "name": "Indonesia",
  "dial_code": "+62",
  "code": "ID"
}, {
  "name": "Iran, Islamic Republic of Persian Gulf",
  "dial_code": "+98",
  "code": "IR"
}, {
  "name": "Iraq",
  "dial_code": "+964",
  "code": "IQ"
}, {
  "name": "Ireland",
  "dial_code": "+353",
  "code": "IE"
}, {
  "name": "Isle of Man",
  "dial_code": "+44",
  "code": "IM"
}, {
  "name": "Israel",
  "dial_code": "+972",
  "code": "IL"
}, {
  "name": "Italy",
  "dial_code": "+39",
  "code": "IT"
}, {
  "name": "Jamaica",
  "dial_code": "+1876",
  "code": "JM"
}, {
  "name": "Japan",
  "dial_code": "+81",
  "code": "JP"
}, {
  "name": "Jersey",
  "dial_code": "+44",
  "code": "JE"
}, {
  "name": "Jordan",
  "dial_code": "+962",
  "code": "JO"
}, {
  "name": "Kazakhstan",
  "dial_code": "+7",
  "code": "KZ"
}, {
  "name": "Kenya",
  "dial_code": "+254",
  "code": "KE"
}, {
  "name": "Kiribati",
  "dial_code": "+686",
  "code": "KI"
}, {
  "name": "Korea, Democratic People's Republic of Korea",
  "dial_code": "+850",
  "code": "KP"
}, {
  "name": "Korea, Republic of South Korea",
  "dial_code": "+82",
  "code": "KR"
}, {
  "name": "Kuwait",
  "dial_code": "+965",
  "code": "KW"
}, {
  "name": "Kyrgyzstan",
  "dial_code": "+996",
  "code": "KG"
}, {
  "name": "Laos",
  "dial_code": "+856",
  "code": "LA"
}, {
  "name": "Latvia",
  "dial_code": "+371",
  "code": "LV"
}, {
  "name": "Lebanon",
  "dial_code": "+961",
  "code": "LB"
}, {
  "name": "Lesotho",
  "dial_code": "+266",
  "code": "LS"
}, {
  "name": "Liberia",
  "dial_code": "+231",
  "code": "LR"
}, {
  "name": "Libyan Arab Jamahiriya",
  "dial_code": "+218",
  "code": "LY"
}, {
  "name": "Liechtenstein",
  "dial_code": "+423",
  "code": "LI"
}, {
  "name": "Lithuania",
  "dial_code": "+370",
  "code": "LT"
}, {
  "name": "Luxembourg",
  "dial_code": "+352",
  "code": "LU"
}, {
  "name": "Macao",
  "dial_code": "+853",
  "code": "MO"
}, {
  "name": "Macedonia",
  "dial_code": "+389",
  "code": "MK"
}, {
  "name": "Madagascar",
  "dial_code": "+261",
  "code": "MG"
}, {
  "name": "Malawi",
  "dial_code": "+265",
  "code": "MW"
}, {
  "name": "Malaysia",
  "dial_code": "+60",
  "code": "MY"
}, {
  "name": "Maldives",
  "dial_code": "+960",
  "code": "MV"
}, {
  "name": "Mali",
  "dial_code": "+223",
  "code": "ML"
}, {
  "name": "Malta",
  "dial_code": "+356",
  "code": "MT"
}, {
  "name": "Marshall Islands",
  "dial_code": "+692",
  "code": "MH"
}, {
  "name": "Martinique",
  "dial_code": "+596",
  "code": "MQ"
}, {
  "name": "Mauritania",
  "dial_code": "+222",
  "code": "MR"
}, {
  "name": "Mauritius",
  "dial_code": "+230",
  "code": "MU"
}, {
  "name": "Mayotte",
  "dial_code": "+262",
  "code": "YT"
}, {
  "name": "Mexico",
  "dial_code": "+52",
  "code": "MX"
}, {
  "name": "Micronesia, Federated States of Micronesia",
  "dial_code": "+691",
  "code": "FM"
}, {
  "name": "Moldova",
  "dial_code": "+373",
  "code": "MD"
}, {
  "name": "Monaco",
  "dial_code": "+377",
  "code": "MC"
}, {
  "name": "Mongolia",
  "dial_code": "+976",
  "code": "MN"
}, {
  "name": "Montenegro",
  "dial_code": "+382",
  "code": "ME"
}, {
  "name": "Montserrat",
  "dial_code": "+1664",
  "code": "MS"
}, {
  "name": "Morocco",
  "dial_code": "+212",
  "code": "MA"
}, {
  "name": "Mozambique",
  "dial_code": "+258",
  "code": "MZ"
}, {
  "name": "Myanmar",
  "dial_code": "+95",
  "code": "MM"
}, {
  "name": "Namibia",
  "dial_code": "+264",
  "code": "NA"
}, {
  "name": "Nauru",
  "dial_code": "+674",
  "code": "NR"
}, {
  "name": "Nepal",
  "dial_code": "+977",
  "code": "NP"
}, {
  "name": "Netherlands",
  "dial_code": "+31",
  "code": "NL"
}, {
  "name": "Netherlands Antilles",
  "dial_code": "+599",
  "code": "AN"
}, {
  "name": "New Caledonia",
  "dial_code": "+687",
  "code": "NC"
}, {
  "name": "New Zealand",
  "dial_code": "+64",
  "code": "NZ"
}, {
  "name": "Nicaragua",
  "dial_code": "+505",
  "code": "NI"
}, {
  "name": "Niger",
  "dial_code": "+227",
  "code": "NE"
}, {
  "name": "Nigeria",
  "dial_code": "+234",
  "code": "NG"
}, {
  "name": "Niue",
  "dial_code": "+683",
  "code": "NU"
}, {
  "name": "Norfolk Island",
  "dial_code": "+672",
  "code": "NF"
}, {
  "name": "Northern Mariana Islands",
  "dial_code": "+1670",
  "code": "MP"
}, {
  "name": "Norway",
  "dial_code": "+47",
  "code": "NO"
}, {
  "name": "Oman",
  "dial_code": "+968",
  "code": "OM"
}, {
  "name": "Pakistan",
  "dial_code": "+92",
  "code": "PK"
}, {
  "name": "Palau",
  "dial_code": "+680",
  "code": "PW"
}, {
  "name": "Palestinian Territory, Occupied",
  "dial_code": "+970",
  "code": "PS"
}, {
  "name": "Panama",
  "dial_code": "+507",
  "code": "PA"
}, {
  "name": "Papua New Guinea",
  "dial_code": "+675",
  "code": "PG"
}, {
  "name": "Paraguay",
  "dial_code": "+595",
  "code": "PY"
}, {
  "name": "Peru",
  "dial_code": "+51",
  "code": "PE"
}, {
  "name": "Philippines",
  "dial_code": "+63",
  "code": "PH"
}, {
  "name": "Pitcairn",
  "dial_code": "+64",
  "code": "PN"
}, {
  "name": "Poland",
  "dial_code": "+48",
  "code": "PL"
}, {
  "name": "Portugal",
  "dial_code": "+351",
  "code": "PT"
}, {
  "name": "Puerto Rico",
  "dial_code": "+1939",
  "code": "PR"
}, {
  "name": "Qatar",
  "dial_code": "+974",
  "code": "QA"
}, {
  "name": "Romania",
  "dial_code": "+40",
  "code": "RO"
}, {
  "name": "Russia",
  "dial_code": "+7",
  "code": "RU"
}, {
  "name": "Rwanda",
  "dial_code": "+250",
  "code": "RW"
}, {
  "name": "Reunion",
  "dial_code": "+262",
  "code": "RE"
}, {
  "name": "Saint Barthelemy",
  "dial_code": "+590",
  "code": "BL"
}, {
  "name": "Saint Helena, Ascension and Tristan Da Cunha",
  "dial_code": "+290",
  "code": "SH"
}, {
  "name": "Saint Kitts and Nevis",
  "dial_code": "+1869",
  "code": "KN"
}, {
  "name": "Saint Lucia",
  "dial_code": "+1758",
  "code": "LC"
}, {
  "name": "Saint Martin",
  "dial_code": "+590",
  "code": "MF"
}, {
  "name": "Saint Pierre and Miquelon",
  "dial_code": "+508",
  "code": "PM"
}, {
  "name": "Saint Vincent and the Grenadines",
  "dial_code": "+1784",
  "code": "VC"
}, {
  "name": "Samoa",
  "dial_code": "+685",
  "code": "WS"
}, {
  "name": "San Marino",
  "dial_code": "+378",
  "code": "SM"
}, {
  "name": "Sao Tome and Principe",
  "dial_code": "+239",
  "code": "ST"
}, {
  "name": "Saudi Arabia",
  "dial_code": "+966",
  "code": "SA"
}, {
  "name": "Senegal",
  "dial_code": "+221",
  "code": "SN"
}, {
  "name": "Serbia",
  "dial_code": "+381",
  "code": "RS"
}, {
  "name": "Seychelles",
  "dial_code": "+248",
  "code": "SC"
}, {
  "name": "Sierra Leone",
  "dial_code": "+232",
  "code": "SL"
}, {
  "name": "Singapore",
  "dial_code": "+65",
  "code": "SG"
}, {
  "name": "Slovakia",
  "dial_code": "+421",
  "code": "SK"
}, {
  "name": "Slovenia",
  "dial_code": "+386",
  "code": "SI"
}, {
  "name": "Solomon Islands",
  "dial_code": "+677",
  "code": "SB"
}, {
  "name": "Somalia",
  "dial_code": "+252",
  "code": "SO"
}, {
  "name": "South Africa",
  "dial_code": "+27",
  "code": "ZA"
}, {
  "name": "South Sudan",
  "dial_code": "+211",
  "code": "SS"
}, {
  "name": "South Georgia and the South Sandwich Islands",
  "dial_code": "+500",
  "code": "GS"
}, {
  "name": "Spain",
  "dial_code": "+34",
  "code": "ES"
}, {
  "name": "Sri Lanka",
  "dial_code": "+94",
  "code": "LK"
}, {
  "name": "Sudan",
  "dial_code": "+249",
  "code": "SD"
}, {
  "name": "Suriname",
  "dial_code": "+597",
  "code": "SR"
}, {
  "name": "Svalbard and Jan Mayen",
  "dial_code": "+47",
  "code": "SJ"
}, {
  "name": "Swaziland",
  "dial_code": "+268",
  "code": "SZ"
}, {
  "name": "Sweden",
  "dial_code": "+46",
  "code": "SE"
}, {
  "name": "Switzerland",
  "dial_code": "+41",
  "code": "CH"
}, {
  "name": "Syrian Arab Republic",
  "dial_code": "+963",
  "code": "SY"
}, {
  "name": "Taiwan",
  "dial_code": "+886",
  "code": "TW"
}, {
  "name": "Tajikistan",
  "dial_code": "+992",
  "code": "TJ"
}, {
  "name": "Tanzania, United Republic of Tanzania",
  "dial_code": "+255",
  "code": "TZ"
}, {
  "name": "Thailand",
  "dial_code": "+66",
  "code": "TH"
}, {
  "name": "Timor-Leste",
  "dial_code": "+670",
  "code": "TL"
}, {
  "name": "Togo",
  "dial_code": "+228",
  "code": "TG"
}, {
  "name": "Tokelau",
  "dial_code": "+690",
  "code": "TK"
}, {
  "name": "Tonga",
  "dial_code": "+676",
  "code": "TO"
}, {
  "name": "Trinidad and Tobago",
  "dial_code": "+1868",
  "code": "TT"
}, {
  "name": "Tunisia",
  "dial_code": "+216",
  "code": "TN"
}, {
  "name": "Turkey",
  "dial_code": "+90",
  "code": "TR"
}, {
  "name": "Turkmenistan",
  "dial_code": "+993",
  "code": "TM"
}, {
  "name": "Turks and Caicos Islands",
  "dial_code": "+1649",
  "code": "TC"
}, {
  "name": "Tuvalu",
  "dial_code": "+688",
  "code": "TV"
}, {
  "name": "Uganda",
  "dial_code": "+256",
  "code": "UG"
}, {
  "name": "Ukraine",
  "dial_code": "+380",
  "code": "UA"
}, {
  "name": "United Arab Emirates",
  "dial_code": "+971",
  "code": "AE"
}, {
  "name": "United Kingdom",
  "dial_code": "+44",
  "code": "GB"
}, {
  "name": "United States",
  "dial_code": "+1",
  "code": "US"
}, {
  "name": "Uruguay",
  "dial_code": "+598",
  "code": "UY"
}, {
  "name": "Uzbekistan",
  "dial_code": "+998",
  "code": "UZ"
}, {
  "name": "Vanuatu",
  "dial_code": "+678",
  "code": "VU"
}, {
  "name": "Venezuela, Bolivarian Republic of Venezuela",
  "dial_code": "+58",
  "code": "VE"
}, {
  "name": "Vietnam",
  "dial_code": "+84",
  "code": "VN"
}, {
  "name": "Virgin Islands, British",
  "dial_code": "+1284",
  "code": "VG"
}, {
  "name": "Virgin Islands, U.S.",
  "dial_code": "+1340",
  "code": "VI"
}, {
  "name": "Wallis and Futuna",
  "dial_code": "+681",
  "code": "WF"
}, {
  "name": "Yemen",
  "dial_code": "+967",
  "code": "YE"
}, {
  "name": "Zambia",
  "dial_code": "+260",
  "code": "ZM"
}, {
  "name": "Zimbabwe",
  "dial_code": "+263",
  "code": "ZW"
}];

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function csvToArray(strData, strDelimiter) {
  strDelimiter = strDelimiter || ",";

  var objPattern = new RegExp("(\\" + strDelimiter + "|\\r?\\n|\\r|^)" + "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" + "([^\"\\" + strDelimiter + "\\r\\n]*))", "gi");

  var arrData = [[]];

  var arrMatches = null;

  while (arrMatches = objPattern.exec(strData)) {
    var strMatchedDelimiter = arrMatches[1];

    if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
      arrData.push([]);
    }

    var strMatchedValue;

    if (arrMatches[2]) {
      strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
    } else {
      strMatchedValue = arrMatches[3];
    }

    arrData[arrData.length - 1].push(strMatchedValue);
  }

  return arrData;
}

function parseCSV(csv) {
  var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';

  var csvArray = csvToArray(csv, delim);
  if (csvArray[1].filter(function (x) {
    return x.length;
  }).length < 2) {
    return {
      title: csvArray[0][0],
      columnNames: csvArray[2],
      rows: csvArray.slice(3, -1)
    };
  }
  return {
    title: csvArray[0][0],
    columnNames: csvArray[1],
    rows: csvArray.slice(2, -1)
  };
}

function generateCSV(table) {
  var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var cellMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };

  function generateCell(cell) {
    var cellText = "" + cell;
    if (cellText.indexOf("'") != -1 || cellText.indexOf('"') != -1 || cellText.indexOf(',') != -1 || cellText.indexOf(delim) != -1) {
      return '"' + cellText.replace(/"/g, '""') + '"';
    }
    return cellText;
  }

  return table.title + "\n" + table.columnNames.map(generateCell).join(delim) + "\n" + table.rows.map(function (row) {
    return row.map(function (c) {
      return generateCell(cellMapper(c));
    }).join(delim);
  }).join('\n') + "\n";
}
exports.csvToArray = csvToArray;
exports.parseCSV = parseCSV;
exports.generateCSV = generateCSV;
exports.default = {
  csvToArray: csvToArray, parseCSV: parseCSV, generateCSV: generateCSV
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function saveBlob(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}

exports.saveBlob = saveBlob;
exports.default = { saveBlob: saveBlob };

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(27);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function columnIdsByName(table) {
  var columnNames = table.columnNames;
  var columnsCount = columnNames.length;
  var ids = new _map2.default();
  for (var columnId = 0; columnId < columnsCount; columnId++) {
    var columnName = columnNames[columnId];
    ids.set(columnName, columnId);
  }
  return ids;
}

function eachRow(table, columnNames, cb) {
  var idsByName = columnIdsByName(table);
  var ids = columnNames.map(function (column) {
    if (column instanceof Array) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(column), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cn = _step.value;
          if (idsByName.has(cn)) return idsByName.get(cn);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      return idsByName.get(column);
    }
  });

  var _loop = function _loop(row) {
    var vals = ids.map(function (id) {
      return row[id];
    });
    cb.apply(undefined, (0, _toConsumableArray3.default)(vals));
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(table.rows), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var row = _step2.value;

      _loop(row);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function anyRow(table, columnNames, cb) {
  var found = false;
  eachRow(table, columnNames, function () {
    return found = found || cb.apply(undefined, arguments);
  });
  return found;
}

function allRows(table, columnNames, cb) {
  var found = true;
  eachRow(table, columnNames, function () {
    return found = found && cb.apply(undefined, arguments);
  });
  return found;
}

function sum(table, column) {
  var sum = 0;
  var columnId = void 0;
  if (column instanceof Array) {
    for (var i = 0; i < table.columnNames.length; i++) {
      if (column.indexOf(table.columnNames[i]) != -1) columnId = i;
    }
  } else {
    for (var _i = 0; _i < table.columnNames.length; _i++) {
      if (table.columnNames[_i] == column) columnId = _i;
    }
  }
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(table.rows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var row = _step3.value;

      sum += +row[columnId];
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return sum;
}

function average(table, column) {
  return sum(table, column) / table.rows.length;
}

function hasColumn(table, column) {
  if (column instanceof Array) {
    for (var i = 0; i < table.columnNames.length; i++) {
      if (column.indexOf(table.columnNames[i]) != -1) return true;
    }
  } else {
    for (var _i2 = 0; _i2 < table.columnNames.length; _i2++) {
      if (table.columnNames[_i2] == column) return true;
    }
  }
  return false;
}

function getColumnName(table, column) {
  if (column instanceof Array) {
    for (var i = 0; i < table.columnNames.length; i++) {
      if (column.indexOf(table.columnNames[i]) != -1) return table.columnNames[i];
    }
  } else {
    for (var _i3 = 0; _i3 < table.columnNames.length; _i3++) {
      if (table.columnNames[_i3] == column) return column;
    }
  }
  return false;
}

exports.default = {
  columnIdsByName: columnIdsByName,
  anyRow: anyRow,
  allRows: allRows,
  sum: sum,
  average: average,
  hasColumn: hasColumn,
  getColumnName: getColumnName
};

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-5f53a76e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  "data-v-37cbef2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropZoneState = exports.GlobalDropZone = undefined;

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropZoneState = new _vue2.default({
  data: {
    visible: false,
    dropReceiver: null
  },
  watch: {
    visible: function visible(v) {
      console.log("DROP ZONE VISIBLE", v);
    }
  }
});

var GlobalDropZone = {
  name: "GlobalDropZone",
  data: function data() {
    return {};
  },

  computed: {
    visible: function visible() {
      return dropZoneState.visible;
    }
  },
  methods: {
    dragLeave: function dragLeave() {
      dropZoneState.visible = false;
    },
    allowDrop: function allowDrop(e) {
      e.dataTransfer.dropEffect = 'copy';
      e.preventDefault();
    },
    handleDrop: function handleDrop(ev) {
      ev.preventDefault();
      dropZoneState.visible = false;
      console.log("DROPPED", ev);
      var files = [];
      if (ev.dataTransfer.items) {
        for (var _i = 0; _i < ev.dataTransfer.items.length; _i++) {
          if (ev.dataTransfer.items[_i].kind === 'file') {
            var file = ev.dataTransfer.items[_i].getAsFile();
            files.push(file);
          }
        }
      } else {
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          files.push(ev.dataTransfer.files[i]);
        }
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _file = _step.value;

          console.log('... file[' + i + '].name = ' + _file.name);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (dropZoneState.dropReceiver) dropZoneState.dropReceiver(files);
    }
  },
  template: '<div class="dropZone" :class="{ visible: visible }" ' + '@dragleave="dragLeave" @dragenter="allowDrop" @dragover="allowDrop" @drop="handleDrop"></div>'
};

exports.GlobalDropZone = GlobalDropZone;
exports.dropZoneState = dropZoneState;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkerQueue = function () {
  function WorkerQueue(workerGenerator) {
    (0, _classCallCheck3.default)(this, WorkerQueue);

    this.tasks = [];
    this.worker = null;
    this.workerGenerator = workerGenerator;
    this.lastRequestId = 0;
  }

  (0, _createClass3.default)(WorkerQueue, [{
    key: "startWorker",
    value: function startWorker() {
      var _this = this;

      var worker = this.workerGenerator();
      worker.onmessage = function (message) {
        var msg = message.data;
        switch (msg.type) {
          case "ready":
            return _this.doNextTask();
          case "logs":
            return _logger2.default.saveLog.apply(_logger2.default, (0, _toConsumableArray3.default)(msg.logs));
          case "response":
            _this.tasks[0].resolve(msg.result);
            _this.tasks.shift();
            _this.doNextTask();

            break;
        }
      };
      worker.onerror = function (error) {
        _this.tasks[0].reject(error);
        _this.tasks.shift();
        worker.terminate();
        _this.worker = null;
        if (_this.tasks.length > 0) {
          _this.startWorker();
        }
      };
      this.worker = worker;
    }
  }, {
    key: "doNextTask",
    value: function doNextTask() {
      var nextTask = this.tasks[0];
      if (nextTask) {
        var method = nextTask.method,
            serializedArgs = nextTask.serializedArgs,
            requestId = nextTask.requestId;

        this.worker.postMessage({ type: "request", method: method, serializedArgs: serializedArgs, requestId: requestId });
      }
    }
  }, {
    key: "doWorkerTask",
    value: function doWorkerTask(method, serializedArgs) {
      var _this2 = this;

      var requestId = ++this.lastRequestId;
      return new _promise2.default(function (resolve, reject) {
        var worker = _this2.worker;
        _this2.tasks.push({ method: method, serializedArgs: serializedArgs, resolve: resolve, reject: reject, requestId: requestId });
        if (!worker) {
          _this2.startWorker();
          return;
        }
        if (_this2.tasks.length == 1) {
          worker.postMessage({ type: "request", method: method, serializedArgs: serializedArgs, requestId: requestId });
        }
      });
    }
  }]);
  return WorkerQueue;
}();

exports.default = WorkerQueue;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  "data-v-5821f632",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(56);

var _from2 = _interopRequireDefault(_from);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(34);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _map = __webpack_require__(27);

var _map2 = _interopRequireDefault(_map);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _tableUtils = __webpack_require__(55);

var _tableUtils2 = _interopRequireDefault(_tableUtils);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var possibleSumColumnNames = _config2.default.logic.ads.sumColumns;

function preformAnalysis(inputTable, query) {
  if (!inputTable) return null;

  var columnsCount = inputTable.columnNames.length;
  var columnIdsByName = _tableUtils2.default.columnIdsByName(inputTable);
  var sumColumnNames = possibleSumColumnNames.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var sumColumnInputIds = sumColumnNames.map(function (columnName) {
    return columnIdsByName.get(columnName);
  });
  var sumColumnCount = sumColumnNames.length;

  var adColumns = query.aggregateUrls ? _config2.default.logic.ads.aggregateColumns.concat(_config2.default.logic.ads.urlColumns) : _config2.default.logic.ads.aggregateColumns;

  var adColumnsNames = adColumns.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adColumnsInputIds = adColumnsNames.map(function (col) {
    return columnIdsByName.get(col);
  });

  if (query.categories != 'all') {
    var categories = query.categories;
    var categoryColumnsIds = categories.map(function (col) {
      return columnIdsByName.get(col.columnName);
    });

    var prefilteredTable = {
      title: inputTable.title,
      columnNames: inputTable.columnNames.slice(),
      rows: inputTable.rows.filter(function (row) {
        var match = true;
        for (var i = 0; i < categories.length; i++) {
          var value = row[categoryColumnsIds[i]];
          var options = categories[i].options;
          match = match && options.indexOf(value) != -1;
        }
        return match;
      })
    };
    inputTable = prefilteredTable;
  }

  var prefilteredData = inputTable.rows;
  var preSummaryColumns = adColumnsInputIds.length + 1;
  var summary = new Array(preSummaryColumns + sumColumnCount);
  for (var i = 0; i < preSummaryColumns; i++) {
    summary[i] = '';
  }for (var columnId = 0; columnId < sumColumnCount; columnId++) {
    summary[preSummaryColumns + columnId] = 0;
  }var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(prefilteredData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var row = _step.value;

      for (var _columnId = 0; _columnId < sumColumnCount; _columnId++) {
        var v = +row[sumColumnInputIds[_columnId]];
        if (isFinite(v)) summary[preSummaryColumns + _columnId] += v * 100;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  summary[0] = 'Summary';

  var adsMap = new _map2.default();
  var adKeyA = new Array(adColumnsInputIds.length);
  var dataRowsCount = inputTable.rows.length;
  for (var rowId = 0; rowId < dataRowsCount; rowId++) {
    var _row = inputTable.rows[rowId];


    var empty = true;
    for (var _i = 0; _i < adColumnsInputIds.length; _i++) {
      var colId = adColumnsInputIds[_i];
      adKeyA[_i] = _row[colId];
      if (_row[colId] != ' --') empty = false;
    }
    if (empty) continue;

    var _adKey = adKeyA.join('!@#');

    var _accumulator = adsMap.get(_adKey);
    if (!_accumulator) {
      _accumulator = {
        keyColumns: adKeyA.slice(),
        overallCount: 0,
        sumColumns: new Array(sumColumnCount)
      };
      for (var _i2 = 0; _i2 < sumColumnCount; _i2++) {
        _accumulator.sumColumns[_i2] = 0.0;
      }
    }

    for (var _i3 = 0; _i3 < sumColumnCount; _i3++) {
      _accumulator.sumColumns[_i3] += _row[sumColumnInputIds[_i3]] * 100;
    }
    _accumulator.overallCount += 100;
    adsMap.set(_adKey, _accumulator);
  }

  var ads = new Array(adsMap.size);
  var adId = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(adsMap.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref = _step2.value;

      var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

      var adKey = _ref2[0];
      var accumulator = _ref2[1];

      ads[adId++] = accumulator;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (typeof window != 'undefined') window.out = ads;
  return {
    title: "Analiza słów z " + inputTable.title,
    columnNames: adColumnsNames.concat(['Count']).concat(sumColumnNames),
    rows: ads.map(function (ad) {
      return ad.keyColumns.concat([ad.overallCount]).concat(ad.sumColumns);
    }),
    summary: summary
  };
}

function calculateTable(outputTable) {
  if (!outputTable) return null;
  var columnNames = outputTable.columnNames;
  var columnsCount = columnNames.length;
  var columnIdsByName = _tableUtils2.default.columnIdsByName(outputTable);

  var outputData = outputTable.rows;

  var clicksColumnId = columnIdsByName.get("Clicks");
  var impressionsColumnId = columnIdsByName.get("Impressions");
  var costColumnId = columnIdsByName.get("Cost");
  var conversionsColumnId = columnIdsByName.get("Conversions");
  var conversionsValueColumnId = columnIdsByName.get("ConversionValue");

  var calculatedData = outputData;
  var summary = outputTable.summary;

  if (clicksColumnId !== undefined && impressionsColumnId !== undefined) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(calculatedData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var row = _step3.value;

        row.push(row[clicksColumnId] * 100 * 100 / row[impressionsColumnId]);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    summary.push(summary[clicksColumnId] * 100 * 100 / summary[impressionsColumnId]);
    columnNames.push('CTR');
  }

  if (conversionsValueColumnId !== undefined && costColumnId !== undefined) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(calculatedData), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _row2 = _step4.value;

        _row2.push(_row2[conversionsValueColumnId] * 100 / _row2[costColumnId]);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    summary.push(summary[conversionsValueColumnId] * 100 / summary[costColumnId]);
    columnNames.push('ROAS');
  }

  if (costColumnId !== undefined && conversionsColumnId !== undefined) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = (0, _getIterator3.default)(calculatedData), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var _row3 = _step5.value;

        _row3.push(_row3[costColumnId] * 100 / _row3[conversionsColumnId]);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    summary.push(summary[costColumnId] * 100 / summary[conversionsColumnId]);
    columnNames.push('CC');
  }

  if (conversionsColumnId !== undefined && clicksColumnId !== undefined) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = (0, _getIterator3.default)(calculatedData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _row4 = _step6.value;

        _row4.push(_row4[conversionsColumnId] * 100 * 100 / _row4[clicksColumnId]);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    summary.push(summary[conversionsColumnId] * 100 * 100 / summary[clicksColumnId]);
    columnNames.push('CR');
  }

  for (var columnId = columnsCount; columnId < columnsCount + columnNames.length; columnId++) {
    var columnName = columnNames[columnId];
    columnIdsByName.set(columnName, columnId);
  }
  columnsCount = columnNames.length;

  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = (0, _getIterator3.default)(calculatedData), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var _row5 = _step7.value;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = (0, _getIterator3.default)(_row5), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var cell = _step8.value;
          if (cell == null) throw new Error("null cell " + (0, _stringify2.default)(cell) + " in row " + (0, _stringify2.default)(_row5));
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  var calculatedTable = {
    title: outputTable.title,
    columnNames: columnNames,
    rows: calculatedData,
    summary: summary
  };
  return calculatedTable;
}

function prepareTableView(calculatedTable, viewSettings) {
  if (!calculatedTable) return null;
  console.log("PREP VIEW!");
  var calculatedData = calculatedTable.rows;

  var columnNames = calculatedTable.columnNames;
  var columnsCount = columnNames.length;
  var summary = calculatedTable.summary;

  var columnIdsByName = _tableUtils2.default.columnIdsByName({ columnNames: columnNames });

  var filteredData = calculatedData;
  if (viewSettings.enableFilter && viewSettings.filter) {
    var filterFunc = _expression2.default.compileFilter(viewSettings.filter, columnIdsByName);

    filteredData = calculatedData.filter(filterFunc);
  }

  if (viewSettings.searchText != '') filteredData = filteredData.filter(function (row) {
    var found = false;
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = (0, _getIterator3.default)(row), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var cell = _step9.value;

        if (cell.indexOf && cell.toLowerCase().indexOf(viewSettings.searchText.toLowerCase()) != -1) found = true;
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    return found;
  });

  var adColumnsNames = _config2.default.logic.ads.aggregateColumns.concat(_config2.default.logic.ads.urlColumns).filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adTitleNames = _config2.default.logic.ads.titleColumns.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adTitleIds = adTitleNames.map(function (col) {
    return columnIdsByName.get(col);
  });
  var adText1Names = _config2.default.logic.ads.text1Columns.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adText2Names = _config2.default.logic.ads.text2Columns.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adText1Ids = adText1Names.map(function (col) {
    return columnIdsByName.get(col);
  });
  var adText2Ids = adText2Names.map(function (col) {
    return columnIdsByName.get(col);
  });
  var adUrlNames = _config2.default.logic.ads.urlColumns.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var adUrlIds = adUrlNames.map(function (col) {
    return columnIdsByName.get(col);
  });
  var objectifiedData = new Array(filteredData.length);

  var _loop = function _loop(rowId) {
    var row = filteredData[rowId];
    var adObject = {
      title: adTitleIds.map(function (id) {
        return row[id].trim();
      }).filter(function (t) {
        return t.length > 0;
      }).filter(function (t) {
        return t != '--';
      }).join(' - '),
      text1: adText1Ids.map(function (id) {
        return row[id].trim();
      }).filter(function (t) {
        return t.length > 0;
      }).filter(function (t) {
        return t != '--';
      }).join('\n'),
      text2: adText2Ids.map(function (id) {
        return row[id].trim();
      }).filter(function (t) {
        return t.length > 0;
      }).filter(function (t) {
        return t != '--';
      }).join('\n'),
      url: adUrlIds.map(function (id) {
        return row[id].trim();
      }).filter(function (t) {
        return t.length > 0;
      }).filter(function (t) {
        return t != '--';
      }).join(', ')
    };
    objectifiedData[rowId] = [adObject].concat(row.slice(adColumnsNames.length));
  };

  for (var rowId = 0; rowId < filteredData.length; rowId++) {
    _loop(rowId);
  }
  if (typeof window != 'undefined') window.objd = objectifiedData;
  columnNames = ['Ad'].concat(columnNames.slice(adColumnsNames.length));
  summary = ['Summary'].concat(summary.slice(adColumnsNames.length));
  columnIdsByName = _tableUtils2.default.columnIdsByName({ columnNames: columnNames });
  columnsCount = columnNames.length;

  var sortedData = objectifiedData;
  if (objectifiedData.length > 0) {
    sortedData = objectifiedData.slice();
    var sortColumnId = columnIdsByName.get(viewSettings.sortBy);

    if (typeof sortedData[0][sortColumnId] == 'number') {
      if (viewSettings.sortAsc) {
        sortedData.sort(function (a, b) {
          return a[sortColumnId] - b[sortColumnId];
        });
      } else {
        sortedData.sort(function (a, b) {
          return b[sortColumnId] - a[sortColumnId];
        });
      }
    } else {
      if (viewSettings.sortAsc) {
        sortedData.sort(function (a, b) {
          return a[sortColumnId] > b[sortColumnId] ? 1 : a[sortColumnId] < b[sortColumnId] ? -1 : 0;
        });
      } else {
        sortedData.sort(function (a, b) {
          return b[sortColumnId] > a[sortColumnId] ? 1 : b[sortColumnId] < a[sortColumnId] ? -1 : 0;
        });
      }
    }
  }

  var sortedTable = {
    title: calculatedTable.title,
    columnNames: columnNames,
    columnTypes: ["ad"].concat(columnNames.slice(1).map(function (t) {
      return "number";
    })),
    rows: sortedData,
    summary: summary
  };
  return sortedTable;
}

function generateTips(inputTable, outputTable, maxTips) {
  var tipsRules = _config2.default.adsTips;
  var tips = [];
  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = (0, _getIterator3.default)(tipsRules), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var rule = _step10.value;

      var tip = rule(inputTable, outputTable);
      if (tip) tips.push(tip);
      if (tips.length >= maxTips) return tips;
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10.return) {
        _iterator10.return();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }

  return tips;
}

function findCategories(inputTable) {
  var categories = [];
  var rowCount = inputTable.rows;
  for (var columnId = 0; columnId < inputTable.columnNames.length; columnId++) {
    var columnName = inputTable.columnNames[columnId];
    if (_config2.default.logic.categoryColumns.indexOf(columnName) == -1) continue;
    var categoriesMap = new _map2.default();
    var categoriesCount = 0;
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = (0, _getIterator3.default)(inputTable.rows), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var _row6 = _step11.value;

        var categoryName = _row6[columnId].trim();
        if (categoryName == '') categoryName = "Empty";
        if (categoryName == '--') continue;
        if (!categoriesMap.has(categoryName)) {
          categoriesMap.set(categoryName, true);
          categoriesCount++;
        }
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    categories.push({
      columnName: columnName,
      options: (0, _from2.default)(categoriesMap.keys())
    });
  }
  return categories;
}

var methods = {
  preformAnalysis: preformAnalysis,
  calculateTable: calculateTable,
  prepareTableView: prepareTableView,
  generateTips: generateTips,

  findCategories: findCategories
};

exports.default = methods;


if (typeof window == "undefined" || window.document === undefined) {
  _logger2.default.install();
  _logger2.default.addWorkerParentLogDestination();
  onmessage = function onmessage(msg) {
    var _msg$data = msg.data,
        method = _msg$data.method,
        serializedArgs = _msg$data.serializedArgs,
        requestId = _msg$data.requestId;

    var args = serializedArgs;

    var result = methods[method].apply(null, args);

    postMessage({
      type: "response",
      result: result,
      requestId: requestId
    });
  };
  postMessage({
    type: "ready"
  });
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(56);

var _from2 = _interopRequireDefault(_from);

var _slicedToArray2 = __webpack_require__(34);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(27);

var _map2 = _interopRequireDefault(_map);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _tableUtils = __webpack_require__(55);

var _tableUtils2 = _interopRequireDefault(_tableUtils);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wordRegexWithoutSpecialChars = _config2.default.logic.words.wordRegex.withoutSpecialChars;
var wordRegexWithSpecialChars = _config2.default.logic.words.wordRegex.withSpecialChars;

var possibleSumColumnNames = _config2.default.logic.words.sumColumns;

function preformAnalysis(inputTable, query) {
  if (!inputTable) return null;
  inputTable.rows.pop();
  var columnsCount = inputTable.columnNames.length;
  var columnIdsByName = _tableUtils2.default.columnIdsByName(inputTable);
  var sumColumnNames = possibleSumColumnNames.filter(function (columnName) {
    return columnIdsByName.has(columnName);
  });
  var sumColumnInputIds = sumColumnNames.map(function (columnName) {
    return columnIdsByName.get(columnName);
  });
  var sumColumnCount = sumColumnNames.length;
  if (query.wordsColumns.length == 0) return null;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(query.wordsColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var col = _step.value;

      if (!columnIdsByName.has(col)) return null;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var wordsColumnsInputIds = query.wordsColumns.map(function (col) {
    return columnIdsByName.get(col);
  });

  if (query.categories != 'all') {
    var categories = query.categories;
    var categoryColumnsIds = categories.map(function (col) {
      return columnIdsByName.get(col.columnName);
    });

    var prefilteredTable = {
      title: inputTable.title,
      columnNames: inputTable.columnNames.slice(),
      rows: inputTable.rows.filter(function (row) {
        var match = true;
        for (var i = 0; i < categories.length; i++) {
          var value = row[categoryColumnsIds[i]];
          var options = categories[i].options;
          match = match && options.indexOf(value) != -1;
        }
        return match;
      })
    };
    inputTable = prefilteredTable;
  }

  var prefilteredData = inputTable.rows;
  var summary = new Array(2 + sumColumnCount);
  for (var columnId = 0; columnId < sumColumnCount; columnId++) {
    summary[2 + columnId] = 0;
  }var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(prefilteredData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var row = _step2.value;

      for (var _columnId = 0; _columnId < sumColumnCount; _columnId++) {
        var v = +row[sumColumnInputIds[_columnId]];
        if (isFinite(v)) summary[2 + _columnId] += v * 100;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  summary[0] = 'Summary';
  summary[1] = '';

  var phraseMap = new _map2.default();
  var dataRowsCount = inputTable.rows.length;
  for (var rowId = 0; rowId < dataRowsCount; rowId++) {
    var _row = inputTable.rows[rowId];


    var _phrases = [];

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(wordsColumnsInputIds), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var wordsColId = _step3.value;

        var wordsText = query.ignoreCase ? ("" + _row[wordsColId]).toLowerCase() : _row[wordsColId];
        var words = query.ignoreSpecialCharacters ? wordsText.match(wordRegexWithoutSpecialChars) || [] : wordsText.match(wordRegexWithSpecialChars) || [];
        var wordCount = words.length;
        for (var phraseLength = +query.minWords; phraseLength <= +query.maxWords; phraseLength++) {
          for (var firstWordId = 0; firstWordId <= wordCount - phraseLength; firstWordId++) {
            var phraseWords = words.slice(firstWordId, firstWordId + phraseLength);

            var phraseText = phraseWords.join(' ');
            if (_phrases.indexOf(phraseText) == -1) _phrases.push(phraseText);
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(_phrases), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _phrase = _step4.value;

        var _accumulator = phraseMap.get(_phrase);
        if (!_accumulator) {
          _accumulator = {
            phraseText: _phrase,
            overallCount: 0,
            sumColumns: new Array(sumColumnCount)
          };
          for (var i = 0; i < sumColumnCount; i++) {
            _accumulator.sumColumns[i] = 0.0;
          }
        }
        for (var _i = 0; _i < sumColumnCount; _i++) {
          _accumulator.sumColumns[_i] += _row[sumColumnInputIds[_i]] * 100;
        }
        _accumulator.overallCount += 100;
        phraseMap.set(_phrase, _accumulator);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }

  var phrases = new Array(phraseMap.size);
  var phraseId = 0;
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = (0, _getIterator3.default)(phraseMap.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _ref = _step5.value;

      var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

      var phrase = _ref2[0];
      var accumulator = _ref2[1];

      phrases[phraseId++] = accumulator;
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  if (typeof window != 'undefined') window.out = phrases;
  return {
    title: "Analiza słów z " + inputTable.title,
    columnNames: ['Phrase', 'Count'].concat(sumColumnNames),
    rows: phrases.map(function (phrase) {
      return [phrase.phraseText, phrase.overallCount].concat(phrase.sumColumns);
    }),
    summary: summary
  };
}

function calculateTable(outputTable) {
  if (!outputTable) return null;
  var columnNames = outputTable.columnNames;
  var columnsCount = columnNames.length;
  var columnIdsByName = _tableUtils2.default.columnIdsByName(outputTable);

  var outputData = outputTable.rows;
  var summary = outputTable.summary;

  var clicksColumnId = columnIdsByName.get("Clicks");
  var impressionsColumnId = columnIdsByName.get("Impressions");
  var costColumnId = columnIdsByName.get("Cost");
  var conversionsColumnId = columnIdsByName.get("Conversions");
  var conversionsValueColumnId = columnIdsByName.get("ConversionValue");

  var calculatedData = outputData;

  if (clicksColumnId !== undefined && impressionsColumnId !== undefined) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = (0, _getIterator3.default)(calculatedData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var row = _step6.value;

        row.push(row[clicksColumnId] * 100 * 100 / row[impressionsColumnId]);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    summary.push(summary[clicksColumnId] * 100 * 100 / summary[impressionsColumnId]);
    columnNames.push('CTR');
  }

  if (conversionsValueColumnId !== undefined && costColumnId !== undefined) {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = (0, _getIterator3.default)(calculatedData), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var _row2 = _step7.value;

        _row2.push(_row2[conversionsValueColumnId] * 100 / _row2[costColumnId]);
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    summary.push(summary[conversionsValueColumnId] * 100 / summary[costColumnId]);
    columnNames.push('ROAS');
  }

  if (costColumnId !== undefined && conversionsColumnId !== undefined) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = (0, _getIterator3.default)(calculatedData), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var _row3 = _step8.value;

        _row3.push(_row3[costColumnId] * 100 / _row3[conversionsColumnId]);
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    summary.push(summary[costColumnId] * 100 / summary[conversionsColumnId]);
    columnNames.push('CC');
  }

  if (conversionsColumnId !== undefined && clicksColumnId !== undefined) {
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = (0, _getIterator3.default)(calculatedData), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var _row4 = _step9.value;

        _row4.push(_row4[conversionsColumnId] * 100 * 100 / _row4[clicksColumnId]);
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    summary.push(summary[conversionsColumnId] * 100 * 100 / summary[clicksColumnId]);
    columnNames.push('CR');
  }

  for (var columnId = columnsCount; columnId < columnNames.length; columnId++) {
    var columnName = columnNames[columnId];
    columnIdsByName.set(columnName, columnId);
  }
  columnsCount = columnNames.length;

  var calculatedTable = {
    title: outputTable.title,
    columnNames: columnNames,
    rows: calculatedData,
    summary: summary
  };
  return calculatedTable;
}

function prepareTableView(calculatedTable, viewSettings) {
  if (!calculatedTable) return null;
  console.log("PREP VIEW!");
  var calculatedData = calculatedTable.rows;

  var columnNames = calculatedTable.columnNames;
  var columnsCount = columnNames.length;
  var summary = calculatedTable.summary;

  calculatedTable.columnNames = columnNames;
  var columnIdsByName = _tableUtils2.default.columnIdsByName(calculatedTable);

  var filteredData = calculatedData;
  if (viewSettings.enableFilter && viewSettings.filter) {
    var filterFunc = _expression2.default.compileFilter(viewSettings.filter, columnIdsByName);

    filteredData = calculatedData.filter(filterFunc);
  }

  if (viewSettings.searchText != '') filteredData = filteredData.filter(function (row) {
    var found = false;
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = (0, _getIterator3.default)(row), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var cell = _step10.value;

        if (cell.indexOf && cell.toLowerCase().indexOf(viewSettings.searchText.toLowerCase()) != -1) found = true;
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }

    return found;
  });

  var sortedData = filteredData;
  if (filteredData.length > 0) {
    sortedData = filteredData.slice();
    var sortColumnId = columnIdsByName.get(viewSettings.sortBy);

    if (typeof sortedData[0][sortColumnId] == 'number') {
      if (viewSettings.sortAsc) {
        sortedData.sort(function (a, b) {
          return a[sortColumnId] - b[sortColumnId];
        });
      } else {
        sortedData.sort(function (a, b) {
          return b[sortColumnId] - a[sortColumnId];
        });
      }
    } else {
      if (viewSettings.sortAsc) {
        sortedData.sort(function (a, b) {
          return a[sortColumnId] > b[sortColumnId] ? 1 : a[sortColumnId] < b[sortColumnId] ? -1 : 0;
        });
      } else {
        sortedData.sort(function (a, b) {
          return b[sortColumnId] > a[sortColumnId] ? 1 : b[sortColumnId] < a[sortColumnId] ? -1 : 0;
        });
      }
    }
  }

  var sortedTable = {
    title: calculatedTable.title,
    columnNames: columnNames,
    columnTypes: ["text"].concat(columnNames.slice(1).map(function (t) {
      return "number";
    })),
    rows: sortedData,
    summary: summary
  };
  return sortedTable;
}

function generateTips(inputTable, outputTable, maxTips) {
  var tipsRules = _config2.default.wordsTips;
  var tips = [];
  var _iteratorNormalCompletion11 = true;
  var _didIteratorError11 = false;
  var _iteratorError11 = undefined;

  try {
    for (var _iterator11 = (0, _getIterator3.default)(tipsRules), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
      var rule = _step11.value;

      var tip = rule(inputTable, outputTable);
      if (tip) tips.push(tip);
      if (tips.length >= maxTips) return tips;
    }
  } catch (err) {
    _didIteratorError11 = true;
    _iteratorError11 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion11 && _iterator11.return) {
        _iterator11.return();
      }
    } finally {
      if (_didIteratorError11) {
        throw _iteratorError11;
      }
    }
  }

  return tips;
}

function findCategories(inputTable) {
  var categories = [];
  var rowCount = inputTable.rows;
  for (var columnId = 0; columnId < inputTable.columnNames.length; columnId++) {
    var columnName = inputTable.columnNames[columnId];
    if (_config2.default.logic.categoryColumns.indexOf(columnName) == -1) continue;
    var categoriesMap = new _map2.default();
    var categoriesCount = 0;
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = (0, _getIterator3.default)(inputTable.rows), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var row = _step12.value;

        if (!categoriesMap.has(row[columnId])) {
          categoriesMap.set(row[columnId], true);
          categoriesCount++;
        }
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }

    categories.push({
      columnName: columnName,
      options: (0, _from2.default)(categoriesMap.keys())
    });
  }
  return categories;
}

var methods = {
  preformAnalysis: preformAnalysis,
  calculateTable: calculateTable,
  prepareTableView: prepareTableView,
  generateTips: generateTips,
  findCategories: findCategories
};

exports.default = methods;


if (typeof window == "undefined" || window.document === undefined) {
  _logger2.default.install();
  _logger2.default.addWorkerParentLogDestination();
  onmessage = function onmessage(msg) {
    var _msg$data = msg.data,
        method = _msg$data.method,
        serializedArgs = _msg$data.serializedArgs,
        requestId = _msg$data.requestId;

    var args = serializedArgs;

    var result = methods[method].apply(null, args);

    postMessage({
      type: "response",
      result: result,
      requestId: requestId
    });
  };
  postMessage({
    type: "ready"
  });
}

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  "data-v-f57ee6a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  "data-v-34d1427e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-411f1f3d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  "data-v-4d0c9038",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  "data-v-68a5abd5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  "data-v-184a216c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-401c6c64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  "data-v-e161f20e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-2636998a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  "data-v-c19a3942",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  "data-v-1a46d8cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  "data-v-6497431a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(477);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueMeta = __webpack_require__(476);

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _Hello = __webpack_require__(399);

var _Hello2 = _interopRequireDefault(_Hello);

var _CsvAnalyzer = __webpack_require__(398);

var _CsvAnalyzer2 = _interopRequireDefault(_CsvAnalyzer);

var _AccountSettings = __webpack_require__(396);

var _AccountSettings2 = _interopRequireDefault(_AccountSettings);

var _LoginForm = __webpack_require__(140);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _Logout = __webpack_require__(419);

var _Logout2 = _interopRequireDefault(_Logout);

var _ResetPassword = __webpack_require__(411);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _ConfirmEmail = __webpack_require__(408);

var _ConfirmEmail2 = _interopRequireDefault(_ConfirmEmail);

var _RegisterForm = __webpack_require__(410);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _ConfirmRegister = __webpack_require__(409);

var _ConfirmRegister2 = _interopRequireDefault(_ConfirmRegister);

var _Order = __webpack_require__(401);

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueMeta2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    redirect: { name: 'csv-words' }
  }, {
    path: '/login/:redirect',
    name: 'login',
    component: _LoginForm2.default,
    meta: { requiresLogout: true }
  }, {
    path: '/sign-up',
    name: 'register',
    component: _RegisterForm2.default,
    meta: { requiresLogout: true }
  }, {
    path: '/sign-out',
    name: 'logout',
    component: _Logout2.default
  }, {
    path: '/confirm-sign-up/:key',
    name: 'confirm-register',
    component: _ConfirmRegister2.default
  }, {
    path: '/home',
    name: 'Hello',
    component: _Hello2.default
  }, {
    path: '/csv/words',
    name: 'csv-words',
    component: _CsvAnalyzer2.default,
    props: {
      analyzer: {
        type: 'words'
      }
    },
    meta: { requiresLogin: true }
  }, {
    path: '/csv/ads',
    name: 'csv-ads',
    component: _CsvAnalyzer2.default,
    props: {
      analyzer: {
        type: 'ads'
      }
    },
    meta: { requiresLogin: true }
  }, {
    path: '/user',
    name: 'account-settings',
    component: _AccountSettings2.default,
    meta: { requiresLogin: true }
  }, {
    path: '/reset-password/:key',
    name: 'reset-password',
    component: _ResetPassword2.default,
    meta: { requiresLogout: true }
  }, {
    path: '/change-email/:key',
    name: 'change-email',
    component: _ConfirmEmail2.default
  }, {
    path: '/order',
    name: 'order',
    component: _Order2.default,
    meta: { requiresLogin: true }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched && to.matched[0] && to.matched[0].meta) {
    if (to.matched[0].meta.requiresLogin) {
      if (!_api2.default.session.loggedIn) {
        console.log("REDIRECT TO LOGIN!");
        next({
          name: 'login',
          params: { redirect: to.fullPath }
        });
        return;
      }
    }
  }

  next();
});

var routerReactions = new _vue2.default({
  data: function data() {
    return {};
  },

  computed: {
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    }
  },
  watch: {
    loggedIn: function loggedIn(v) {
      if (v) {
        console.log("LOGGED IN!");
        if (router.currentRoute.meta.requiresLogout) {
          if (router.currentRoute.params.redirect) {
            router.replace(router.currentRoute.params.redirect);
          } else {
            router.replace({ name: 'index' });
          }
        }
      } else {
        console.log("LOGGED OUT!");
        if (router.currentRoute.meta.requiresLogin) {
          router.replace({
            name: 'login',
            params: { redirect: router.currentRoute.fullPath }
          });
        }
      }
    }
  }
});

window.rtr = router;

exports.default = router;

/***/ }),
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _LoginForm = __webpack_require__(140);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _LeftMenu = __webpack_require__(400);

var _LeftMenu2 = _interopRequireDefault(_LeftMenu);

var _overlayLayer = __webpack_require__(33);

var _overlayModel2 = __webpack_require__(15);

var _overlayModel3 = _interopRequireDefault(_overlayModel2);

var _GlobalDropZone = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drawerFocusLostListener = void 0;

exports.default = {
  name: 'app',
  metaInfo: {
    title: 'Semgregate',
    titleTemplate: '%s | Semgregate'
  },
  components: {
    LoginForm: _LoginForm2.default, LeftMenu: _LeftMenu2.default, OverlayComponent: _overlayLayer.OverlayComponent, GlobalDropZone: _GlobalDropZone.GlobalDropZone
  },
  data: function data() {
    return {
      drawerVisible: false
    };
  },

  computed: {
    title: function title() {
      var title = this.$route.name;
      try {
        title = app.$route.matched[0].components.default.metaInfo.title;
      } catch (e) {}
      return title;
    },
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    },
    overlayModel: function overlayModel() {
      return _overlayModel3.default;
    }
  },
  methods: {
    dragEnter: function dragEnter(ev) {
      console.log("DRAG ENTER");
      _GlobalDropZone.dropZoneState.visible = true;
    },
    showDrawer: function showDrawer() {
      this.drawerVisible = !this.drawerVisible;
    }
  },
  watch: {
    drawerVisible: function drawerVisible(visible) {}
  },
  created: function created() {
    window.app = this;
  },
  mounted: function mounted() {
    document.querySelector("#preload").style.display = "none";
  },
  beforeDestroy: function beforeDestroy() {
    if (drawerFocusLostListener) document.body.removeEventListener("touch", drawerFocusLostListener);
    if (drawerFocusLostListener) document.body.removeEventListener("click", drawerFocusLostListener);
  }
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChangePassword = __webpack_require__(407);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _ChangeEmail = __webpack_require__(406);

var _ChangeEmail2 = _interopRequireDefault(_ChangeEmail);

var _ChangeUserData = __webpack_require__(418);

var _ChangeUserData2 = _interopRequireDefault(_ChangeUserData);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'account-settings',
  metaInfo: {
    title: (0, _i18n3.default)().accountSettings.title
  },
  components: {
    ChangePassword: _ChangePassword2.default, ChangeEmail: _ChangeEmail2.default, ChangeUserData: _ChangeUserData2.default
  },
  data: function data() {
    return {};
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().accountSettings;
    }
  }
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _LoadFileSmall = __webpack_require__(149);

var _LoadFileSmall2 = _interopRequireDefault(_LoadFileSmall);

var _BigTable = __webpack_require__(146);

var _BigTable2 = _interopRequireDefault(_BigTable);

var _AdsTable = __webpack_require__(405);

var _AdsTable2 = _interopRequireDefault(_AdsTable);

var _SaveView = __webpack_require__(145);

var _SaveView2 = _interopRequireDefault(_SaveView);

var _LoadView = __webpack_require__(144);

var _LoadView2 = _interopRequireDefault(_LoadView);

var _AdsLeftBar = __webpack_require__(403);

var _AdsLeftBar2 = _interopRequireDefault(_AdsLeftBar);

var _TopBar = __webpack_require__(142);

var _TopBar2 = _interopRequireDefault(_TopBar);

var _WorkerQueue = __webpack_require__(70);

var _WorkerQueue2 = _interopRequireDefault(_WorkerQueue);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _adsAnalyzer = __webpack_require__(104);

var _adsAnalyzer2 = _interopRequireDefault(_adsAnalyzer);

var _adsAnalyzer3 = __webpack_require__(481);

var _adsAnalyzer4 = _interopRequireDefault(_adsAnalyzer3);

var _csv = __webpack_require__(53);

var _save = __webpack_require__(54);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PremiumOverlay = __webpack_require__(66);

var _PremiumOverlay2 = _interopRequireDefault(_PremiumOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.analyzerWorker = _adsAnalyzer4.default;


var webWorkerQueue = new _WorkerQueue2.default(_adsAnalyzer4.default);

var adsAnalyzerState = new _vue2.default({
  data: {
    filter: JSON.parse((0, _stringify2.default)(_config2.default.logic.defaultFilter)),
    sortColumn: "Count",
    sortAsc: false,
    appliedFilter: null,
    query: JSON.parse((0, _stringify2.default)(_config2.default.logic.ads.defaultQuery))
  }
});

exports.default = {
  name: 'ads-analyzer',
  props: {
    inputTable: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    searchText: {
      type: String
    }
  },
  components: {
    LoadFileSmall: _LoadFileSmall2.default,
    BigTable: _BigTable2.default,
    AdsTable: _AdsTable2.default,
    SaveView: _SaveView2.default,
    LoadView: _LoadView2.default,
    AdsLeftBar: _AdsLeftBar2.default,
    TopBar: _TopBar2.default
  },
  metaInfo: {
    title: 'Ads'
  },
  data: function data() {
    return {
      query: JSON.parse((0, _stringify2.default)(_config2.default.logic.ads.defaultQuery)),
      outputTable: null,
      calculatedTable: null,
      visibleTable: null,
      state: "ready",
      sortColumn: adsAnalyzerState.sortColumn,
      sortAsc: adsAnalyzerState.sortAsc,
      filter: adsAnalyzerState.filter,
      appliedFilter: adsAnalyzerState.appliedFilter,
      webWorkerEnabled: localStorage.noWorker ? false : typeof Worker !== "undefined",
      categories: null,
      lastSearchChange: 0,
      visibleDialog: null,
      tips: [],
      tipsExpanded: true,
      filterExpanded: true,
      enableFilter: false,
      maxVisibleRows: _config2.default.view.maxVisibleRows,
      testEnvironment: localStorage.test
    };
  },

  computed: {
    viewSettings: function viewSettings() {
      return {
        sortBy: this.sortColumn,
        sortAsc: this.sortAsc,
        filter: this.appliedFilter,
        enableFilter: true,
        searchText: this.searchText,
        maxVisibleRows: this.maxVisibleRows
      };
    },
    visibleDialogTitle: function visibleDialogTitle() {
      switch (this.visibleDialog) {
        case 'loadView':
          return "Load ilters";
        case 'saveView':
          return "Save Filters";
        default:
          'Dialog?!';
      }
    },
    saveableView: function saveableView() {
      return {
        sortColumn: this.sortColumn,
        sortAsc: this.sortAsc,
        filter: this.appliedFilter || this.filter,
        filterApplied: !!this.appliedFilter
      };
    },
    limitedVisibleTable: function limitedVisibleTable() {
      var viewSettings = this.viewSettings;
      var visibleTable = this.visibleTable;
      if (!visibleTable) return null;
      return (0, _extends3.default)({}, visibleTable, {
        rows: visibleTable.rows.slice(0, +viewSettings.maxVisibleRows || _config2.default.view.maxVisibleRows)
      });
    },
    premium: function premium() {
      return _api2.default.session.premium;
    },
    tableEndInfoType: function tableEndInfoType() {
      if (this.visibleTable.rows.length == this.limitedVisibleTable.rows.length) return null;
      if (!this.premium) return "premium";
      return "download";
    },
    tableEndInfo: function tableEndInfo() {
      var type = this.tableEndInfoType;
      if (!type) return null;
      return {
        text: (0, _i18n3.default)().endInfo[type]({
          allRows: this.visibleTable.rows.length,
          visibleRows: this.limitedVisibleTable.rows.length
        }),
        type: type
      };
    }
  },
  watch: {
    enableFilter: function enableFilter(v) {
      if (!v && this.appliedFilter) this.clearFilter();
    },
    inputTable: function inputTable(table) {
      this.processInputTable(table);
    },
    query: function query(v) {
      adsAnalyzerState.query = v;
      this.computeOutputTable();
    },
    filter: function filter(v) {
      adsAnalyzerState.filter = v;
    },
    appliedFilter: function appliedFilter(v) {
      adsAnalyzerState.appliedFilter = v;
    },
    sortColumn: function sortColumn(v) {
      adsAnalyzerState.sortColumn = v;
    },
    sortAsc: function sortAsc(v) {
      adsAnalyzerState.sortAsc = v;
    },
    outputTable: function outputTable() {
      this.computeCalculatedTable();
    },
    calculatedTable: function calculatedTable() {
      this.computeVisibleTable();
      this.computeTips();
    },
    viewSettings: function viewSettings() {
      this.computeVisibleTable();
    }
  },
  methods: {
    showPremiumOverlay: function showPremiumOverlay() {
      _overlayModel2.default.show({
        component: _PremiumOverlay2.default,
        props: {},
        on: {}
      });
    },
    i18n: function i18n() {
      return (0, _i18n3.default)().ads;
    },
    doWorkerTask: function doWorkerTask(method, args) {
      _logger2.default.startLagDetector('ads-' + method, 1000);
      var promise = void 0;
      if (this.webWorkerEnabled) {
        promise = webWorkerQueue.doWorkerTask(method, args);
      } else {
        promise = new _promise2.default(function (resolve, reject) {
          args = JSON.parse((0, _stringify2.default)(args));
          resolve(_adsAnalyzer2.default[method].apply(_adsAnalyzer2.default, (0, _toConsumableArray3.default)(args)));
        });
      }
      return promise.then(function (result) {
        _logger2.default.stopLagDetector('ads-' + method);
        return result;
      }).catch(function (error) {
        _logger2.default.stopLagDetector('ads-' + method);
        _logger2.default.addTag('ads-error', 'ads-' + method + "-error");
        throw error;
      });
    },
    processInputTable: function processInputTable(table) {
      console.log("INPUT TABLE", table);
      if (table.type != "adPerformance") {
        this.state = "wrongType";
        return;
      }
      this.computeCategories();
      this.computeOutputTable();
    },
    cellText: function cellText(cell) {
      if (typeof cell == "number") return this.addThousandSeparator(cell % 100 == 0 ? cell / 100 : (cell / 100).toFixed(2));
      return cell;
    },
    addThousandSeparator: function addThousandSeparator(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + "\xA0" + '$2');
      }
      return x1 + x2;
    },
    toggleSort: function toggleSort(columnName) {
      if (columnName == this.sortColumn) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortColumn = columnName;
      }
    },
    saveCSV: function saveCSV() {
      if (!this.premium) return this.showPremiumOverlay();
      var table = this.visibleTable;
      var data = (0, _csv.generateCSV)((0, _extends3.default)({}, table, {
        columnNames: table.displayColumnNames
      }), ',', this.cellText);
      var blob = new Blob([data], { type: 'text/csv' });
      var filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".csv";
      (0, _save.saveBlob)(blob, filename);
    },
    saveTSV: function saveTSV() {
      if (!this.premium) return this.showPremiumOverlay();
      var table = this.visibleTable;
      var data = (0, _csv.generateCSV)((0, _extends3.default)({}, table, {
        columnNames: table.displayColumnNames
      }), '\t', this.cellText);
      var blob = new Blob([data], { type: 'text/tsv' });
      var filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".tsv";
      (0, _save.saveBlob)(blob, filename);
    },
    applyFilter: function applyFilter() {
      var filterJson = (0, _stringify2.default)(this.filter);
      console.log("APPLY FILTER", filterJson);
      this.appliedFilter = JSON.parse(filterJson);
    },
    updateFilter: function updateFilter() {
      var filterJson = (0, _stringify2.default)(this.filter);
      console.log("UPDATE FILTER", filterJson);
      this.appliedFilter = JSON.parse(filterJson);
    },
    clearFilter: function clearFilter() {
      this.appliedFilter = null;
    },
    computeCategories: function computeCategories() {
      var _this = this;

      var inputTable = this.inputTable;
      if (!inputTable) return this.categories = null;
      this.state = "computing";
      this.categories = null;
      return this.doWorkerTask("findCategories", [inputTable]).then(function (result) {
        return _this.categories = result;
      });
    },
    computeOutputTable: function computeOutputTable() {
      var _this2 = this;

      var inputTable = this.inputTable;
      if (!inputTable) return null;
      this.state = "computing";
      this.outputTable = null;
      return this.doWorkerTask("preformAnalysis", [inputTable, this.query]).then(function (result) {
        return _this2.outputTable = result;
      });
    },
    computeCalculatedTable: function computeCalculatedTable() {
      var _this3 = this;

      var outputTable = this.outputTable;
      if (!outputTable) return this.calculatedTable = null;
      this.state = "computing";
      this.calculatedTable = null;
      return this.doWorkerTask("calculateTable", [outputTable]).then(function (result) {
        return _this3.calculatedTable = result;
      });
    },
    computeVisibleTable: function computeVisibleTable() {
      var _this4 = this;

      var calculatedTable = this.calculatedTable;
      var viewSettings = this.viewSettings;
      if (!calculatedTable) return this.visibleTable = null;
      this.state = "filtering";
      this.visibleTable = null;
      return this.doWorkerTask("prepareTableView", [calculatedTable, viewSettings]).then(function (result) {
        result.displayColumnNames = (0, _i18n3.default)().translateColumnNames(result.columnNames);
        _this4.visibleTable = result;
        _this4.state = result ? "done" : "failed";
      });
    },
    computeTips: function computeTips() {
      var _this5 = this;

      var inputTable = this.inputTable;
      var outputTable = this.calculatedTable;
      this.tips = [];
      return this.doWorkerTask("generateTips", [inputTable, outputTable]).then(function (result) {
        _this5.tips = result;
      });
    },
    openSaveViewDialog: function openSaveViewDialog() {
      this.visibleDialog = "saveView";
    },
    openLoadViewDialog: function openLoadViewDialog() {
      this.visibleDialog = "loadView";
    },
    closeDialog: function closeDialog() {
      this.visibleDialog = null;
    },
    loadView: function loadView(view) {
      console.log("LOAD view", view);
      this.filter = view.filter;
      if (view.filterApplied) this.appliedFilter = this.filter;
      this.sortColumn = view.sortColumn;
      this.sortAsc = view.sortAsc;
    },
    showTip: function showTip(tip) {
      if (tip.filter) {
        this.filter = tip.filter;
        this.enableFilter = true;
        this.applyFilter();
      }
    }
  },
  created: function created() {
    this.processInputTable(this.inputTable);
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(248);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(247);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _LoadFile = __webpack_require__(422);

var _LoadFile2 = _interopRequireDefault(_LoadFile);

var _WordsAnalyzer = __webpack_require__(402);

var _WordsAnalyzer2 = _interopRequireDefault(_WordsAnalyzer);

var _AdsAnalyzer = __webpack_require__(397);

var _AdsAnalyzer2 = _interopRequireDefault(_AdsAnalyzer);

var _WorkerQueue = __webpack_require__(70);

var _WorkerQueue2 = _interopRequireDefault(_WorkerQueue);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _csvParser = __webpack_require__(218);

var _csvParser2 = _interopRequireDefault(_csvParser);

var _csvParser3 = __webpack_require__(482);

var _csvParser4 = _interopRequireDefault(_csvParser3);

var _csv = __webpack_require__(53);

var _save = __webpack_require__(54);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.csvWorker = _csvParser4.default;


var inputLanguagesObservable = _api2.default.observable(['config', "allInputLanguages"]);
var inputLanguagesPromise = new _promise2.default(function (resolve, reject) {
  inputLanguagesObservable.observe({
    set: function set(value) {
      console.log("INPUT LANGUAGES LOADED", value);
      resolve(value);
    }
  });
});

var inputConfigPromise = inputLanguagesPromise.then(function (inputLanguages) {
  var inputConfig = _config2.default.input;
  console.log("INPUT CONFIG", inputConfig);

  for (var typeName in inputConfig) {
    inputConfig[typeName].languages = [];
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(inputLanguages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var inputLang = _step.value;

      var inputLangConfig = inputLang.config;
      for (var _typeName in inputLangConfig) {
        var langType = inputLangConfig[_typeName];
        var translation = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(langType.columnTranslation), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var transItem = _step2.value;

            translation[transItem.from] = transItem.to;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        console.log("ST", _typeName, inputLang.name, translation);
        var lang = {
          lang: inputLang.name,
          columnTranslation: translation,
          summaryRegex: langType.summaryRegex.map(function (r) {
            return new RegExp(r, "i");
          })
        };
        inputConfig[_typeName].languages.push(lang);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  console.log("INPUT CONFIG WITH LANGS", inputConfig);

  return inputConfig;
});

var webWorkerQueue = new _WorkerQueue2.default(_csvParser4.default);

exports.default = {
  name: 'csv-analyzer',
  metaInfo: function metaInfo() {
    return {
      title: this.i18n().title[this.analyzer.type]
    };
  },

  props: {
    analyzer: {
      type: Object,
      default: function _default() {
        return {
          type: "words"
        };
      }
    }
  },
  components: {
    LoadFile: _LoadFile2.default,
    WordsAnalyzer: _WordsAnalyzer2.default,
    AdsAnalyzer: _AdsAnalyzer2.default
  },
  data: function data() {
    return {
      inputData: null,
      inputTable: null,
      state: "ready",
      webWorkerEnabled: localStorage.noWorker ? false : typeof Worker !== "undefined",
      searchText: "",
      searchFieldKeyListener: null,
      inputFileError: null
    };
  },

  watch: {
    inputData: function inputData(data) {
      this.computeInputTable();
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().csvAnalyzer;
    },
    global_i18n: function global_i18n() {
      return (0, _i18n3.default)();
    },
    handleFileLoaded: function handleFileLoaded(file) {
      var ext = file.name.split('.').pop();
      if (_config2.default.files.acceptedExtensions.indexOf(ext) == -1) this.inputFileError = { type: 'extension', ext: ext };
      if (file.type && _config2.default.files.acceptedMime.indexOf(file.type) == -1) this.inputFileError = { type: 'type', fileType: file.type };
      if (this.inputFileError) {
        console.trace("INPUT FILE ERROR");
        return;
      }
      this.inputTable = null;

      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        var data = e.target.result;
        vm.inputData = {
          fileName: file.name,
          text: data,
          format: file.name.split('.').pop()
        };
      };
      reader.readAsText(file);
    },
    doWorkerTask: function doWorkerTask(method, args) {
      _logger2.default.startLagDetector('csv-' + method, 1000);
      var promise = void 0;
      if (this.webWorkerEnabled) {
        promise = webWorkerQueue.doWorkerTask(method, args);
      } else {
        promise = new _promise2.default(function (resolve, reject) {
          args = JSON.parse((0, _stringify2.default)(args));
          resolve(_csvParser2.default[method].apply(_csvParser2.default, (0, _toConsumableArray3.default)(args)));
        });
      }
      return promise.then(function (result) {
        _logger2.default.stopLagDetector('csv-' + method);
        return result;
      }).catch(function (error) {
        _logger2.default.stopLagDetector('csv-' + method);
        _logger2.default.addTag('csv-error', 'csv-' + method + "-error");
        throw error;
      });
    },
    computeInputTable: function computeInputTable() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.inputData;

                if (data) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', null);

              case 3:

                _this.inputTable = null;
                _this.state = "parsing";

                _context.t0 = _this;
                _context.t1 = data;
                _context.next = 9;
                return inputConfigPromise;

              case 9:
                _context.t2 = _context.sent;
                _context.t3 = [_context.t1, _context.t2];

                _context.t4 = function (table) {

                  _this.parsing = false;
                  if (table.columnNames.length <= 1) {
                    alert("Unknown file format");
                    return _this.inputTable = null;
                  }
                  console.log("PARSED TABLE", table);
                  _this.state = "parsed";
                  _this.inputTable = table;
                };

                _context.t5 = function (error) {
                  console.error("INPUT FILE ERROR", error);
                  _this.inputFileError = { type: "format" };
                };

                return _context.abrupt('return', _context.t0.doWorkerTask.call(_context.t0, "parseData", _context.t3).then(_context.t4).catch(_context.t5));

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSearchChange: function handleSearchChange(ev, now) {
      var _this2 = this;

      var value = ev.target.value;
      if (value == this.searchText) return;
      if (now) {
        this.searchText = value;
        return;
      }
      this.lastSearchChange = Date.now();
      setTimeout(function () {
        if (Date.now() > _config2.default.view.searchDelay) {
          _this2.searchText = ev.target.value;
        }
      }, _config2.default.view.searchDelay + 20);
    },
    retry: function retry() {
      this.inputFileError = null;
      this.state = "ready";
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    this.searchFieldKeyListener = function (ev) {
      var ck = ev.keyCode ? ev.keyCode : ev.which;
      if ((ev.ctrlKey || ev.metaKey) && ck == 70 || ck == 191) {
        ev.preventDefault();
        ev.stopPropagation();
        document.querySelector("input#search").focus();
      }
    };
    window.addEventListener('keydown', this.searchFieldKeyListener);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.searchFieldKeyListener);
  }
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'left-menu',
  data: function data() {
    return {};
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().menu;
    }
  }
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(34);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _PhoneInput = __webpack_require__(99);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _CountryInput = __webpack_require__(148);

var _CountryInput2 = _interopRequireDefault(_CountryInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hello',
  components: { PhoneInput: _PhoneInput2.default, CountryInput: _CountryInput2.default },
  data: function data() {
    return {
      state: 'loading',
      editedUserData: {},
      required: true,
      phoneNumberInvalid: false,
      countryInvalid: false,
      error: null,
      allFields: ['firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'addressLine1', 'addressLine2', 'postalCode', 'taxNumber'],
      requiredFields: ['firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'city', 'addressLine1']
    };
  },

  reactive: {
    user: ['user', 'user']
  },
  computed: {
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    },
    userData: function userData() {
      if (!this.user) return null;
      var data = JSON.parse((0, _stringify2.default)(this.user.userData || {}));
      return data;
    }
  },
  watch: {
    userData: function userData() {
      if (!this.userData) return;
      this.editedUserData = JSON.parse((0, _stringify2.default)(this.userData));
      var fields = this.allFields;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (!this.editedUserData[field]) this.editedUserData[field] = '';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.editedUserData['phoneNumber'] != '' && this.editedUserData['country'] == '') {
        var prefix = this.editedUserData['phoneNumber'].split(' ')[0];
        var found = countries.filter(function (c) {
          return c.dial_code == prefix;
        })[0];
        this.editedUserData['country'] = found ? found.code : "";
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _field = _step2.value;

          if (this.editedUserData[_field] != '') {
            var el = this.$refs[_field];
            if (el) el = el.parentElement;
            if (el) el.setAttribute('class', el.getAttribute('class').replace('is-invalid', '') + ' is-dirty');
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.state = 'ready';
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().order;
    },
    user_i18n: function user_i18n() {
      return (0, _i18n3.default)().user.changeUserData;
    },
    back: function back() {
      this.$router.back();
    },
    buy: function buy() {
      var anyEmpty = false;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.requiredFields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var field = _step3.value;
          if (this.editedUserData[field].trim() == '') {
            var el = this.$refs[field][0];
            if (el) el = el.parentElement;
            if (el) el.setAttribute('class', el.getAttribute('class') + ' is-invalid');
            console.log("EMPTY FIELD", field);
            anyEmpty = true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (anyEmpty) {
        return;
      }

      var phoneNumber = this.editedUserData.phoneNumber;
      var sep = phoneNumber.indexOf(' ');
      console.log("PN", phoneNumber, sep);
      if (sep == -1 || phoneNumber.slice(0, sep).trim().length == 0 || phoneNumber.slice(sep + 1).trim().length < 3 || !phoneNumber.match(/^[0-9 #+-]+$/)) {
        console.log("PN INVALID", phoneNumber.slice(0, sep).trim().length == 0, phoneNumber.slice(sep + 1).trim().length < 3, !phoneNumber.match(/^[0-9 #+-]+$/));
        this.phoneNumberInvalid = false;
        this.phoneNumberInvalid = true;
        this.required = true;
        return;
      }

      this.state = "working";
      var productId = "semgregate";
      var planId = "semgregate_gold";
      var price = { value: 1, currency: "USD" };
      var orderPromise = _api2.default.request(['subscription', 'createOrder'], productId, planId, price);
      var saveUserPromise = _api2.default.request(['foxyCart', 'saveUser'], this.editedUserData);
      _promise2.default.all([orderPromise, saveUserPromise]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
            orderId = _ref2[0],
            foxyUserId = _ref2[1],
            checkoutLink = _ref2[2];

        console.log("ORDER ID:", orderId);
        console.log("Foxy USER ID", foxyUserId);

        var startCheckoutPromise = _api2.default.request(['foxyCart', 'startSubscribeCheckout'], orderId, planId, productId, price);
        startCheckoutPromise.then(function (checkoutLink) {
          if (window.history) {
            history.pushState({}, window.location.href);
          }
          window.location.href = checkoutLink;
        });
      });
    }
  }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(20);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _LoadFileSmall = __webpack_require__(149);

var _LoadFileSmall2 = _interopRequireDefault(_LoadFileSmall);

var _BigTable = __webpack_require__(146);

var _BigTable2 = _interopRequireDefault(_BigTable);

var _BigTable3 = __webpack_require__(420);

var _BigTable4 = _interopRequireDefault(_BigTable3);

var _SaveView = __webpack_require__(145);

var _SaveView2 = _interopRequireDefault(_SaveView);

var _LoadView = __webpack_require__(144);

var _LoadView2 = _interopRequireDefault(_LoadView);

var _WordsLeftBar = __webpack_require__(426);

var _WordsLeftBar2 = _interopRequireDefault(_WordsLeftBar);

var _TopBar = __webpack_require__(142);

var _TopBar2 = _interopRequireDefault(_TopBar);

var _WorkerQueue = __webpack_require__(70);

var _WorkerQueue2 = _interopRequireDefault(_WorkerQueue);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _wordsAnalyzer = __webpack_require__(105);

var _wordsAnalyzer2 = _interopRequireDefault(_wordsAnalyzer);

var _wordsAnalyzer3 = __webpack_require__(483);

var _wordsAnalyzer4 = _interopRequireDefault(_wordsAnalyzer3);

var _csv = __webpack_require__(53);

var _save = __webpack_require__(54);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PremiumOverlay = __webpack_require__(66);

var _PremiumOverlay2 = _interopRequireDefault(_PremiumOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.analyzerWorker = _wordsAnalyzer4.default;


var webWorkerQueue = new _WorkerQueue2.default(_wordsAnalyzer4.default);

var wordsAnalyzerState = new _vue2.default({
  data: {
    query: JSON.parse((0, _stringify2.default)(_config2.default.logic.words.defaultQuery)),
    filter: JSON.parse((0, _stringify2.default)(_config2.default.logic.defaultFilter)),
    sortColumn: "Count",
    sortAsc: false,
    appliedFilter: null
  }
});

exports.default = {
  name: 'words-analyzer',
  props: {
    inputTable: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    searchText: {
      type: String
    }
  },
  components: {
    LoadFileSmall: _LoadFileSmall2.default,
    BigTable: _BigTable2.default,
    BigTable2: _BigTable4.default,
    SaveView: _SaveView2.default,
    LoadView: _LoadView2.default,
    WordsLeftBar: _WordsLeftBar2.default,
    TopBar: _TopBar2.default
  },
  metaInfo: {
    title: 'Words'
  },
  data: function data() {
    return {
      outputTable: null,
      calculatedTable: null,
      visibleTable: null,
      state: "ready",
      query: wordsAnalyzerState.query,
      sortColumn: wordsAnalyzerState.sortColumn,
      sortAsc: wordsAnalyzerState.sortAsc,
      filter: wordsAnalyzerState.filter,
      appliedFilter: wordsAnalyzerState.appliedFilter,
      webWorkerEnabled: localStorage.noWorker ? false : typeof Worker !== "undefined",
      categories: null,
      lastSearchChange: 0,
      visibleDialog: null,
      tips: [],
      tipsExpanded: true,
      filterExpanded: true,
      enableFilter: false,
      maxVisibleRows: _config2.default.view.maxVisibleRows,
      testEnvironment: localStorage.test
    };
  },

  computed: {
    limitedVisibleTable: function limitedVisibleTable() {
      var viewSettings = this.viewSettings;
      var visibleTable = this.visibleTable;
      if (!visibleTable) return null;
      if (this.premium) {
        return (0, _extends3.default)({}, visibleTable, {
          rows: visibleTable.rows.slice(0, +viewSettings.maxVisibleRows || _config2.default.view.maxVisibleRows)
        });
      } else {
        return (0, _extends3.default)({}, visibleTable, {
          rows: visibleTable.rows.slice(0, 20)
        });
      }
    },
    viewSettings: function viewSettings() {
      return {
        sortBy: this.sortColumn,
        sortAsc: this.sortAsc,
        filter: this.appliedFilter,
        enableFilter: true,
        searchText: this.searchText,
        maxVisibleRows: this.maxVisibleRows
      };
    },
    saveableView: function saveableView() {
      return {
        query: this.query,
        sortColumn: this.sortColumn,
        sortAsc: this.sortAsc,
        filter: this.appliedFilter || this.filter,
        filterApplied: !!this.appliedFilter
      };
    },
    premium: function premium() {
      return _api2.default.session.premium;
    },
    tableEndInfoType: function tableEndInfoType() {
      if (this.visibleTable.rows.length == this.limitedVisibleTable.rows.length) return null;
      if (!this.premium) return "premium";
      return "download";
    },
    tableEndInfo: function tableEndInfo() {
      var type = this.tableEndInfoType;
      if (!type) return null;
      console.log("I18n", this.i18n());
      return {
        text: this.i18n().endInfo[type]({
          allRows: this.visibleTable.rows.length,
          visibleRows: this.limitedVisibleTable.rows.length
        }),
        type: type
      };
    }
  },
  watch: {
    enableFilter: function enableFilter(v) {
      if (!v && this.appliedFilter) this.clearFilter();
    },
    inputTable: function inputTable(table) {
      this.processInputTable(table);
    },
    query: function query(v) {
      wordsAnalyzerState.query = v;
      this.computeOutputTable();
    },
    filter: function filter(v) {
      wordsAnalyzerState.filter = v;
    },
    appliedFilter: function appliedFilter(v) {
      wordsAnalyzerState.appliedFilter = v;
    },
    sortColumn: function sortColumn(v) {
      wordsAnalyzerState.sortColumn = v;
    },
    sortAsc: function sortAsc(v) {
      wordsAnalyzerState.sortAsc = v;
    },
    outputTable: function outputTable() {
      this.computeCalculatedTable();
    },
    calculatedTable: function calculatedTable() {
      this.computeVisibleTable();
      this.computeTips();
    },
    viewSettings: function viewSettings() {
      this.computeVisibleTable();
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().words;
    },
    doWorkerTask: function doWorkerTask(method, args) {
      _logger2.default.startLagDetector('words-' + method, 1000);
      var promise = void 0;
      if (this.webWorkerEnabled) {
        promise = webWorkerQueue.doWorkerTask(method, args);
      } else {
        promise = new _promise2.default(function (resolve, reject) {
          args = JSON.parse((0, _stringify2.default)(args));
          resolve(_wordsAnalyzer2.default[method].apply(_wordsAnalyzer2.default, (0, _toConsumableArray3.default)(args)));
        });
      }
      return promise.then(function (result) {
        _logger2.default.stopLagDetector('words-' + method);
        return result;
      }).catch(function (error) {
        _logger2.default.stopLagDetector('words-' + method);
        _logger2.default.addTag('words-error', 'words-' + method + "-error");
        throw error;
      });
    },
    processInputTable: function processInputTable(table) {
      console.log("INPUT TABLE", table);
      if (table) {
        var ncolumns = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.query.wordsColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var column = _step.value;

            if (table.columnNames.indexOf(column) != -1) ncolumns.push(column);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (ncolumns.length == 0) {
          var wc = _config2.default.logic.words.wordColumnsByType[table.type] || ['Query'];
          this.query.wordsColumns = wc.filter(function (c) {
            return table.columnNames.indexOf(c) != -1;
          });
        } else {
          this.query.wordsColumns = ncolumns;
        }
      }
      this.computeCategories();
      this.computeOutputTable();
    },
    cellText: function cellText(cell) {
      if (typeof cell == "number") return this.addThousandSeparator(cell % 100 == 0 ? cell / 100 : (cell / 100).toFixed(2));
      return cell;
    },
    addThousandSeparator: function addThousandSeparator(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + "\xA0" + '$2');
      }
      return x1 + x2;
    },
    toggleSort: function toggleSort(columnName) {
      if (columnName == this.sortColumn) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortColumn = columnName;
      }
    },
    showPremiumOverlay: function showPremiumOverlay() {
      _overlayModel2.default.show({
        component: _PremiumOverlay2.default,
        props: {},
        on: {}
      });
    },
    saveCSV: function saveCSV() {
      if (!this.premium) return this.showPremiumOverlay();
      var table = this.visibleTable;
      var data = (0, _csv.generateCSV)((0, _extends3.default)({}, table, {
        columnNames: table.displayColumnNames
      }), ',', this.cellText);
      var blob = new Blob([data], { type: 'text/csv' });
      var filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".csv";
      (0, _save.saveBlob)(blob, filename);
    },
    saveTSV: function saveTSV() {
      if (!this.premium) return this.showPremiumOverlay();
      var table = this.visibleTable;
      var data = (0, _csv.generateCSV)((0, _extends3.default)({}, table, {
        columnNames: table.displayColumnNames
      }), '\t', this.cellText);
      var blob = new Blob([data], { type: 'text/tsv' });
      var filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".tsv";
      (0, _save.saveBlob)(blob, filename);
    },
    applyFilter: function applyFilter() {
      var filterJson = (0, _stringify2.default)(this.filter);
      console.log("APPLY FILTER", filterJson);
      this.appliedFilter = JSON.parse(filterJson);
    },
    updateFilter: function updateFilter() {
      var filterJson = (0, _stringify2.default)(this.filter);
      console.log("UPDATE FILTER", filterJson);
      this.appliedFilter = JSON.parse(filterJson);
    },
    clearFilter: function clearFilter() {
      this.appliedFilter = null;
    },
    computeOutputTable: function computeOutputTable() {
      var _this = this;

      var query = this.query;
      var inputTable = this.inputTable;
      console.log("COMPUTE OUTPUT", query, inputTable);
      if (!inputTable) return null;
      if (query.wordsColumns.length == 0) return null;
      this.state = "computing";
      this.outputTable = null;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(query.wordsColumns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var col = _step2.value;

          if (inputTable.columnNames.indexOf(col) == -1) {
            console.error("COLUMN NOT FOUND", col);
            return null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.doWorkerTask("preformAnalysis", [inputTable, query]).then(function (result) {
        return _this.outputTable = result;
      });
    },
    computeCategories: function computeCategories() {
      var _this2 = this;

      var inputTable = this.inputTable;
      if (!inputTable) return this.categories = null;
      this.state = "computing";
      this.categories = null;
      return this.doWorkerTask("findCategories", [inputTable]).then(function (result) {
        return _this2.categories = result;
      });
    },
    computeCalculatedTable: function computeCalculatedTable() {
      var _this3 = this;

      var outputTable = this.outputTable;
      if (!outputTable) return this.calculatedTable = null;
      this.state = "computing";
      this.calculatedTable = null;
      return this.doWorkerTask("calculateTable", [outputTable]).then(function (result) {
        return _this3.calculatedTable = result;
      });
    },
    computeVisibleTable: function computeVisibleTable() {
      var _this4 = this;

      var calculatedTable = this.calculatedTable;
      var viewSettings = this.viewSettings;
      var inputTable = this.inputTable;
      if (!calculatedTable || !this.inputTable) return this.visibleTable = null;
      this.state = "filtering";
      this.visibleTable = null;
      return this.doWorkerTask("prepareTableView", [calculatedTable, viewSettings]).then(function (result) {
        result.displayColumnNames = (0, _i18n3.default)().translateColumnNames(result.columnNames);
        _this4.visibleTable = result;
        _this4.state = result ? "done" : "failed";
      });
    },
    computeTips: function computeTips() {
      var _this5 = this;

      var inputTable = this.inputTable;
      var outputTable = this.calculatedTable;
      this.tips = [];
      if (!inputTable || !outputTable) return;
      return this.doWorkerTask("generateTips", [inputTable, outputTable]).then(function (result) {
        _this5.tips = result;
      });
    },
    openSaveViewDialog: function openSaveViewDialog() {
      this.visibleDialog = "saveView";
    },
    openLoadViewDialog: function openLoadViewDialog() {
      this.visibleDialog = "loadView";
    },
    closeDialog: function closeDialog() {
      this.visibleDialog = null;
    },
    loadView: function loadView(view) {
      console.log("LOAD view", view);
      this.query = view.query;
      this.filter = view.filter;
      if (view.filterApplied) this.appliedFilter = this.filter;
      this.sortColumn = view.sortColumn;
      this.sortAsc = view.sortAsc;
    },
    showTip: function showTip(tip) {
      if (tip.filter) {
        this.filter = tip.filter;
        this.enableFilter = true;
        this.applyFilter();
      }
    }
  },
  created: function created() {
    this.processInputTable(this.inputTable);
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FilterExpression = __webpack_require__(67);

var _FilterExpression2 = _interopRequireDefault(_FilterExpression);

var _SimpleFilterExpression = __webpack_require__(141);

var _SimpleFilterExpression2 = _interopRequireDefault(_SimpleFilterExpression);

var _AdsQuery = __webpack_require__(404);

var _AdsQuery2 = _interopRequireDefault(_AdsQuery);

var _Checkbox = __webpack_require__(147);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "words-left-bar",
  props: {
    query: {
      type: Object
    },
    filter: {
      type: Object
    },
    appliedFilter: {
      type: Object
    },
    inputColumnNames: {
      type: Array
    },
    calculatedColumnNames: {
      type: Array
    },
    categories: {
      type: Array
    },
    enableFilter: {
      type: Boolean
    }
  },
  components: {
    FilterExpression: _FilterExpression2.default,
    SimpleFilterExpression: _SimpleFilterExpression2.default,
    AdsQuery: _AdsQuery2.default,
    Checkbox: _Checkbox2.default
  },
  enableFilter: {
    type: Boolean
  },
  data: function data() {
    return {
      queryExpand: true,
      filterExpand: true
    };
  },

  computed: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().ads.query;
    },
    toggleQueryExpand: function toggleQueryExpand() {
      this.queryExpand = !this.queryExpand;
    },
    toggleFilterExpand: function toggleFilterExpand() {
      this.filterExpand = !this.filterExpand;
    },
    handleFilterUpdate: function handleFilterUpdate(f) {
      this.$emit("update:filter", f);
    },
    handleQueryUpdate: function handleQueryUpdate(q) {
      this.$emit("update:query", q);
    },
    handleEnableFilterUpdate: function handleEnableFilterUpdate(v) {
      this.$emit("update:enableFilter", v);
    }
  }
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _adsAnalyzer = __webpack_require__(104);

var _adsAnalyzer2 = _interopRequireDefault(_adsAnalyzer);

var _MultiSelect = __webpack_require__(150);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ads-query',
  components: { MultiSelect: _MultiSelect2.default },
  props: {
    columns: {
      type: Array
    },
    categories: {
      type: Array
    },
    query: {
      type: Object,
      default: function _default() {
        return {
          categories: 'all',
          aggregateUrls: true
        };
      }
    }
  },
  data: function data() {
    return {
      aggregateUrls: this.query.aggregateUrls,
      selectedCategories: []
    };
  },

  computed: {},
  watch: {
    categories: function categories() {
      this.selectedCategories = JSON.parse((0, _stringify2.default)(this.categories));
    },
    query: function query(q) {
      this.aggregateUrls = this.query.aggregateUrls;
      this.selectedCategories = !this.query.categories || this.query.categories == 'all' ? JSON.parse((0, _stringify2.default)(this.categories)) : JSON.parse((0, _stringify2.default)(this.query.categories));
    },
    aggregateUrls: function aggregateUrls(v) {
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.aggregateUrls = v;
      this.$emit("update:query", query);
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().ads.query;
    },
    translateColumn: function translateColumn(col) {
      return (0, _i18n3.default)().translateColumnName(col);
    },
    toggleAggregateUrls: function toggleAggregateUrls() {
      this.aggregateUrls = !this.aggregateUrls;
    },
    updateCategories: function updateCategories(index, value) {
      this.selectedCategories[index].options = value;
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.categories = JSON.parse((0, _stringify2.default)(this.selectedCategories));
      this.$emit("update:query", query);
    }
  },
  created: function created() {
    this.selectedCategories = JSON.parse((0, _stringify2.default)(this.categories));
  }
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNan = __webpack_require__(71);

var _isNan2 = _interopRequireDefault(_isNan);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inivisibleRowsCount = 23;
var clusterSize = 23;

var endInfoHeight = 45;

var getElementPosition = function getElementPosition(element) {
  var o = element;
  var x = 0;
  var y = 0;
  while (true) {
    x += o.offsetLeft;
    y += o.offsetTop;
    o = o.offsetParent;
    if (!o) return {
      x: x,
      y: y
    };
    if (o.scrollLeft) x -= o.scrollLeft;
    if (o.scrollTop) y -= o.scrollTop;
  }
};

exports.default = {
  name: 'AdsTable',
  props: {
    table: {
      type: Object
    },
    sortColumn: {
      type: String
    },
    sortAsc: {
      type: Boolean
    },
    found: {
      type: Array
    },
    rowHeight: {
      type: Number,
      default: function _default() {
        return 35;
      }
    },
    firstColumnWidth: {
      type: Number,
      default: function _default() {
        return 200;
      }
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    endInfo: {}
  },
  data: function data() {
    return {
      scrollTop: 0,
      scrollLeft: 0,
      scrollHeight: 0,
      visibleFirstColumnWidth: 0,
      savedScrollLeft: 0,
      extender: null
    };
  },

  computed: {
    visibleRowsRange: function visibleRowsRange() {
      var firstVisibleRow = this.scrollTop / this.rowHeight | 0;
      var lastVisibleRow = (this.scrollTop + this.scrollHeight) / this.rowHeight | 0;
      return { begin: firstVisibleRow, end: lastVisibleRow };
    },
    renderedRowsRange: function renderedRowsRange() {
      var _visibleRowsRange = this.visibleRowsRange,
          begin = _visibleRowsRange.begin,
          end = _visibleRowsRange.end;

      var extendedBegin = Math.max(0, begin - inivisibleRowsCount);
      var extendedEnd = Math.max(0, end + inivisibleRowsCount);
      var extendedBeginCluster = extendedBegin / clusterSize | 0;
      var extendedEndCluster = extendedEnd / clusterSize | 0;
      var calculatedBegin = extendedBeginCluster * clusterSize;
      var calculatedEnd = extendedEndCluster * clusterSize;
      return {
        begin: calculatedBegin,
        end: calculatedEnd
      };
    },
    renderedRows: function renderedRows() {
      var _renderedRowsRange = this.renderedRowsRange,
          begin = _renderedRowsRange.begin,
          end = _renderedRowsRange.end;

      return this.table.rows.slice(begin, end);
    },
    topMargin: function topMargin() {
      return Math.max(0, this.renderedRowsRange.begin * this.rowHeight);
    },
    bottomMargin: function bottomMargin() {
      return Math.max(0, (this.table.rows.length - this.renderedRowsRange.end) * this.rowHeight + (this.endInfo ? endInfoHeight : 0));
    }
  },
  watch: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().ads;
    },
    cellText: function cellText(cell) {
      if (cell == Infinity) return "--";
      if (cell == -Infinity) return "--";
      if ((0, _isNan2.default)(cell)) return "--";
      if (typeof cell == "number") return this.addThousandSeparator(cell % 100 == 0 ? cell / 100 : (cell / 100).toFixed(2));
      return cell;
    },
    addThousandSeparator: function addThousandSeparator(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + "\xA0" + '$2');
      }
      return x1 + x2;
    },
    handleScroll: function handleScroll() {
      this.scrollTop = this.$refs.scroller.scrollTop;
      this.scrollLeft = this.$refs.scroller.scrollLeft;
      this.extender = null;
    },
    resize: function resize() {
      console.log("RESIZE!");
      this.scrollHeight = this.$refs.scroller.clientHeight;
      var thead = this.$refs.firstHeadRow;
      var otherWidth = 0;
      for (var el = thead.firstElementChild.nextElementSibling; el; el = el.nextElementSibling) {
        otherWidth += el.offsetWidth;
      }
      var spaceWidth = this.$refs.scroller.clientWidth - 5;
      var remainingWidth = spaceWidth - otherWidth;
      console.log("FIRST COLUMN WIDTH", this.firstColumnWidth);
      var firstColumnWidth = Math.max(this.firstColumnWidth, remainingWidth);
      console.log("REMAINING WIDTH", remainingWidth, "SPACE WIDTH", spaceWidth, "COLUMNS WIDTH", otherWidth);
      this.visibleFirstColumnWidth = firstColumnWidth;
    },
    handleMouseOver: function handleMouseOver(event, cell, colId) {
      return;
      var target = event.target;
      while (target && !target.classList.contains('cell')) {
        target = target.parentElement;
      }var pos = getElementPosition(target);
      var holderPos = getElementPosition(this.$refs.holder);
      var y = pos.y - holderPos.y - this.$refs.scroller.scrollTop + this.rowHeight;
      var x = pos.x - holderPos.x - this.$refs.scroller.scrollLeft + 50;
      if (y + this.rowHeight > this.$refs.scroller.clientHeight) {
        y -= this.rowHeight * 2;
      }
      if (x + 150 > this.$refs.scroller.clientHeight) {
        x -= 150;
      }
      this.extender = {
        x: x, y: y,
        w: target.clientWidth,
        paddingLeft: window.getComputedStyle(target, null).getPropertyValue('padding-left'),
        cell: cell, colId: colId
      };
    },
    handleMouseOut: function handleMouseOut(event) {},
    toggleSort: function toggleSort(column) {
      this.$emit('toggleSort', column);
    },
    generateClass: function generateClass(text) {
      if (!text) return "cg-error";
      return text.toLowerCase().replace(/[^a-z]/g, '-');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.resizerLoop = function () {
      if (_this.finished) return;
      var w = _this.$refs.scroller.clientWidth;
      var h = _this.$refs.scroller.clientHeight;
      if (w != _this.width || h != _this.height) {
        _this.width = w;
        _this.height = h;
        _this.resize();
      }
      _this.resizerLoopTimeout = setTimeout(_this.resizerLoop, 200);
    };
    this.resizerLoop();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizerLoopTimeout !== undefined) {
      clearTimeout(this.resizerLoopTimeout);
    }
    this.finished = true;
  }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'change-email',
  data: function data() {
    return {
      newEmail: '',
      currentPassword: '',
      state: 'ready',
      required: false,
      error: null
    };
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.startEmailChange;
    },
    change: function change(e) {
      var _this = this;

      e.preventDefault();

      if (this.newEmail.trim() == '') {
        this.required = true;
        if (this.newEmail.trim() == '') {
          this.$refs.newEmail1.parentElement.setAttribute('class', this.$refs.newEmail1.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newEmail1.focus();
        }
        return;
      }

      this.state = "working";
      _api2.default.request(["emailPassword", "startEmailChange"], this.newEmail, this.currentPassword).then(function (result) {
        _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "ready";
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'change-password',
  data: function data() {
    return {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      state: 'ready',
      required: false,
      notMatch: false,
      error: null
    };
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.changePassword;
    },
    change: function change(e) {
      var _this = this;

      e.preventDefault();

      if (this.oldPassword.trim() == '' || this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
        this.required = true;
        if (this.newPassword2.trim() == '') {
          this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword2.focus();
        }
        if (this.newPassword1.trim() == '') {
          this.$refs.newPassword1.parentElement.setAttribute('class', this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword1.focus();
        }
        if (this.oldPassword.trim() == '') {
          this.$refs.oldPassword.parentElement.setAttribute('class', this.$refs.oldPassword.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.oldPassword.focus();
        }
        return;
      }

      this.notMatch = this.newPassword1 != this.newPassword2;
      if (this.notMatch) {
        this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.newPassword2.focus();
        return;
      }

      this.state = "working";
      logger.addPassword(this.oldPassword);
      logger.addPassword(this.newPassword1);
      _api2.default.request(["emailPassword", "updatePasswords"], this.oldPassword, this.newPassword1).then(function (result) {
        logger.removePassword(_this.oldPassword);
        logger.removePassword(_this.newPassword1);
        _this.state = "done";
      }).catch(function (error) {
        logger.removePassword(_this.oldPassword);
        logger.removePassword(_this.newPassword1);
        _this.error = error;
        _this.state = "ready";
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm-email',
  data: function data() {
    return {
      notMatch: false,
      error: null,
      state: 'loading',
      required: false,
      observable: null,
      keyState: false
    };
  },

  computed: {
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    },
    key: function key() {
      return this.$route.params.key;
    }
  },
  watch: {
    key: function key() {
      this.readKey();
    },
    keyState: function keyState(v) {
      var _this = this;

      if (this.state == 'loading') {
        if (!v) {
          this.state = 'notFound';
          return;
        }
        if (v.used) {
          this.state = 'used';
        } else if (v.expire < Date.now()) {
          this.state = 'expired';
        } else {
          this.state = "loading";
          _api2.default.request(["emailPassword", "finishEmailChange"], this.key).then(function (result) {
            _this.state = "done";
          }).catch(function (error) {
            _this.error = error;
            _this.state = "ready";
          });
        }
      }
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.finishEmailChange;
    },
    readKey: function readKey() {
      if (this.observable) this.observable.unbindProperty(this, "keyState");
      this.state = 'loading';
      this.observable = _api2.default.observable(['emailPassword', 'emailKey', this.key]);

      this.observable.bindProperty(this, "keyState");
    },
    exit: function exit() {
      this.$router.replace({ name: 'index' });
    }
  },
  created: function created() {
    this.readKey();
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm-register',
  data: function data() {
    return {
      notMatch: false,
      error: null,
      state: 'loading',
      required: false,
      observable: null,
      keyState: false
    };
  },

  computed: {
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    },
    key: function key() {
      return this.$route.params.key;
    }
  },
  watch: {
    key: function key() {
      this.readKey();
    },
    keyState: function keyState(v) {
      var _this = this;

      if (this.state == 'loading') {
        if (!v) {
          this.state = 'notFound';
          return;
        }
        if (v.used) {
          this.state = 'used';
        } else if (v.expired) {
          this.state = 'expired';
        } else {
          this.state = "loading";
          _api2.default.request(["emailPassword", "finishRegister"], this.key).then(function (result) {
            _this.state = "done";
          }).catch(function (error) {
            _this.error = error;
            _this.state = "ready";
          });
        }
      }
    },
    loggedIn: function loggedIn(v) {},
    resend: function resend(e) {
      var _this2 = this;

      e.preventDefault();

      this.state = "working";
      _api2.default.request(["emailPassword", "resendRegisterKey", this.keyState.email], this.email).then(function (result) {
        _this2.state = "resent";
      }).catch(function (error) {
        _this2.error = error;
        _this2.state = "ready";
        if (error == 'notFound') {
          _this2.$refs.email.parentElement.setAttribute('class', _this2.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this2.$refs.email.focus();
        }
      });
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.finishRegister;
    },
    readKey: function readKey() {
      if (this.observable) this.observable.unbindProperty(this, "keyState");
      this.state = 'loading';
      this.observable = _api2.default.observable(['emailPassword', 'emailKey', this.key]);

      this.observable.bindProperty(this, "keyState");
    },
    exit: function exit() {
      this.$router.replace({ name: 'index' });
    }
  },
  created: function created() {
    this.readKey();
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'login-form',
  metaInfo: {
    title: (0, _i18n3.default)().emailPassword.loginForm.title
  },
  data: function data() {
    return {
      state: "ready",
      error: null,
      email: "",
      password: "",
      required: false
    };
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.loginForm;
    },
    login: function login(e) {
      var _this = this;

      e.preventDefault();

      if (this.email.trim() == '' || this.password.trim() == '') {
        this.required = true;
        if (this.email.trim() == '') {
          this.$refs.email.parentElement.setAttribute('class', this.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.email.focus();
        }
        if (this.password.trim() == '') {
          this.$refs.password.parentElement.setAttribute('class', this.$refs.password.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.password.focus();
        }
        return;
      }

      this.state = "working";
      var password = this.password;
      _logger2.default.addPassword(password);
      _api2.default.request(["emailPassword", "login"], this.email, password).then(function (result) {
        _logger2.default.removePassword(password);
        _this.state = "done";
      }).catch(function (error) {
        _logger2.default.removePassword(password);
        _this.error = error;
        _this.state = "ready";
        if (error == 'notFound') {
          _this.$refs.email.parentElement.setAttribute('class', _this.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this.$refs.email.focus();
        }
        if (error == 'wrongPassword') {
          _this.$refs.password.parentElement.setAttribute('class', _this.$refs.password.parentElement.getAttribute('class') + ' is-invalid');
          _this.$refs.password.focus();
        }
      });
    },
    resetPassword: function resetPassword(e) {
      var _this2 = this;

      e.preventDefault();

      this.state = "working";
      _api2.default.request(["emailPassword", "startPasswordReset"], this.email).then(function (result) {
        _this2.state = "reset";
      }).catch(function (error) {
        _this2.error = error;
        _this2.state = "ready";
        if (error == 'notFound') {
          _this2.$refs.email.parentElement.setAttribute('class', _this2.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this2.$refs.email.focus();
        }
      });
    },
    resend: function resend(e) {
      var _this3 = this;

      e.preventDefault();

      this.state = "working";
      _api2.default.request(["emailPassword", "resendRegisterKey", this.email], this.email).then(function (result) {
        _this3.state = "resent";
      }).catch(function (error) {
        _this3.error = error;
        _this3.state = "ready";
        if (error == 'notFound') {
          _this3.$refs.email.parentElement.setAttribute('class', _this3.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this3.$refs.email.focus();
        }
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    window.lfvm = this;
  }
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _PhoneInput = __webpack_require__(99);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkPassword(pass) {
  var digits = /\d/.test(pass);
  var lower = /[a-z]/.test(pass);
  var upper = /[A-Z]/.test(pass);
  return pass.length >= 8 && digits && lower && upper;
}

exports.default = {
  name: 'register-form',
  metaInfo: {
    title: (0, _i18n3.default)().emailPassword.registerForm.title
  },
  components: {
    PhoneInput: _PhoneInput2.default
  },
  data: function data() {
    return {
      state: "ready",
      error: null,
      email: "",
      password: "",
      password2: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      phoneNumberInvalid: false,
      requiredFields: ['firstName', 'lastName', 'phoneNumber', 'email', 'password', 'password2'].reverse(),
      required: false,
      notMatch: false,
      captchaResponse: false,
      recaptchaSiteKey: "6LcqmTEUAAAAAD1gJH4UxsIMykUUxeDhf61DVCOR",
      recaptchaKey: null,
      passwordTooSimple: false
    };
  },

  computed: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.registerForm;
    },
    verified: function verified(response) {
      console.log("VERIFIED", response);
      this.recaptchaKey = response;
    },
    register: function register(e) {
      var _this = this;

      e.preventDefault();

      var anyEmpty = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.requiredFields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var fieldName = _step.value;
          if (this[fieldName].trim() == '') {
            anyEmpty = true;
            if (fieldName == "phoneNumber") {
              this.phoneNumberInvalid = true;
              continue;
            }
            var el = this.$refs[fieldName];
            el.parentElement.setAttribute('class', el.parentElement.getAttribute('class') + ' is-invalid');
            el.focus();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (anyEmpty) {
        this.required = true;
        return;
      }

      var sep = this.phoneNumber.indexOf(' ');
      console.log("PN", this.phoneNumber, sep);
      if (sep == -1 || this.phoneNumber.slice(0, sep).trim().length == 0 || this.phoneNumber.slice(sep + 1).trim().length < 3 || !this.phoneNumber.match(/^[0-9 #+-]+$/)) {
        console.log("PN INVALID", this.phoneNumber.slice(0, sep).trim().length == 0, this.phoneNumber.slice(sep + 1).trim().length < 3, !this.phoneNumber.match(/^[0-9 #+-]+$/));
        this.phoneNumberInvalid = false;
        this.phoneNumberInvalid = true;
        this.required = true;
        return;
      }

      if (!this.recaptchaKey) {
        this.error = 'noRecaptcha';
        return;
      }

      this.passwordTooSimple = !checkPassword(this.password);
      console.log("CHECK PASSWORD", this.passwordTooSimple, this.password);
      if (this.passwordTooSimple) return;

      if (this.password != this.password2) {
        this.notMatch = true;
        this.$refs.password2.parentElement.setAttribute('class', this.$refs.password2.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.password2.focus();
        return;
      }

      this.state = "working";

      var userData = {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber
      };

      logger.addPassword(this.password);
      _api2.default.request(["emailPassword", "startRegister"], this.email, this.password, userData, this.recaptchaKey).then(function (result) {
        logger.removePassword(_this.password);
        _this.state = "done";
      }).catch(function (error) {
        logger.removePassword(_this.password);
        _this.error = error;
        _this.state = "ready";
        _this.recaptchaKey = null;
        _this.$refs.recaptcha.reset();

        if (error == 'notFound') {
          _this.$refs.email.parentElement.setAttribute('class', _this.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this.$refs.email.focus();
        }
        if (error == 'wrongPassword') {
          _this.$refs.password.parentElement.setAttribute('class', _this.$refs.password.parentElement.getAttribute('class') + ' is-invalid');
          _this.$refs.password.focus();
        }
      });
    },
    resend: function resend(e) {
      var _this2 = this;

      e.preventDefault();

      this.state = "working";
      _api2.default.request(["emailPassword", "resendRegisterKey", this.email], this.email).then(function (result) {
        _this2.state = "resent";
      }).catch(function (error) {
        _this2.error = error;
        _this2.state = "ready";
        if (error == 'notFound') {
          _this2.$refs.email.parentElement.setAttribute('class', _this2.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          _this2.$refs.email.focus();
        }
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    window.lfvm = this;
  }
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'reset-password',
  data: function data() {
    return {
      notMatch: false,
      error: null,
      state: 'loading',
      required: false,
      newPassword1: '',
      newPassword2: '',
      observable: null,
      keyState: false
    };
  },

  computed: {
    key: function key() {
      return this.$route.params.key;
    }
  },
  watch: {
    key: function key() {
      this.readKey();
    },
    keyState: function keyState(v) {
      if (this.state != 'done' && v && v.expired) {
        this.state = 'expired';
        return;
      }
      if (this.state == 'loading') {
        if (!v) {
          this.state = 'notFound';
          return;
        }
        if (v.used) {
          this.state = 'used';
        } else if (v.expired) {
          this.state = 'expired';
        } else {
          this.state = 'ready';
        }
      }
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().emailPassword.resetPassword;
    },
    readKey: function readKey() {
      if (this.observable) this.observable.unbindProperty(this, "keyState");
      this.state = 'loading';
      this.observable = _api2.default.observable(['emailPassword', 'emailKey', this.key]);

      this.observable.bindProperty(this, "keyState");
    },
    change: function change(e) {
      var _this = this;

      e.preventDefault();

      if (this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
        this.required = true;
        if (this.newPassword2.trim() == '') {
          this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword2.focus();
        }
        if (this.newPassword1.trim() == '') {
          this.$refs.newPassword1.parentElement.setAttribute('class', this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword1.focus();
        }
        return;
      }

      this.notMatch = this.newPassword1 != this.newPassword2;
      if (this.notMatch) {
        this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.newPassword2.focus();
        return;
      }

      this.state = "working";
      logger.addPassword(this.newPassword1);
      _api2.default.request(["emailPassword", "finishPasswordReset"], this.key, this.newPassword1).then(function (result) {
        logger.removePassword(_this.newPassword1);
        _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "ready";
      });
    },
    login: function login() {
      var _this2 = this;

      this.state = "loging";
      logger.addPassword(this.newPassword1);
      _api2.default.request(["emailPassword", "login"], this.keyState.email, this.newPassword1).then(function (result) {
        logger.removePassword(_this2.newPassword1);
        _this2.state = "done";
      }).catch(function (error) {
        _this2.error = error;
        _this2.state = "done";
        _this2.$router.replace({ name: 'index' });
      });
    }
  },
  created: function created() {
    this.readKey();
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "PremiumOverlay",
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().premium.overlay;
    }
  }
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    },
    possibleOperators: function possibleOperators() {
      return _expression2.default.operators.filter(function (x) {
        return x.isBinary;
      });
    }
  },
  watch: {},
  methods: {
    operatorTitle: function operatorTitle(type) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.type == type) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg() {
      var narg = _expression2.default.newArg(this.expression, this.columns);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(ev) {
      var nType = ev.target.value;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    }
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _SimpleFilterOrBlock = __webpack_require__(413);

var _SimpleFilterOrBlock2 = _interopRequireDefault(_SimpleFilterOrBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'simple-filter-and-block',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    FilterExpression: _SimpleFilterOrBlock2.default
  },
  data: function data() {
    return {
      possibleOperators: [{ name: 'and', title: 'include' }, { name: 'nand', title: 'exclude' }]
    };
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    }
  },
  watch: {},
  methods: {
    operatorTitle: function operatorTitle(name) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.name == name) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg(at) {
      var nArg = {
        "type": "or",
        args: [{
          "type": ">",
          "args": ["Count", 100]
        }]
      };
      var nArgs = this.expression.args.slice();
      nArgs.splice(at + 1, 0, nArg);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      if (nArgs.length == 0) return this.deleteThis();
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(ev) {
      var nType = ev.target.value;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    }
  }
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _FilterExpression = __webpack_require__(67);

var _FilterExpression2 = _interopRequireDefault(_FilterExpression);

var _SimpleFilterAndBlock = __webpack_require__(412);

var _SimpleFilterAndBlock2 = _interopRequireDefault(_SimpleFilterAndBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    FilterExpression: _SimpleFilterAndBlock2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    },
    possibleOperators: function possibleOperators() {
      return _expression2.default.operators;
    }
  },
  watch: {},
  methods: {
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg() {
      var narg = {
        "type": "and",
        args: [{
          "type": "or",
          args: [{
            "type": ">",
            "args": ["Count", 100]
          }]
        }]
      };
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    }
  }
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _FilterExpression = __webpack_require__(67);

var _FilterExpression2 = _interopRequireDefault(_FilterExpression);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'simple-filter-or-block',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    FilterExpression: _FilterExpression2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    }
  },
  watch: {},
  methods: {
    operatorTitle: function operatorTitle(name) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.name == name) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg() {
      var narg = _expression2.default.newArg(this.expression, this.columns);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      if (this.expression.args.length <= 1) {
        return this.deleteThis();
      }
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(ev) {
      var nType = ev.target.value;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    },
    addOuterAnd: function addOuterAnd() {
      this.$emit('addAnd');
    }
  }
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopFilterExpression = __webpack_require__(415);

var _TopFilterExpression2 = _interopRequireDefault(_TopFilterExpression);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "top-bar",
  props: {
    query: {
      type: Object
    },
    filter: {
      type: Object
    },
    appliedFilter: {
      type: Object
    },
    inputColumnNames: {
      type: Array
    },
    calculatedColumnNames: {
      type: Array
    },
    categories: {
      type: Array
    },
    enableFilter: {
      type: Boolean
    },
    tips: {
      type: Array
    },
    tipsExpanded: {
      type: Boolean
    },
    filterExpanded: {
      type: Boolean
    }
  },
  components: {
    TopFilterExpression: _TopFilterExpression2.default
  },
  data: function data() {
    return {
      queryExpand: true,
      filterExpand: true
    };
  },

  computed: {
    wordsColumnNames: function wordsColumnNames() {
      return this.inputColumnNames.filter(function (columnName) {
        if (_config2.default.logic.categoryColumns.indexOf(columnName) != -1) return false;
        return true;
      });
    }
  },
  methods: {
    i18n: function (_i18n) {
      function i18n() {
        return _i18n.apply(this, arguments);
      }

      i18n.toString = function () {
        return _i18n.toString();
      };

      return i18n;
    }(function () {
      return i18n().tips;
    }),
    handleQueryUpdate: function handleQueryUpdate(q) {
      this.$emit("update:query", q);
    },
    handleFilterUpdate: function handleFilterUpdate(f) {
      this.$emit("update:filter", f);
    }
  }
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _TopFilterOrBlock = __webpack_require__(417);

var _TopFilterOrBlock2 = _interopRequireDefault(_TopFilterOrBlock);

var _SingleSelect = __webpack_require__(151);

var _SingleSelect2 = _interopRequireDefault(_SingleSelect);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'top-filter-and-block',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    FilterExpression: _TopFilterOrBlock2.default,
    SingleSelect: _SingleSelect2.default
  },
  data: function data() {
    return {
      possibleOperators: [{ name: 'and', title: 'include' }, { name: 'nand', title: 'exclude' }]
    };
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    }
  },
  watch: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().filter;
    },
    operatorTitle: function operatorTitle(name) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.name == name) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorObject: function operatorObject(name) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.possibleOperators), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var op = _step2.value;

          if (op.name == name) return op;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg(at) {
      var nArg = {
        "type": "or",
        args: [{
          "type": ">",
          "args": ["Count", 100]
        }]
      };
      var nArgs = this.expression.args.slice();
      nArgs.splice(at + 1, 0, nArg);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      if (nArgs.length == 0) return this.deleteThis();
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(value) {
      var nType = value.name;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    }
  }
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _TopFilterAndBlock = __webpack_require__(414);

var _TopFilterAndBlock2 = _interopRequireDefault(_TopFilterAndBlock);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PremiumOverlay = __webpack_require__(66);

var _PremiumOverlay2 = _interopRequireDefault(_PremiumOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    applied: {
      type: Boolean
    },
    filterExpanded: {
      type: Boolean
    }
  },
  components: {
    TopFilterAndBlock: _TopFilterAndBlock2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    premium: function premium() {
      return _api2.default.session.premium;
    },
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    },
    possibleOperators: function possibleOperators() {
      return _expression2.default.operators;
    }
  },
  watch: {},
  methods: {
    showPremiumOverlay: function showPremiumOverlay() {
      _overlayModel2.default.show({
        component: _PremiumOverlay2.default,
        props: {},
        on: {}
      });
    },
    i18n: function i18n() {
      return (0, _i18n3.default)().filter;
    },
    translateColumn: function translateColumn(col) {
      return (0, _i18n3.default)().translateColumnName(col);
    },
    translateOperator: function translateOperator(operator) {
      return this.i18n().operators[operator.title || operator] || "i18n:" + (operator.title || operator);
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg() {
      if (this.expression.args.length > 0 && !this.premium) return this.showPremiumOverlay();
      var narg = {
        "type": "and",
        args: [{
          "type": "or",
          args: [{
            "type": ">",
            "args": ["Count", 100]
          }]
        }]
      };
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
      if (this.applied) this.$emit('update');
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
      if (this.applied) this.$emit('update');
    },
    updated: function updated() {
      componentHandler.upgradeAllRegistered();
    },
    mounted: function mounted() {
      componentHandler.upgradeAllRegistered();
    }
  }
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _SingleSelect = __webpack_require__(151);

var _SingleSelect2 = _interopRequireDefault(_SingleSelect);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'top-filter-logic-block',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    SingleSelect: _SingleSelect2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    },
    possibleOperators: function possibleOperators() {
      return _expression2.default.operators.filter(function (x) {
        return x.isBinary;
      });
    }
  },
  watch: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().filter;
    },
    translateColumn: function translateColumn(col) {
      return (0, _i18n3.default)().translateColumnName(col);
    },
    translateOperator: function translateOperator(operator) {
      return this.i18n().operators[operator.title] || "i18n:" + operator.title;
    },
    operatorTitle: function operatorTitle(type) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.type == type) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    operatorObject: function operatorObject(name) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.possibleOperators), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var op = _step2.value;

          if (op.name == name) return op;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    addArg: function addArg() {
      var narg = _expression2.default.newArg(this.expression, this.columns);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(v) {
      var nType = v.name;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    },
    updated: function updated() {
      componentHandler.upgradeAllRegistered();
    },
    mounted: function mounted() {
      componentHandler.upgradeAllRegistered();
    }
  }
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _expression = __webpack_require__(13);

var _expression2 = _interopRequireDefault(_expression);

var _TopFilterLogicBlock = __webpack_require__(416);

var _TopFilterLogicBlock2 = _interopRequireDefault(_TopFilterLogicBlock);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PremiumOverlay = __webpack_require__(66);

var _PremiumOverlay2 = _interopRequireDefault(_PremiumOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'top-filter-or-block',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expression: {
      type: Object,
      default: function _default() {
        return {
          type: "and",
          args: []
        };
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    TopFilterLogicBlock: _TopFilterLogicBlock2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    definition: function definition() {
      return _expression2.default.operatorsByName.get(this.expression.type);
    },
    premium: function premium() {
      return _api2.default.session.premium;
    }
  },
  watch: {},
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().filter;
    },
    showPremiumOverlay: function showPremiumOverlay() {
      _overlayModel2.default.show({
        component: _PremiumOverlay2.default,
        props: {},
        on: {}
      });
    },
    operatorTitle: function operatorTitle(name) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.possibleOperators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var op = _step.value;

          if (op.name == name) return op.title;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    operatorDefinition: function operatorDefinition(expr) {
      var operator = _expression2.default.operatorsByName.get(expr.type);
      console.log("OP", operator);
      return operator;
    },
    addArg: function addArg() {
      if (!this.premium) return this.showPremiumOverlay();
      var narg = _expression2.default.newArg(this.expression, this.columns);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      });
    },
    setArg: function setArg(argId, ev) {
      console.log("SET ARG", argId, ev);
      var nArgs = this.expression.args.slice();
      nArgs[argId] = ev;
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    deleteArg: function deleteArg(argId) {
      if (this.expression.args.length <= 1) {
        return this.deleteThis();
      }
      console.log("DELETE ARG", argId);
      var nArgs = this.expression.args.slice();
      nArgs.splice(argId, 1);
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      });
    },
    setType: function setType(ev) {
      var nType = ev.target.value;
      var nDefinition = _expression2.default.operatorsByName.get(nType);
      console.log("SET TYPE", nType);
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse((0, _stringify2.default)(this.expression))]
        });
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        });
      } else {
          console.log("HOLD ARGS");
          this.$emit('update:expression', {
            type: nType,
            args: this.expression.args
          });
        }
    },
    deleteThis: function deleteThis() {
      this.$emit('delete');
    },
    addOuterAnd: function addOuterAnd() {
      if (!this.premium) return this.showPremiumOverlay();
      this.$emit('addAnd');
    }
  }
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'file-list',
  props: {
    contentType: {
      type: String,
      default: function _default() {
        return "view";
      }
    }
  },
  data: function data() {
    return {
      fileList: null,
      working: false,
      selected: null,
      renaming: null,
      deleting: null,
      newName: ""
    };
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().save.list;
    },
    select: function select(file) {
      if (this.selected != file) {
        this.renaming = null;
      }
      this.selected = file;
      this.$emit('selected', file);
    },
    remove: function remove(file) {
      this.deleting = file;
    },
    rename: function rename(file) {
      this.newName = file.name;
      this.renaming = file;
    },
    finishRename: function finishRename() {
      var _this = this;

      this.working = true;
      _api2.default.request(['save', 'rename'], this.contentType, this.renaming.name, this.newName).then(function (done) {
        _this.renaming.name = _this.newName;
        _this.renaming = null;
        _this.working = false;
      });
    },
    confirmDelete: function confirmDelete() {
      var _this2 = this;

      this.working = true;
      _api2.default.request(['save', 'remove'], this.contentType, this.deleting.name).then(function (done) {
        _this2.deleting = null;
        _this2.working = false;
      });
    },
    cancelDelete: function cancelDelete() {
      this.deleting = null;
    }
  },
  created: function created() {
    this.observable = _api2.default.observable(['save', 'list', this.contentType]);
    this.observable.bindProperty(this, "fileList");
  },
  beforeDestroy: function beforeDestroy() {
    this.observable.unbindProperty(this, "fileList");
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FileList = __webpack_require__(143);

var _FileList2 = _interopRequireDefault(_FileList);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'load-view',
  props: {
    contentType: {
      type: String,
      default: function _default() {
        return "view";
      }
    },
    acceptedMime: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    acceptedExtensions: {
      type: Array,
      default: function _default() {
        return ['sgf'];
      }
    }
  },
  components: {
    FileList: _FileList2.default
  },
  data: function data() {
    return {
      fileName: null,
      selectedFile: null,
      state: "ready",
      error: null,
      required: false
    };
  },

  methods: {
    i18n: function (_i18n) {
      function i18n() {
        return _i18n.apply(this, arguments);
      }

      i18n.toString = function () {
        return _i18n.toString();
      };

      return i18n;
    }(function () {
      return i18n().save;
    }),
    handleInputChange: function handleInputChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.handleFileSelected(files[0]);
    },
    handleFileSelected: function handleFileSelected(file) {
      var _this = this;

      this.fileName = file.name;
      var ext = file.name.split('.').pop();
      if (this.acceptedExtensions && this.acceptedExtensions.indexOf(ext) == -1) this.error = "File with extension " + ext + " is not supported";
      if (this.acceptedMime && file.type && this.acceptedMime.indexOf(file.type) == -1) this.error = "File type " + file.type + " is not supported";
      if (this.error) {
        this.state = 'error';
        return;
      }
      this.state = 'working';
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        try {
          data = JSON.parse(data);
        } catch (e) {
          _this.error = "Incompatible file format";
          _this.state = 'error';
          return;
        }
        _this.state = 'done';
        _this.$emit('load', data);
      };
      reader.readAsText(file);
    },
    load: function load(e) {
      var _this2 = this;

      if (!this.selectedFile) {
        this.error = "no file selected";
        this.state = "error";
      }
      this.fileName = this.selectedFile.name;
      this.state = 'working';

      _api2.default.get(["save", "content", this.contentType, this.selectedFile.name]).then(function (entry) {
        if (!entry) {
          _this2.state = "error";
          _this2.error = "notFound";
          return;
        }
        _this2.state = "done";
        _this2.$emit('load', entry.content);
      }).catch(function (error) {
        _this2.state = "error";
        _this2.error = error;
      });
    },
    close: function close() {
      this.$emit('close');
    },
    selected: function selected(file) {
      this.selectedFile = file;
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _FileList = __webpack_require__(143);

var _FileList2 = _interopRequireDefault(_FileList);

var _save = __webpack_require__(54);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'save-view',
  props: {
    data: {
      default: function _default() {
        return [];
      }
    },
    contentType: {
      type: String,
      default: function _default() {
        return "view";
      }
    },
    extension: {
      type: String,
      default: function _default() {
        return "sgf";
      }
    },
    defaultFileName: {
      type: String,
      default: function _default() {
        return "view";
      }
    }
  },
  components: {
    FileList: _FileList2.default
  },
  data: function data() {
    return {
      fileName: "",
      state: "ready",
      error: null,
      required: false
    };
  },

  methods: {
    i18n: function (_i18n) {
      function i18n() {
        return _i18n.apply(this, arguments);
      }

      i18n.toString = function () {
        return _i18n.toString();
      };

      return i18n;
    }(function () {
      return i18n().save;
    }),
    download: function download() {
      var data = (0, _stringify2.default)(this.data, null, "  ");
      var blob = new Blob([data], { type: 'application/semgregate-filter' });
      var filename = (this.fileName.trim() != '' ? this.fileName.trim() : this.defaultFileName) + "." + this.extension;

      (0, _save.saveBlob)(blob, filename);
    },
    save: function save(e) {
      var _this = this;

      e.preventDefault();

      if (this.fileName.trim() == '') {

        this.required = true;
        this.$refs.fileName.parentElement.setAttribute('class', this.$refs.fileName.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.fileName.focus();

        return;
      }

      this.state = "working";
      _api2.default.request(['save', 'save'], this.contentType, this.fileName, this.data).then(function (result) {
        return _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "error";
      });
    },
    close: function close() {
      this.$emit('close');
    },
    selected: function selected(file) {
      this.fileName = file.name;
      this.$refs.fileName.parentElement.setAttribute('class', this.$refs.fileName.parentElement.getAttribute('class').replace('is-invalid', '') + ' is-focused');
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _PhoneInput = __webpack_require__(99);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _CountryInput = __webpack_require__(148);

var _CountryInput2 = _interopRequireDefault(_CountryInput);

var _countries = __webpack_require__(42);

var _countries2 = _interopRequireDefault(_countries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'change-user-data',
  components: { PhoneInput: _PhoneInput2.default, CountryInput: _CountryInput2.default },
  data: function data() {
    return {
      editedUserData: {},
      state: 'loading',
      required: true,
      phoneNumberInvalid: false,
      countryInvalid: false,
      error: null,
      allFields: ['firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'addressLine1', 'addressLine2', 'postalCode', 'taxNumber'],
      requiredFields: ['firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'city', 'addressLine1']
    };
  },

  reactive: {
    user: ['user', 'user']
  },
  computed: {
    userData: function userData() {
      if (!this.user) return null;
      var data = JSON.parse((0, _stringify2.default)(this.user.userData || {}));

      return data;
    },
    dataEdited: function dataEdited() {
      return (0, _stringify2.default)(this.editedUserData) != (0, _stringify2.default)(this.userData);
    }
  },
  watch: {
    userData: function userData() {
      if (!this.userData) return;
      this.editedUserData = JSON.parse((0, _stringify2.default)(this.userData));
      var fields = this.allFields;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (!this.editedUserData[field]) this.editedUserData[field] = '';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.editedUserData['phoneNumber'] != '' && this.editedUserData['country'] == '') {
        var prefix = this.editedUserData['phoneNumber'].split(' ')[0];
        var found = _countries2.default.filter(function (c) {
          return c.dial_code == prefix;
        })[0];
        this.editedUserData['country'] = found ? found.code : "";
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _field = _step2.value;

          if (this.editedUserData[_field] != '') {
            var el = this.$refs[_field];
            if (el) el = el.parentElement;
            if (el) el.setAttribute('class', el.getAttribute('class').replace('is-invalid', '') + ' is-dirty');
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.state = 'ready';
    }
  },
  methods: {
    i18n: function (_i18n) {
      function i18n() {
        return _i18n.apply(this, arguments);
      }

      i18n.toString = function () {
        return _i18n.toString();
      };

      return i18n;
    }(function () {
      return i18n().user.changeUserData;
    }),
    change: function change(e) {
      var _this = this;

      e.preventDefault();

      var anyEmpty = false;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.requiredFields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var field = _step3.value;
          if (this.editedUserData[field].trim() == '') {
            var el = this.$refs[field][0];
            if (el) el = el.parentElement;
            if (el) el.setAttribute('class', el.getAttribute('class') + ' is-invalid');
            console.log("EMPTY FIELD", field);
            anyEmpty = true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (anyEmpty) {
        return;
      }

      var phoneNumber = this.editedUserData.phoneNumber;
      var sep = phoneNumber.indexOf(' ');
      console.log("PN", phoneNumber, sep);
      if (sep == -1 || phoneNumber.slice(0, sep).trim().length == 0 || phoneNumber.slice(sep + 1).trim().length < 3 || !phoneNumber.match(/^[0-9 #+-]+$/)) {
        console.log("PN INVALID", phoneNumber.slice(0, sep).trim().length == 0, phoneNumber.slice(sep + 1).trim().length < 3, !phoneNumber.match(/^[0-9 #+-]+$/));
        this.phoneNumberInvalid = false;
        this.phoneNumberInvalid = true;
        this.required = true;
        return;
      }

      this.state = "working";
      _api2.default.request(["user", "updateUserData"], this.editedUserData).then(function (result) {
        _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "ready";
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'login-form',
  metaInfo: {
    title: (0, _i18n3.default)().user.logout.title
  },
  data: function data() {
    return {
      error: null,
      email: "",
      password: "",
      required: false
    };
  },

  computed: {
    state: function state() {
      return _api2.default.session.loggedIn ? 'working' : 'done';
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().user.logout;
    }
  },
  updated: function updated() {},
  mounted: function mounted() {
    _api2.default.request(["session", "logout"], {}).then(function (ok) {});
  }
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'big-table',
  props: {
    table: {
      type: Object
    },
    sortColumn: {
      type: String
    },
    sortAsc: {
      type: Boolean
    },
    found: {
      type: Array
    },
    rowHeight: {
      type: Number,
      default: function _default() {
        return 49;
      }
    },
    firstColumnWidth: {
      type: Number,
      default: function _default() {
        return 200;
      }
    },
    showSummary: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tableScrollY: 0,
      invisibleRows: _config2.default.view.table.invisibleRows,
      clusterSize: _config2.default.view.table.partitionSize,
      maxTableRows: _config2.default.view.table.visibleRange,
      visiblePartRowsRange: [_config2.default.view.table.partitionSize, _config2.default.view.table.visibleRange],
      visiblePart: null,
      resizeListener: null
    };
  },

  computed: {
    tableTopHeight: function tableTopHeight() {
      var height = 46;
      if (this.showSummary) height += 46;
      return height;
    },
    renderedRowsRange: function renderedRowsRange() {
      var firstVisibleRow = this.tableScrollY / this.rowHeight | 0;
      var notClusterized = Math.max(0, firstVisibleRow - this.invisibleRows);
      var clusterSize = this.clusterSize;
      var clusterized = (notClusterized / clusterSize | 0) * clusterSize;

      var last = Math.min(this.table.rows.length - 1, clusterized + this.maxTableRows);
      return [clusterized, last];
    },
    tableMargins: function tableMargins() {
      var rowsRange = this.renderedRowsRange;
      var top = rowsRange[0] * this.rowHeight;
      var bottom = (this.table.rows.length - rowsRange[1] - 1) * this.rowHeight;
      return [top, bottom];
    },
    foundMap: function foundMap() {
      var map = {};
      var found = this.found;
      if (!found) return map;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(found), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          var cellId = el.rowId + '-' + el.columnId;
          map[cellId] = map[cellId] || [];
          map[cellId].push(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return map;
    }
  },
  watch: {
    table: function table() {
      var _this = this;

      this.sliceVisiblePart(true);
      setTimeout(function () {
        return _this.resize();
      }, 50);
    },
    renderedRowsRange: function renderedRowsRange() {
      var _this2 = this;

      this.sliceVisiblePart(false);
      setTimeout(function () {
        return _this2.resize();
      }, 50);
    },
    found: function found(_found) {
      if (_found.length == 0) return;
      var y = _found[0].rowId * this.rowHeight;
      document.querySelector(".big-table .table-holder").scrollTop = y;
    }
  },
  methods: {
    toggleSort: function toggleSort(column) {
      this.$emit('toggleSort', column);
    },
    handleTableScroll: function handleTableScroll(e) {
      this.tableScrollY = e.target.scrollTop;
    },
    generateId: function generateId(text) {
      return text.toLowerCase().replace(/[^a-zA-Z0-9-]/g, '-');
    },
    generateClass: function generateClass(text) {
      if (!text) return "cg-error";
      return text.toLowerCase().replace(/[^a-z]/g, '-');
    },
    addThousandSeparator: function addThousandSeparator(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '\xA0' + '$2');
      }
      return x1 + x2;
    },
    cellText: function cellText(cell) {
      if (typeof cell == "number") return this.addThousandSeparator(cell % 100 == 0 ? cell / 100 : (cell / 100).toFixed(2));
      return cell;
    },
    sliceVisiblePart: function sliceVisiblePart(force) {
      var rowsRange = this.renderedRowsRange;
      if (rowsRange[0] != this.visiblePartRowsRange[0] || rowsRange[1] != this.visiblePartRowsRange[1] || force) {
        this.visiblePartRowsRange[0] = rowsRange[0];
        this.visiblePartRowsRange[1] = rowsRange[1];

        this.visiblePart = this.table.rows.slice(rowsRange[0], rowsRange[1] + 1);
      }
    },
    resize: function resize() {
      var thead = this.$el.querySelector('.table-holder thead tr');
      var otherWidth = 0;
      for (var el = thead.firstElementChild.nextElementSibling; el; el = el.nextElementSibling) {
        otherWidth += el.clientWidth;
      }
      var spaceWidth = this.$el.querySelector('.table-holder').clientWidth - 5;
      var remainingWidth = spaceWidth - otherWidth;
      var firstColumnWidth = Math.max(this.firstColumnWidth, remainingWidth);
      console.log("REMAINING WIDTH", remainingWidth, "SPACE WIDTH", spaceWidth, "COLUMNS WIDTH", otherWidth);
      var widthString = firstColumnWidth + 'px';
      var cell = this.$el.querySelector('.table-holder thead tr').firstElementChild;
      cell.style.width = widthString;
      cell.style.maxWidth = widthString;
      cell.style.minWidth = widthString;
      var rows = this.$el.querySelectorAll("tr");
      for (var i = 0; i < rows.length; i++) {
        cell = rows[i].firstElementChild;
        cell.style.width = widthString;
        cell.style.maxWidth = widthString;
        cell.style.minWidth = widthString;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.sliceVisiblePart(true);
    setTimeout(function () {
      return _this3.resize();
    }, 50);
    this.resizeListener = function () {
      return _this3.resize();
    };
    window.addEventListener('resize', this.resizeListener);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener);
  }
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNan = __webpack_require__(71);

var _isNan2 = _interopRequireDefault(_isNan);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inivisibleRowsCount = 23;
var clusterSize = 23;
var endInfoHeight = 45;

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  document.body.removeChild(textArea);
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    console.log('Async: Copying to clipboard was successful!');
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
}

exports.default = {
  name: 'BigTable2',
  props: {
    table: {
      type: Object
    },
    sortColumn: {
      type: String
    },
    sortAsc: {
      type: Boolean
    },
    found: {
      type: Array
    },
    rowHeight: {
      type: Number,
      default: function _default() {
        return 45;
      }
    },
    firstColumnWidth: {
      type: Number,
      default: function _default() {
        return 200;
      }
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    endInfo: {}
  },
  data: function data() {
    return {
      scrollTop: 0,
      scrollLeft: 0,
      scrollHeight: 0,
      visibleFirstColumnWidth: 0,
      savedScrollLeft: 0,
      extender: null
    };
  },

  computed: {
    visibleRowsRange: function visibleRowsRange() {
      var firstVisibleRow = this.scrollTop / this.rowHeight | 0;
      var lastVisibleRow = (this.scrollTop + this.scrollHeight) / this.rowHeight | 0;
      return { begin: firstVisibleRow, end: lastVisibleRow };
    },
    renderedRowsRange: function renderedRowsRange() {
      var _visibleRowsRange = this.visibleRowsRange,
          begin = _visibleRowsRange.begin,
          end = _visibleRowsRange.end;

      var extendedBegin = Math.max(0, begin - inivisibleRowsCount);
      var extendedEnd = Math.max(0, end + inivisibleRowsCount);
      var extendedBeginCluster = extendedBegin / clusterSize | 0;
      var extendedEndCluster = extendedEnd / clusterSize | 0;
      var calculatedBegin = extendedBeginCluster * clusterSize;
      var calculatedEnd = extendedEndCluster * clusterSize;
      return {
        begin: calculatedBegin,
        end: calculatedEnd
      };
    },
    renderedRows: function renderedRows() {
      var _renderedRowsRange = this.renderedRowsRange,
          begin = _renderedRowsRange.begin,
          end = _renderedRowsRange.end;

      return this.table.rows.slice(begin, end);
    },
    topMargin: function topMargin() {
      return Math.max(0, this.renderedRowsRange.begin * this.rowHeight);
    },
    bottomMargin: function bottomMargin() {
      return Math.max(0, (this.table.rows.length - this.renderedRowsRange.end) * this.rowHeight + (this.endInfo ? endInfoHeight : 0));
    }
  },
  watch: {
    table: function table() {
      var _this = this;

      setTimeout(function () {
        return _this.resize();
      }, 50);
    },
    renderedRowsRange: function renderedRowsRange() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.resize();
      }, 50);
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().words;
    },
    cellText: function cellText(cell) {
      if (cell == Infinity) return "--";
      if (cell == -Infinity) return "--";
      if ((0, _isNan2.default)(cell)) return "--";
      if (typeof cell == "number") return this.addThousandSeparator(cell % 100 == 0 ? cell / 100 : (cell / 100).toFixed(2));
      return cell;
    },
    addThousandSeparator: function addThousandSeparator(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + "\xA0" + '$2');
      }
      return x1 + x2;
    },
    handleScroll: function handleScroll() {
      this.scrollTop = this.$refs.scroller.scrollTop;
      this.scrollLeft = this.$refs.scroller.scrollLeft;
      this.extender = null;
    },
    resize: function resize() {
      this.scrollHeight = this.$refs.scroller.clientHeight;
      var thead = this.$refs.firstHeadRow;
      var otherWidth = 0;
      for (var el = thead.firstElementChild.nextElementSibling; el; el = el.nextElementSibling) {
        otherWidth += el.clientWidth;
      }
      var spaceWidth = this.$refs.scroller.clientWidth - 5;
      var remainingWidth = spaceWidth - otherWidth;
      var firstColumnWidth = Math.max(this.firstColumnWidth, remainingWidth);
      console.log("REMAINING WIDTH", remainingWidth, "SPACE WIDTH", spaceWidth, "COLUMNS WIDTH", otherWidth);
      this.visibleFirstColumnWidth = firstColumnWidth;
    },
    handleMouseOver: function handleMouseOver(event) {
      return;
      var y = event.target.offsetTop - this.$refs.scroller.clientTop - this.$refs.scroller.scrollTop + this.rowHeight * 3;
      if (y + this.rowHeight > this.$refs.scroller.clientHeight) {
        y -= this.rowHeight * 2;
      }
      var x = event.target.offsetLeft - this.$refs.scroller.clientLeft - this.$refs.scroller.scrollLeft + 1 + 23;
      if (x + 150) {
        x -= 150;
      }
      this.extender = {
        x: x,
        y: y,
        w: event.target.clientWidth,
        paddingLeft: window.getComputedStyle(event.target, null).getPropertyValue('padding-left'),
        nonNumeric: event.target.classList.contains('non-numeric'),
        text: event.target.innerText
      };
    },
    handleMouseOut: function handleMouseOut(event) {
      this.extender = null;
    },
    toggleSort: function toggleSort(column) {
      this.$emit('toggleSort', column);
    },
    generateClass: function generateClass(text) {
      if (!text) return "cg-error";
      return text.toLowerCase().replace(/[^a-z]/g, '-');
    },
    copyText: function copyText(text) {
      copyTextToClipboard(text);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.resizerLoop = function () {
      if (_this3.finished) return;
      var w = _this3.$refs.scroller.clientWidth;
      var h = _this3.$refs.scroller.clientHeight;
      if (w != _this3.width || h != _this3.height) {
        _this3.width = w;
        _this3.height = h;
        _this3.resize();
      }
      _this3.resizerLoopTimeout = setTimeout(_this3.resizerLoop, 200);
    };
    this.resizerLoop();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizerLoopTimeout !== undefined) {
      clearTimeout(this.resizerLoopTimeout);
    }
    this.finished = true;
  }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'checkbox',
  props: {
    checked: {
      type: Boolean
    },
    label: {
      type: String
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    toggle: function toggle() {
      this.$emit('update:checked', !this.checked);
    }
  }
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _countries = __webpack_require__(42);

var _countries2 = _interopRequireDefault(_countries);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _CountryPicker = __webpack_require__(421);

var _CountryPicker2 = _interopRequireDefault(_CountryPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(124);

exports.default = {
  name: 'country-input',
  props: {
    value: {},
    required: {
      type: Boolean,
      required: true
    },
    label: {
      type: String
    },
    invalid: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      liveValue: this.value,
      overlayStackId: null,
      lastCloseTime: 0
    };
  },

  reactive: {
    geoIpIsoCode: ["geoip", "country"]
  },
  computed: {
    empty: function empty() {
      if (!this.liveValue) return true;
      if (this.liveValue.trim().length == 0) return true;
      return false;
    },
    name: function name() {
      var _this = this;

      if (this.empty) return "";
      var country = _countries2.default.filter(function (c) {
        return c.code == _this.liveValue;
      })[0];
      if (!country) return "Unknown";
      return country.name;
    }
  },
  watch: {
    geoIpIsoCode: function geoIpIsoCode(iso) {
      if (!this.isoCode) {
        this.isoCode = iso;
        this.prefix = _countries2.default.filter(function (country) {
          return country.code == iso;
        })[0].dial_code;
      }
    },
    liveValue: function liveValue(value) {
      this.$emit('update:value', value);
    },
    invalid: function invalid(v) {
      if (!v) return;
      if (!this.number.match(/^[0-9 #+-]{3,}$/)) {
        this.$refs.number.parentElement.setAttribute('class', this.$refs.number.parentElement.getAttribute('class') + ' is-invalid');
      }
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  created: function created() {},
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },

  methods: {
    showPrefixMenu: function showPrefixMenu() {
      var _this2 = this;

      if (this.overlayStackId === null && Date.now() - this.lastCloseTime > 230) {
        this.overlayStackId = _overlayModel2.default.show({
          component: _CountryPicker2.default,
          props: {
            anchor: _overlayModel2.default.elementAnchor(this.$refs.country)
          },
          on: {
            selected: function selected(code) {
              console.log("SELECTED COUNTRY", code);
              _this2.liveValue = code;
            }
          }
        });
      } else {
        _overlayModel2.default.close(this.overlayStackId);
        this.overlayStackId = null;
        this.lastCloseTime = Date.now();
      }
    }
  }
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _overlayLayer = __webpack_require__(33);

var _countries2 = __webpack_require__(42);

var _countries3 = _interopRequireDefault(_countries2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CountryPicker',
  props: ['anchor'],
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      position: { x: 0, y: 0 },
      search: ""
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    countries: function countries() {
      return _countries3.default;
    },
    filteredCountries: function filteredCountries() {
      var query = this.search.toLowerCase().trim();
      if (query.length == 0) return this.countries;
      return this.countries.filter(function (country) {
        if (country.name.toLowerCase().indexOf(query) != -1) return true;
        if (country.code.toLowerCase().indexOf(query) != -1) return true;
        if (country.dial_code.indexOf(query) != -1) return true;
        return false;
      });
    }
  },
  methods: {
    updatePosition: function updatePosition(position) {
      this.position = position;
    },
    focusSearch: function focusSearch() {
      var _this = this;

      if (this.$refs.search) {
        this.$refs.search.focus();
        this.$refs.search.select();
      }
      if (document.activeElement != this.$refs.search) {
        setTimeout(function () {
          return _this.focusSearch();
        }, 50);
      }
    },
    countrySelected: function countrySelected(country) {
      this.$emit("selected", country.code);
      this.$emit("close");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    componentHandler.upgradeAllRegistered();
    setTimeout(function () {
      return _this2.focusSearch();
    }, 50);
  }
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _GlobalDropZone = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'load-file',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().loadFile;
    },
    handleInputChange: function handleInputChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.handleFileSelected(files[0]);
    },
    handleFileSelected: function handleFileSelected(file) {
      this.$emit('file', file);
    }
  },
  mounted: function mounted() {
    var _this = this;

    _GlobalDropZone.dropZoneState.dropReceiver = function (files) {
      console.log("DROP ZONE RECEIVER", files);
      _this.handleFileSelected(files[0]);
    };
  },
  beforeDestroy: function beforeDestroy() {
    _GlobalDropZone.dropZoneState.dropReceiver = null;
  }
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _GlobalDropZone = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'load-file-small',
  data: function data() {
    return {};
  },

  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().loadFile;
    },
    handleInputChange: function handleInputChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.handleFileSelected(files[0]);
    },
    handleFileSelected: function handleFileSelected(file) {
      this.$emit('file', file);
    }
  },
  mounted: function mounted() {
    var _this = this;

    _GlobalDropZone.dropZoneState.dropReceiver = function (files) {
      return _this.handleFileSelected(files[0]);
    };
  },
  beforeDestroy: function beforeDestroy() {
    _GlobalDropZone.dropZoneState.dropReceiver = null;
  }
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _MultiSelectPicker = __webpack_require__(423);

var _MultiSelectPicker2 = _interopRequireDefault(_MultiSelectPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'multi-select',
  components: {},
  props: {
    options: {
      type: Array
    },
    value: {
      type: Array
    },
    allOption: {
      type: Boolean
    },
    without: {
      type: Boolean
    },
    many: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      uniq: "" + uniqCounter++,
      overlayStackId: null,
      lastCloseTime: 0
    };
  },

  computed: {
    visibleValue: function visibleValue() {
      var _this = this;

      if (this.value.length == 0) return this.i18n().none;
      if (this.allOption && this.value.length == this.options.length) return this.i18n().all;
      if (this.without && this.value.length > this.options.length / 2 + 2) return this.i18n().without + " " + this.options.filter(function (option) {
        return _this.value.indexOf(option) == -1;
      }).map(function (v) {
        return _this.display(v);
      }).join(', ');
      if (this.many && this.value.length > 1) {
        return "" + this.value.length + " / " + this.options.length + " " + this.many;
      }
      return this.value.map(function (v) {
        return _this.display(v);
      }).join(', ');
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q.slice();
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().multiSelect;
    },
    isSelected: function isSelected(option) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var other = _step.value;

          if ((0, _stringify2.default)(option) == (0, _stringify2.default)(other)) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    toggleMenu: function toggleMenu() {
      var _this2 = this;

      if (this.overlayStackId === null && Date.now() - this.lastCloseTime > 230) {
        this.overlayStackId = _overlayModel2.default.show({
          component: _MultiSelectPicker2.default,
          props: {
            anchor: _overlayModel2.default.elementAnchor(this.$refs.button),
            value: this.value,
            options: this.options,
            allOption: this.allOption,
            without: this.without,
            many: this.many,
            display: this.display
          },
          on: {
            'update:value': function updateValue(value) {
              return _this2.$emit('update:value', value);
            },
            close: function close() {
              _this2.overlayStackId = null;
              _this2.lastCloseTime = Date.now();
            }
          }
        });
      } else {
        _overlayModel2.default.close(this.overlayStackId);
        this.overlayStackId = null;
        this.lastCloseTime = Date.now();
      }
    }
  }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

var _overlayLayer = __webpack_require__(33);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'multi-select-picker',
  components: {
    OverlayAnchor: _overlayLayer.OverlayAnchor
  },
  props: {
    anchor: {},
    options: {
      type: Array
    },
    value: {
      type: Array
    },
    allOption: {
      type: Boolean
    },
    without: {
      type: Boolean
    },
    many: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      uniq: "" + uniqCounter++,
      position: { x: 0, y: 0 },
      liveValue: this.value
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    visibleOptions: function visibleOptions() {
      var options = this.options.slice();
      console.log("ALL", this.i18n(), this.i18n().all);
      if (this.allOption) options.unshift(this.i18n().all);
      return options;
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q.slice();
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().multiSelect;
    },
    updateIfChanged: function updateIfChanged() {
      console.log("UPDATE IF CHANGED", (0, _stringify2.default)(this.value), (0, _stringify2.default)(this.liveValue));
      if ((0, _stringify2.default)(this.value) != (0, _stringify2.default)(this.liveValue)) {
        console.log('CHANGED', (0, _stringify2.default)(this.value), (0, _stringify2.default)(this.liveValue));
        this.$emit("update:value", this.liveValue);
      }
    },
    toggle: function toggle(option) {
      if (option == this.i18n().all) {
        if (this.liveValue.length == this.options.length) {
          this.liveValue = [];
          this.updateIfChanged();
          return;
        } else {
          this.liveValue = this.options.slice();
          this.updateIfChanged();
          return;
        }
      }
      var index = -1;
      for (var i = 0; i < this.liveValue.length; i++) {
        if ((0, _stringify2.default)(this.liveValue[i]) == (0, _stringify2.default)(option)) index = i;
      }
      if (index == -1) {
        this.liveValue.push(option);
      } else {
        if (this.liveValue.length < 2) return;
        this.liveValue.splice(index, 1);
      }
      this.updateIfChanged();
    },
    set: function set(option) {
      if (option == this.i18n().all) this.liveValue = this.options.slice();else this.liveValue = [option];
      this.menuOpen = false;
      this.updateIfChanged();
    },
    isSelected: function isSelected(option) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.liveValue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var other = _step.value;

          if ((0, _stringify2.default)(option) == (0, _stringify2.default)(other)) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    updatePosition: function updatePosition(position) {
      this.position.x = position.x;
      this.position.y = position.y;
    }
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _countries = __webpack_require__(42);

var _countries2 = _interopRequireDefault(_countries);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PhonePrefixPicker = __webpack_require__(424);

var _PhonePrefixPicker2 = _interopRequireDefault(_PhonePrefixPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(124);

exports.default = {
  name: 'phone-input',
  props: {
    value: {},
    required: {
      type: Boolean,
      required: true
    },
    label: {
      type: String
    },
    invalid: {
      type: Boolean
    }
  },
  data: function data() {
    var sep = this.value.indexOf(' ');
    var empty = sep == -1;
    var prefix = empty ? "" : this.value.slice(0, sep);
    var number = empty ? "" : this.value.slice(sep + 1);
    var country = _countries2.default.filter(function (c) {
      return c.dial_code == prefix;
    })[0];
    return {
      prefix: prefix, number: number,
      isoCode: country ? country.isoCode : null,
      overlayStackId: null,
      lastCloseTime: 0
    };
  },

  reactive: {
    geoIpIsoCode: ["geoip", "country"]
  },
  computed: {
    liveValue: function liveValue() {
      return (this.prefix + " " + this.number).trim();
    },
    prefixInvalid: function prefixInvalid() {
      return this.invalid && this.prefix.trim().length == 0;
    }
  },
  watch: {
    geoIpIsoCode: function geoIpIsoCode(iso) {
      if (!this.isoCode) {
        this.isoCode = iso;
        this.prefix = _countries2.default.filter(function (country) {
          return country.code == iso;
        })[0].dial_code;
      }
    },
    liveValue: function liveValue(value) {
      this.$emit('update:value', value);
    },
    invalid: function invalid(v) {
      if (!v) return;
      if (!this.number.match(/^[0-9 #+-]{3,}$/)) {
        this.$refs.number.parentElement.setAttribute('class', this.$refs.number.parentElement.getAttribute('class') + ' is-invalid');
      }
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  created: function created() {},
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },

  methods: {
    showPrefixMenu: function showPrefixMenu() {
      var _this = this;

      if (this.overlayStackId === null && Date.now() - this.lastCloseTime > 230) {
        this.overlayStackId = _overlayModel2.default.show({
          component: _PhonePrefixPicker2.default,
          props: {
            anchor: _overlayModel2.default.elementAnchor(this.$refs.prefix)
          },
          on: {
            selected: function selected(code) {
              return _this.prefix = code;
            }
          }
        });
      } else {
        _overlayModel2.default.close(this.overlayStackId);
        this.overlayStackId = null;
        this.lastCloseTime = Date.now();
      }
    }
  }
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _overlayLayer = __webpack_require__(33);

var _countries2 = __webpack_require__(42);

var _countries3 = _interopRequireDefault(_countries2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PhonePrefixPicker',
  props: ['anchor'],
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      position: { x: 0, y: 0 },
      search: ""
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    countries: function countries() {
      return _countries3.default;
    },
    filteredCountries: function filteredCountries() {
      var query = this.search.toLowerCase().trim();
      if (query.length == 0) return this.countries;
      return this.countries.filter(function (country) {
        if (country.name.toLowerCase().indexOf(query) != -1) return true;
        if (country.code.toLowerCase().indexOf(query) != -1) return true;
        if (country.dial_code.indexOf(query) != -1) return true;
        return false;
      });
    }
  },
  methods: {
    updatePosition: function updatePosition(position) {
      this.position = position;
    },
    focusSearch: function focusSearch() {
      var _this = this;

      if (this.$refs.search) {
        this.$refs.search.focus();
        this.$refs.search.select();
      }
      if (document.activeElement != this.$refs.search) {
        setTimeout(function () {
          return _this.focusSearch();
        }, 50);
      }
    },
    countrySelected: function countrySelected(country) {
      this.$emit("selected", country.dial_code);
      this.$emit("close");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    componentHandler.upgradeAllRegistered();
    setTimeout(function () {
      return _this2.focusSearch();
    }, 50);
  }
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _SingleSelectPicker = __webpack_require__(425);

var _SingleSelectPicker2 = _interopRequireDefault(_SingleSelectPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'single-select',
  props: {
    options: {
      type: Array
    },
    value: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      uniq: "" + uniqCounter++,
      overlayStackId: null,
      lastCloseTime: 0,
      liveValue: this.value
    };
  },

  computed: {
    visibleValue: function visibleValue() {
      return this.display(this.value);
    },
    visibleOptions: function visibleOptions() {
      var options = this.options.slice();
      return options;
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q;
    }
  },
  methods: {
    set: function set(option) {
      this.liveValue = option;
      this.$emit("update:value", this.liveValue);
      if (this.overlayStackId !== null) {
        _overlayModel2.default.close(this.overlayStackId);
      }
    },
    toggleMenu: function toggleMenu() {
      var _this = this;

      if (this.overlayStackId === null && Date.now() - this.lastCloseTime > 230) {
        this.overlayStackId = _overlayModel2.default.show({
          component: _SingleSelectPicker2.default,
          props: {
            anchor: _overlayModel2.default.elementAnchor(this.$refs.button),
            value: this.value,
            options: this.options,
            allOption: this.allOption,
            without: this.without,
            many: this.many,
            display: this.display
          },
          on: {
            'update:value': function updateValue(value) {
              return _this.set(value);
            },
            close: function close() {
              _this.overlayStackId = null;
              _this.lastCloseTime = Date.now();
            }
          }
        });
      } else {
        _overlayModel2.default.close(this.overlayStackId);
        this.overlayStackId = null;
        this.lastCloseTime = Date.now();
      }
    }
  }
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayLayer = __webpack_require__(33);

var _overlayModel = __webpack_require__(15);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'single-select-picker',
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  props: {
    options: {
      type: Array
    },
    value: {},
    anchor: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      uniq: "" + uniqCounter++,
      liveValue: this.value,
      position: { x: 0, y: 0 }
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    visibleOptions: function visibleOptions() {
      var options = this.options.slice();
      return options;
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q;
    }
  },
  methods: {
    set: function set(option) {
      this.liveValue = option;
      this.$emit("update:value", this.liveValue);
    },
    updatePosition: function updatePosition(position) {
      this.position.x = position.x;
      this.position.y = position.y;
    }
  }
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FilterExpression = __webpack_require__(67);

var _FilterExpression2 = _interopRequireDefault(_FilterExpression);

var _SimpleFilterExpression = __webpack_require__(141);

var _SimpleFilterExpression2 = _interopRequireDefault(_SimpleFilterExpression);

var _WordsQuery = __webpack_require__(427);

var _WordsQuery2 = _interopRequireDefault(_WordsQuery);

var _Checkbox = __webpack_require__(147);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "words-left-bar",
  props: {
    query: {
      type: Object
    },
    filter: {
      type: Object
    },
    appliedFilter: {
      type: Object
    },
    inputColumnNames: {
      type: Array
    },
    calculatedColumnNames: {
      type: Array
    },
    categories: {
      type: Array
    },
    enableFilter: {
      type: Boolean
    }
  },
  components: {
    Checkbox: _Checkbox2.default,
    FilterExpression: _FilterExpression2.default,
    SimpleFilterExpression: _SimpleFilterExpression2.default,
    WordsQuery: _WordsQuery2.default
  },
  data: function data() {
    return {
      queryExpand: true,
      filterExpand: true
    };
  },

  computed: {
    wordsColumnNames: function wordsColumnNames() {
      return this.inputColumnNames.filter(function (columnName) {
        if (_config2.default.logic.categoryColumns.indexOf(columnName) != -1) return false;
        return true;
      });
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().ads.query;
    },
    toggleQueryExpand: function toggleQueryExpand() {
      this.queryExpand = !this.queryExpand;
    },
    toggleFilterExpand: function toggleFilterExpand() {
      this.filterExpand = !this.filterExpand;
    },
    handleQueryUpdate: function handleQueryUpdate(q) {
      this.$emit("update:query", q);
    },
    handleFilterUpdate: function handleFilterUpdate(f) {
      this.$emit("update:filter", f);
    },
    handleEnableFilterUpdate: function handleEnableFilterUpdate(v) {
      this.$emit("update:enableFilter", v);
    }
  }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _wordsAnalyzer = __webpack_require__(105);

var _wordsAnalyzer2 = _interopRequireDefault(_wordsAnalyzer);

var _MultiSelect = __webpack_require__(150);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _i18n2 = __webpack_require__(2);

var _i18n3 = _interopRequireDefault(_i18n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'words-query',
  components: { MultiSelect: _MultiSelect2.default },
  props: {
    columns: {
      type: Array
    },
    categories: {
      type: Array
    },
    query: {
      type: Object,
      default: function _default() {
        return {
          categories: 'all',
          wordsColumns: [],
          minWords: 1,
          maxWords: 2,
          ignoreSpecialCharacters: true,
          ignoreCase: true
        };
      }
    }
  },
  data: function data() {
    return {
      wordsColumns: this.query.wordsColumns,
      minWords: this.query.minWords,
      maxWords: this.query.maxWords,
      ignoreSpecialCharacters: this.query.ignoreSpecialCharacters,
      ignoreCase: this.query.ignoreCase,
      selectedCategories: []
    };
  },

  computed: {},
  watch: {
    categories: function categories() {
      this.selectedCategories = JSON.parse((0, _stringify2.default)(this.categories));
    },
    query: function query(q) {
      this.wordsColumns = this.query.wordsColumns;
      this.minWords = this.query.minWords;
      this.maxWords = this.query.maxWords;
      this.ignoreSpecialCharacters = this.query.ignoreSpecialCharacters;
      this.ignoreCase = this.query.ignoreCase;
      this.selectedCategories = !this.query.categories || this.query.categories == 'all' ? JSON.parse((0, _stringify2.default)(this.categories)) : JSON.parse((0, _stringify2.default)(this.query.categories));
    },
    wordsColumns: function wordsColumns(v) {
      console.log("WORDS COLUMNS", v);

      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.wordsColumns = v;
      this.$emit("update:query", query);
    },
    minWords: function minWords(v) {
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.minWords = +v;
      this.$emit("update:query", query);
    },
    maxWords: function maxWords(v) {
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.maxWords = +v;
      this.$emit("update:query", query);
    },
    ignoreSpecialCharacters: function ignoreSpecialCharacters(v) {
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.ignoreSpecialCharacters = v;
      this.$emit("update:query", query);
    },
    ignoreCase: function ignoreCase(v) {
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.ignoreCase = v;
      this.$emit("update:query", query);
    }
  },
  methods: {
    i18n: function i18n() {
      return (0, _i18n3.default)().words.query;
    },
    translateColumn: function translateColumn(col) {
      return (0, _i18n3.default)().translateColumnName(col);
    },
    toggleSpecialCharacters: function toggleSpecialCharacters() {
      this.ignoreSpecialCharacters = !this.ignoreSpecialCharacters;
    },
    toggleIgnoreCase: function toggleIgnoreCase() {
      this.ignoreCase = !this.ignoreCase;
    },
    updateCategories: function updateCategories(index, value) {
      this.selectedCategories[index].options = value;
      var query = JSON.parse((0, _stringify2.default)(this.query));
      query.categories = JSON.parse((0, _stringify2.default)(this.selectedCategories));
      this.$emit("update:query", query);
    }
  },
  created: function created() {
    this.selectedCategories = JSON.parse((0, _stringify2.default)(this.categories));
  }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  acceptedMime: ["text/csv", "application/csv", "text/comma-separated-values", "application/comma-separated-values", "text/tsv", "application/tsv", "text/tab-separated-values", "text/application-separated-values"],
  acceptedExtensions: ['tsv', 'csv']

};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _searchQueryPerformance = __webpack_require__(212);

var _searchQueryPerformance2 = _interopRequireDefault(_searchQueryPerformance);

var _adPerformance = __webpack_require__(211);

var _adPerformance2 = _interopRequireDefault(_adPerformance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  searchQueryPerformance: _searchQueryPerformance2.default,
  adPerformance: _adPerformance2.default
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  name: "adPerformance",

  requiredFields: [['Headline', ['HeadlinePart1', 'HeadlinePart2']], ['Description', ['Description1', 'Description2']], ['DisplayUrl', 'CreativeDestinationUrl', 'CreativeFinalUrls']],

  numericFields: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  languages: [{
    lang: 'pl',
    columnTranslation: {
      'Kliknięcia': 'Clicks',
      'Wyświetlenia': 'Impressions',
      'Koszt': 'Cost',
      'Konwersje': 'Conversions',
      'Wartość wszystkich konw.': 'ConversionValue',

      'Reklama': 'Headline',
      'Nagłówek 1': 'HeadlinePart1',
      'Nagłówek 2': 'HeadlinePart2',
      'Nagłówek 3': 'HeadlinePart3',
      'Linia tekstu 1': 'Description1',
      'Linia tekstu 2': 'Description2',
      'Tekst reklamy': 'Description',
      'Wyświetlany URL': 'DisplayUrl',
      "Końcowy URL": "CreativeFinalUrls",
      "Docelowy URL": "CreativeDestinationUrl",

      'Kampania': 'CampaignName',
      'Grupa reklam': 'AdGroupName'
    },
    summaryRegex: [/^Łącznie/i, /^Razem/i]
  }, {
    lang: 'en',
    columnTranslation: {
      'Clicks': 'Clicks',
      'Impressions': 'Impressions',
      'Cost': 'Cost',
      'Conversions': 'Conversions',
      'All conv. value': 'ConversionValue',

      'Headline': 'Headline',
      'Headline 1': 'HeadlinePart1',
      'Headline 2': 'HeadlinePart2',
      'Headline 3': 'HeadlinePart3',
      'Description line 1': 'Description1',
      'Description line 2': 'Description2',
      'Description': 'Description',
      'Display URL': 'DisplayUrl',
      "Final URL": "CreativeFinalUrls",
      "Destination URL": "CreativeDestinationUrl",

      'Campaign': 'CampaignName',
      'Ad group': 'AdGroupName'
    },
    summaryRegex: [/^Total/i]
  }]

};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  name: "searchQueryPerformance",

  requiredFields: ['Query'],

  numericFields: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  languages: [{
    lang: 'pl',
    columnTranslation: {
      'Kliknięcia': 'Clicks',
      'Wyświetlenia': 'Impressions',
      'Koszt': 'Cost',
      'Konwersje': 'Conversions',
      'Wartość wszystkich konw.': 'ConversionValue',

      'Kampania': 'CampaignName',
      'Grupa reklam': 'AdGroupName',
      'Wyszukiwane hasło': 'Query'
    },
    summaryRegex: [/^Łącznie/i, /^Razem/i]
  }, {
    lang: 'en',
    columnTranslation: {
      'Clicks': 'Clicks',
      'Impressions': 'Impressions',
      'Cost': 'Cost',
      'Conversions': 'Conversions',
      'All conv. value': 'ConversionValue',

      'Campaign': 'CampaignName',
      'Ad group': 'AdGroupName',
      'Search term': 'Query'
    },
    summaryRegex: [/^Total/i]
  }]

};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ads = __webpack_require__(214);

var _ads2 = _interopRequireDefault(_ads);

var _words = __webpack_require__(215);

var _words2 = _interopRequireDefault(_words);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  threadsCount: 4,
  minimalSetSizeForThreading: 5000,

  defaultFilter: {
    "type": "and",
    args: [{
      "type": "and",
      args: [{
        "type": "or",
        args: [{
          "type": ">",
          "args": ["Count", 100]
        }]
      }]
    }]
  },

  categoryColumns: ['CampaignName', 'AdGroupName'],

  ads: _ads2.default,
  words: _words2.default
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  defaultQuery: {
    categories: 'all',
    aggregateUrls: true
  },

  sumColumns: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  titleColumns: ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3'],
  text1Columns: ['Description', 'Description1'],
  text2Columns: ['Description2'],
  urlColumns: ['CreativeFinalUrls', 'CreativeDestinationUrl'],
  aggregateColumns: ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3', 'Description', 'Description1', 'Description2']

};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  defaultQuery: {
    wordsColumns: [],
    categories: 'all',
    minWords: 1,
    maxWords: 2,
    ignoreSpecialCharacters: true,
    ignoreCase: true
  },

  wordRegex: {
    withoutSpecialChars: /[0-9]+[,\.][0-9]+|[0-9]+|".+"|[\u00C0-\u1FFF\u2C00-\uD7FF\w0-9]+/g,
    withSpecialChars: /".+"|[^ ]+/g
  },

  sumColumns: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  wordColumnsByType: {
    'searchQueryPerformance': ['Query'],
    'adPerformance': ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3', 'Description', 'Description1', 'Description2']
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  maxVisibleRows: 1000,
  table: {
    partitionSize: 20,
    visibleRange: 69,
    invisibleRows: 23 },

  searchDelay: 400

};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tableUtils = __webpack_require__(55);

var _tableUtils2 = _interopRequireDefault(_tableUtils);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _filterGenerator = __webpack_require__(219);

var _filterGenerator2 = _interopRequireDefault(_filterGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [function (inputTable, outputTable) {
  if (!_tableUtils2.default.hasColumn(outputTable, "Conversions")) return false;
  if (!_tableUtils2.default.hasColumn(outputTable, "Cost")) return false;

  var allCosts = _tableUtils2.default.sum(inputTable, "Cost");
  var allConversions = _tableUtils2.default.sum(inputTable, "Conversions");
  var averageConversionCost = allCosts / allConversions;

  if (_tableUtils2.default.anyRow(outputTable, ["Conversions", "Cost"], function (conversions, cost) {
    return conversions == 0 && cost / 100 > averageConversionCost * 3;
  })) {
    var filter = {
      name: "tip1_highCost",
      text: "You have words with very high cost, and no conversions",
      filter: _filterGenerator2.default.create(_filterGenerator2.default.include(_filterGenerator2.default.gt("Cost", (averageConversionCost * 3).toFixed(2)), _filterGenerator2.default.eq("Conversions", 0)))
    };
    return filter;
  }

  return false;
}, function (inputTable, outputTable) {
  if (!_tableUtils2.default.hasColumn(outputTable, "CC")) return false;
  if (!_tableUtils2.default.hasColumn(outputTable, "Conversions")) return false;
  if (!_tableUtils2.default.hasColumn(outputTable, "Cost")) return false;

  if (!_tableUtils2.default.hasColumn(inputTable, "Conversions")) return false;
  if (!_tableUtils2.default.hasColumn(inputTable, "Cost")) return false;

  var allCosts = _tableUtils2.default.sum(inputTable, "Cost");
  var allConversions = _tableUtils2.default.sum(inputTable, "Conversions");
  var averageConversionCost = allCosts / allConversions;


  if (_tableUtils2.default.anyRow(outputTable, ["Conversions", "Cost"], function (conversions, cost) {
    if (conversions <= 0) return false;
    var convCost = cost / conversions;
    return cost > averageConversionCost * 3 && convCost > averageConversionCost * 3;
  })) {
    var filter = {
      name: "tip2_highCost",
      text: "You have words with outstanding cost and conversion cost",
      filter: _filterGenerator2.default.create(_filterGenerator2.default.include(_filterGenerator2.default.gt("Cost", (averageConversionCost * 3).toFixed(2)), _filterGenerator2.default.gt("CC", (averageConversionCost * 3).toFixed(2)), _filterGenerator2.default.gt("Conversions", 0)))
    };
    return filter;
  }

  return false;
}];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(34);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(243);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(4);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(3);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _csv = __webpack_require__(53);

var _config = __webpack_require__(12);

var _config2 = _interopRequireDefault(_config);

var _tableUtils = __webpack_require__(55);

var _tableUtils2 = _interopRequireDefault(_tableUtils);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readTable(data) {
  var table = data.format == 'csv' ? (0, _csv.parseCSV)(data.text, ",") : (0, _csv.parseCSV)(data.text, '\t');
  var delimiters = [',', '\t'];
  var delimiterId = 0;
  while (table.columnNames.length <= 1) {
    table = (0, _csv.parseCSV)(data.text, delimiters[delimiterId]);
    delimiterId++;
  }
  console.log("TABLE", table);
  table.fileName = data.fileName;
  return table;
}

function parseAllNumbers(table) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(table.rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var row = _step.value;

      for (var i = 0; i < row.length; i++) {
        var cell = row[i];
        if (cell.match(/^(([0-9]+[ \u00A0])*(([0-9]+[,.][0-9]+)|([0-9]+)))$/)) {
          row[i] = +cell.replace(/[^0-9,\.-]/g, '').replace(',', '.');
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return table;
}

function checkField(fields, rf) {
  if (rf instanceof Array) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(rf), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var part = _step2.value;

        if (part instanceof Array) {
          if (checkFields(fields, part)) return true;
        } else {
          if (fields.indexOf(part) != -1) return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    console.log("field", rf, "not found");
    return false;
  } else {
    var found = fields.indexOf(rf) != -1;
    if (!found) console.log("field", rf, "not found");
    return found;
  }
}

function checkFields(fields, required) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(required), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var rf = _step3.value;

      if (!checkField(fields, rf)) return false;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return true;
}

function checkType(table, type, language) {
  var columnNames = table.columnNames;
  console.log("input fields", columnNames);
  console.log("LANG", (0, _stringify2.default)(language.columnTranslation));
  var columnTranslations = (0, _keys2.default)(language.columnTranslation);
  var translatedColumnNames = columnNames.map(function (name) {
    var columnName = columnTranslations.find(function (c) {
      var cNorm = c.trim().replace(/\u00A0/gi, ' ').replace(/&nbsp;/gi, ' ').replace(/ +/gi, ' ');
      var nameNorm = name.trim().replace(/\u00A0/gi, ' ').replace(/&nbsp;/gi, ' ').replace(/ +/gi, ' ');
      return cNorm == nameNorm;
    });
    if (!columnName) return null;
    return language.columnTranslation[columnName];
  });
  console.log('type', type.name, language.lang);
  console.log("translated fields", translatedColumnNames.filter(function (x) {
    return !!x;
  }));
  console.log("required fields", (0, _stringify2.default)(type.requiredFields));

  return checkFields(translatedColumnNames, type.requiredFields);
}

function detectFileType(table, inputConfig) {
  for (var typeName in inputConfig) {
    var typeConfig = inputConfig[typeName];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(typeConfig.languages), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var language = _step4.value;

        if (checkType(table, typeConfig, language)) {
          return [typeName, language.lang];
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }
  return null;
}

function removeUndefinedColumns(table) {
  var inputColumnsCount = table.columnNames.length;
  var inputColumnNames = table.columnNames;
  var undefinedColumnsCount = 0;
  for (var i = 0; i < inputColumnsCount; i++) {
    if (!table.columnNames[i]) undefinedColumnsCount++;
  }var definedColumnsCount = inputColumnsCount - undefinedColumnsCount;
  var rowsCount = table.rows.length;
  for (var _i = 0; _i < rowsCount; _i++) {
    var inRow = table.rows[_i];
    var outRow = new Array(definedColumnsCount);
    var outp = 0;
    for (var inp = 0; inp < inputColumnsCount; inp++) {
      if (inputColumnNames[inp]) outRow[outp++] = inRow[inp];
    }
    table.rows[_i] = outRow;
  }
  table.columnNames = table.columnNames.filter(function (col) {
    return !!col;
  });
  return table;
}

function translateTable(table, _ref, inputConfig) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      dataType = _ref2[0],
      lang = _ref2[1];

  var tconf = inputConfig[dataType];
  var translation = tconf.languages.filter(function (l) {
    return l.lang == lang;
  })[0].columnTranslation;
  var columnTranslations = (0, _keys2.default)(translation);
  console.log("RAW TABLE COLUMN NAMES", table.columnNames);
  table.columnNames = table.columnNames.map(function (name) {
    var columnName = columnTranslations.find(function (c) {
      var cNorm = c.trim().replace(/\u00A0/gi, ' ').replace(/&nbsp;/gi, ' ').replace(/ +/gi, ' ');
      var nameNorm = name.trim().replace(/\u00A0/gi, ' ').replace(/&nbsp;/gi, ' ').replace(/ +/gi, ' ');
      if (cNorm == nameNorm) console.log("COMP", cNorm, nameNorm);
      return cNorm == nameNorm;
    });
    if (!columnName) return null;
    return translation[columnName];
  });
  console.log("TRANSLATED TABLE COLUMN NAMES", table.columnNames);
  return removeUndefinedColumns(table);
}

function parseNumericColumns(table, columns) {
  var columnIdsByName = _tableUtils2.default.columnIdsByName(table);
  var columnIds = columns.map(function (col) {
    return columnIdsByName.get(col);
  }).filter(function (x) {
    return !!x;
  });
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = (0, _getIterator3.default)(table.rows), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var row = _step5.value;

      for (var i = 0; i < columnIds.length; i++) {
        var cell = row[columnIds[i]];
        var simpleValue = cell.match(/^[^0-9]*(([0-9]+[\s\u00A0])*(([0-9]+[,.][0-9]+)|([0-9]+)))[^0-9]*$/);
        if (simpleValue) {
          row[columnIds[i]] = +simpleValue[1].replace(/[^0-9,\.-]/g, '').replace(',', '.');
        } else {
          console.error("BAD NUMERIC CELL", cell);
          throw new Error("unknownTableType");
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return table;
}

function removeSummary(table, _ref3, inputConfig) {
  var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
      dataType = _ref4[0],
      lang = _ref4[1];

  var tconf = inputConfig[dataType];
  var summaryRegex = tconf.languages.filter(function (l) {
    return l.lang == lang;
  })[0].summaryRegex;
  var rowId = void 0;
  for (rowId = table.rows.length - 1; rowId >= 0; rowId--) {
    var row = table.rows[rowId];
    var found = false;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = (0, _getIterator3.default)(summaryRegex), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var regex = _step6.value;

        if (row[0].match(regex)) found = true;
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    if (!found) break;
  }
  console.log("ROWS BEFORE", table.rows.length, "SLICE", rowId);
  console.log("REMOVE", table.rows.length - rowId - 1, "LAST ROWS OF SUMMARY");
  table.rows = table.rows.slice(0, rowId + 1);
  console.log("ROWS AFTER", table.rows.length);
  return table;
}

function parseData(data, inputConfig) {
  var table = readTable(data);

  var fileType = detectFileType(table, inputConfig);
  if (!fileType) throw new Error("unknownTableType");

  var _fileType = (0, _slicedToArray3.default)(fileType, 2),
      dataType = _fileType[0],
      language = _fileType[1];

  console.error("DETECTED FILE TYPE", dataType, language);
  table = removeSummary(table, fileType, inputConfig);
  table = translateTable(table, fileType, inputConfig);
  table.type = dataType;

  table = parseNumericColumns(table, inputConfig[dataType].numericFields);
  return table;
}

var methods = {
  parseData: parseData
};

exports.default = methods;


if (typeof window == "undefined" || window.document === undefined) {
  _logger2.default.install();
  _logger2.default.addWorkerParentLogDestination();
  onmessage = function onmessage(msg) {
    var _msg$data = msg.data,
        method = _msg$data.method,
        serializedArgs = _msg$data.serializedArgs,
        requestId = _msg$data.requestId;

    var args = serializedArgs;

    var result = methods[method].apply(null, args);

    postMessage({
      type: "response",
      result: result,
      requestId: requestId
    });
  };
  postMessage({
    type: "ready"
  });
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function create() {
  for (var _len = arguments.length, filters = Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  filters = filters.map(function (filter) {
    if (filter.type != 'and') {
      return include(filter);
    } else return filter;
  });
  return {
    "type": "and",
    args: filters
  };
}

function include() {
  for (var _len2 = arguments.length, filters = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    filters[_key2] = arguments[_key2];
  }

  filters = filters.map(function (filter) {
    if (filter.type != 'or') {
      return {
        "type": "or",
        args: [filter]
      };
    } else return filter;
  });
  return {
    type: "and",
    args: filters
  };
}

function exclude() {
  for (var _len3 = arguments.length, filters = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    filters[_key3] = arguments[_key3];
  }

  filters = filters.map(function (filter) {
    if (filter.type != 'or') {
      return {
        "type": "or",
        args: [filter]
      };
    } else return filter;
  });
  return {
    type: "nand",
    args: filters
  };
}

function and() {
  for (var _len4 = arguments.length, filters = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    filters[_key4] = arguments[_key4];
  }

  return {
    type: "and",
    args: filters
  };
}

function or() {
  for (var _len5 = arguments.length, filters = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    filters[_key5] = arguments[_key5];
  }

  return {
    type: "or",
    args: filters
  };
}

function gt(columnName, value) {
  return {
    "type": ">",
    "args": [columnName, value]
  };
}

function lt(columnName, value) {
  return {
    "type": "<",
    "args": [columnName, value]
  };
}

function eq(columnName, value) {
  return {
    "type": "=",
    "args": [columnName, value]
  };
}

exports.default = {
  create: create, include: include, exclude: exclude, and: and, or: or, gt: gt, lt: lt, eq: eq
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactiveDaoSockjs = __webpack_require__(100);

var _reactiveDaoSockjs2 = _interopRequireDefault(_reactiveDaoSockjs);

var _logger = __webpack_require__(18);

var _logger2 = _interopRequireDefault(_logger);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vueAsyncComputed = __webpack_require__(154);

var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);

var _api = __webpack_require__(5);

var _api2 = _interopRequireDefault(_api);

var _reactiveDaoVue = __webpack_require__(152);

var _reactiveDaoVue2 = _interopRequireDefault(_reactiveDaoVue);

var _vueRecaptcha = __webpack_require__(156);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

var _App = __webpack_require__(155);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(153);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_logger2.default.addAjaxLogDestination("/saveLogs");
if (!localStorage.test) _logger2.default.install();


_vue2.default.config.devtools = true;

_vue2.default.use(_vueAsyncComputed2.default);

_vue2.default.use(_reactiveDaoVue2.default, {
  dao: _api2.default
});

_vue2.default.component('vue-recaptcha', _vueRecaptcha2.default);

var script = document.createElement('script');
script.src = "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit";
document.head.appendChild(script);

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  title: 'Account Settings'
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  title: "Ads analyzer",

  dialog: {
    loadView: {
      title: "Load query with filters"
    },
    saveView: {
      title: "Save query with filters"
    }
  },

  saveCSV: "CSV",
  saveTSV: "TSV",
  tips: "Semgregate AI Tips & Tricks",
  tipApplyFilter: "Apply Filter!",
  computing: {
    title: "Computing...",
    text: "Please wait."
  },
  filtering: {
    title: "Filtering...",
    text: "Please wait."
  },
  empty: "No results found",
  failed: "Processing failed",
  wrongType: {
    title: "Wrong report type",
    text: "Ads processor can process only ads reports. Please load another report or switch to another processor."
  },

  query: {
    title: "Query",
    filterResults: "Filter results",
    aggregateUrls: "Aggregate URLs"
  },

  filename: "file: ",

  endInfo: {
    'download': function download(_ref) {
      var allRows = _ref.allRows,
          visibleRows = _ref.visibleRows;
      return "There is " + (allRows - visibleRows) + " more ads. You can download full table.";
    },
    'premium': function premium(_ref2) {
      var allRows = _ref2.allRows,
          visibleRows = _ref2.visibleRows;
      return "There is " + (allRows - visibleRows) + " more ads. To see them all you need premium account.";
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  searchBox: "Enter your query...",

  title: {
    words: "CSV Words analyzer",
    ads: "CSV Ads analyzer"
  },

  csvOrTsv: "TSV or CSV",
  inputError: {
    title: "File input error",
    extension: function extension(_ref) {
      var ext = _ref.ext;
      return "File with extension " + ext + " is not supported";
    },
    type: function type(_ref2) {
      var fileType = _ref2.fileType;
      return "File type " + fileType + " is not supported";
    },
    adsQuery: function adsQuery() {
      return "Ads analyzer supports only ads performance reports.";
    },
    format: function format() {
      return "File format not supported.";
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var env = __webpack_require__(237);

module.exports = {

  loginForm: {
    title: 'Sign In',
    email: 'Email',
    password: 'Password',
    submit: 'Sing In',
    resetButton: "Reset password",
    resendButton: "Resend confirmation email.",
    errors: {
      notFound: 'Email not found in our database.',
      wrongPassword: 'Password does not match one stored in our database.',
      registrationNotConfirmed: 'Email registered but not confirmed.'
    },
    reset: {
      title: "Reset password",
      text: function text(_ref) {
        var email = _ref.email;
        return 'We sent email to ' + email + ' with special secret link and instructions to reset your password.';
      }
    },
    resent: {
      title: "Resend email confirmation",
      text: function text(_ref2) {
        var email = _ref2.email;
        return 'We sent email to ' + email + ' with special secret link and instructions to confirm your email and activate your account.';
      }
    },
    registerText: "If you don't have account, ",
    registerLink: "Click here to create one"
  },

  changePassword: {
    title: "Change password",
    oldPassword: "Current password",
    newPassword: "New password",
    retypePassword: "Retype new password",
    notMatch: "Passwords does not match!",
    submit: "Change password",
    errors: {
      wrongPassword: "Old password does not match one stored in our database."
    },
    done: {
      title: "Change password",
      text: "Password successfully changed."
    }
  },

  resetPasswordEmail: function resetPasswordEmail(_ref3) {
    var email = _ref3.email,
        key = _ref3.key,
        user = _ref3.user;
    return {
      from: 'Semgregate <system@semgregate.com>',
      to: user.display + ' <' + email + '>',
      subject: 'Password reset request.',
      text: __webpack_require__(363)({ user: user, env: env, key: key }),
      html: __webpack_require__(362)({ user: user, env: env, key: key })
    };
  },

  resetPassword: {
    title: "Reset password",
    newPassword: "New password",
    retypePassword: "Retype new password",
    notMatch: "Passwords does not match!",
    submit: "Change password",
    errors: {},
    done: {
      title: "Reset password",
      text: "Password successfully changed.",
      loginButton: 'Sign In'
    },
    loading: {
      title: "Reset password",
      text: "Loading. please wait..."
    },
    used: {
      title: "Reset password",
      text: "Your link has been used before."
    },
    expired: {
      title: "Reset password",
      text: "Your link expired."
    },
    notFound: {
      title: "Not found",
      text: "We could not find your link in our database. Please copy and paste address from email that your received."
    }
  },

  startEmailChange: {
    title: "Change email",
    newEmail: 'New email',
    currentPassword: 'Current password',
    submit: "Change email",
    errors: {
      wrongPassword: "Password does not match one stored in our database.",
      taken: "This email is already registered in our system."
    },
    done: {
      title: "Change email",
      text: function text(_ref4) {
        var email = _ref4.email;
        return 'We sent a change confirmation link to your new email ' + email + ', when you click it, your email will be updated. The link will expire in 24 hours';
      }
    }
  },

  changeEmailEmail: function changeEmailEmail(_ref5) {
    var oldEmail = _ref5.oldEmail,
        newEmail = _ref5.newEmail,
        key = _ref5.key,
        user = _ref5.user;
    return {
      from: 'Semgregate <system@semgregate.com>',
      to: user.display + ' <' + newEmail + '>',
      subject: 'Email change request.',
      text: __webpack_require__(359)({ user: user, env: env, key: key, newEmail: newEmail }),
      html: __webpack_require__(358)({ user: user, env: env, key: key, newEmail: newEmail })
    };
  },

  finishEmailChange: {
    title: "Confirm email",
    done: {
      title: "Confirm email",
      text: "Email successfully changed.",
      exitButton: 'Ok'
    },
    loading: {
      title: "Confirm email",
      text: "Loading. please wait..."
    },
    used: {
      title: "Confirm email",
      text: "Your link has been used before."
    },
    expired: {
      title: "Confirm email",
      text: "Your link expired."
    },
    notFound: {
      title: "Not found",
      text: "We could not find your link in our database. Please copy and paste address from email that your received."
    }
  },

  registerEmail: function registerEmail(_ref6) {
    var key = _ref6.key,
        email = _ref6.email,
        userData = _ref6.userData;
    return {
      from: 'Semgregate <system@semgregate.com>',
      to: userData.firstName + ' ' + userData.lastName + ' <' + email + '>',
      subject: 'Sing up.',
      text: __webpack_require__(361)({ user: userData, env: env, key: key }),
      html: __webpack_require__(360)({ user: userData, env: env, key: key })
    };
  },

  registerForm: {
    title: 'Sign up',
    email: 'Email',
    password: 'Password',
    retypePassword: 'Retype password',
    fullName: 'First name',
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number',
    submit: 'Sing up',
    resendButton: "Resend confirmation email.",
    notMatch: "Passwords does not match!",
    errors: {
      alreadyAdded: 'Email already registered.',
      registrationNotConfirmed: 'Email registered but not confirmed.',
      noRecaptcha: 'Recaptcha is required'
    },
    resent: {
      title: "Resend email confirmation",
      text: function text(_ref7) {
        var email = _ref7.email;
        return 'We sent email to ' + email + ' with special secret link and instructions to confirm your email and activate your account.';
      }
    },
    done: {
      title: 'Sign up',
      text: function text(_ref8) {
        var email = _ref8.email;
        return 'We sent email to ' + email + ' with special secret link and instructions to confirm your email and activate your account.';
      }
    },
    passwordTooSimple: "Password is too weak, enter password with at least 8 characters, upper & lower case letters and numbers"
  },

  finishRegister: {
    title: "Confirm sign up",
    registerLink: "Click here to create new account",
    done: {
      title: "Confirm sign up",
      text: "Your account was successfully created. You will be logged in.",
      exitButton: 'Ok'
    },
    loading: {
      title: "Confirm sign up",
      text: "Loading. please wait..."
    },
    used: {
      title: "Confirm sign up",
      text: "Your link has been used before."
    },
    expired: {
      title: "Confirm sign up",
      text: "Your link expired."
    },
    notFound: {
      title: "Not found",
      text: "We could not find your link in our database. Please copy and paste address from email that your received."
    },
    resent: {
      title: "Resend email confirmation",
      text: "We sent email with special secret link and instructions to confirm your email."
    }
  }

};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  apply: "Apply Filter",
  update: "Apply Filter",
  clear: "Reset Filter",

  operators: {
    ">": ">",
    ">=": ">=",
    "<": "<",
    "<=": "<=",
    "=": "=",
    "Regex": "regex",
    "!regex": "not regex",
    "include": "include",
    "exclude": "exclude"
  },

  andLine: "and",
  orLine: "or",

  and: "and",
  or: "or",

  summary: {
    activeFilter: "Active filter:",
    filter: "Filter:"
  }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var i18n = {
  language: "English",

  emailPassword: __webpack_require__(224),
  user: __webpack_require__(235),

  menu: __webpack_require__(228),

  accountSettings: __webpack_require__(221),

  csvAnalyzer: __webpack_require__(223),

  words: __webpack_require__(236),
  ads: __webpack_require__(222),

  tips: __webpack_require__(234),

  filter: __webpack_require__(225),

  table: __webpack_require__(233),

  multiSelect: __webpack_require__(229),
  loadFile: __webpack_require__(227),

  save: __webpack_require__(232),

  order: __webpack_require__(230),

  premium: __webpack_require__(231),

  translateColumnName: function translateColumnName(columnName) {
    return i18n.table[columnName] || columnName;
  },
  translateColumnNames: function translateColumnNames(columnNames) {
    return columnNames.map(i18n.translateColumnName);
  }
};

module.exports = i18n;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  tapOrDrop: "Tap or Drop file here.",
  load: "LOAD"
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  home: 'Home',
  csvWordsAnalyzer: 'CSV words analyzer',
  csvAdsAnalyzer: 'CSV ads analyzer',

  accountSettings: 'Account Settings',
  logout: 'Sign out',

  help: 'Help'

};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  none: "None",
  all: "All",
  without: "Without"

};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  billingData: "Billing information",
  productData: "Product",
  back: "Back to offer",
  next: "Proceed to payment"

};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  overlay: {
    title: "Premium only",
    text: "This feature need premium account, contact us to get one."
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  list: {
    remove: {
      prompt: function prompt(file) {
        return "Do you really want to delete file " + file.name + " ?";
      },
      yes: "Yes",
      no: "No"
    },
    loading: "Loading File List..."
  },

  loadFromCloud: "Load from cloud",
  upload: "Upload",

  loaded: function loaded(fileName) {
    return "File " + fileName + " loaded!";
  },
  loadError: function loadError(error) {
    return "File load impossible - " + error;
  },
  ok: "Ok",
  fileNamePlaceholder: "File name",

  saveToCloud: "Save to cloud",
  download: "Download",
  fileSaved: function fileSaved(fileName) {
    return "File " + fileName + " saved!";
  },
  saveError: function saveError(error) {
    return "File save impossible - " + error;
  }

};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  'Clicks': 'Clicks',
  'Impressions': 'Impressions',
  'Cost': 'Cost',
  'Conversions': 'Conversions',
  'ConversionValue': 'Total conv. value',
  'HeadlinePart1': 'Headline 1',
  'HeadlinePart2': 'Headline 2',
  'HeadlinePart3': 'Headline 3',
  'Description1': 'Description line 1',
  'Description2': 'Description line 2',
  'Description': 'Description',
  'DisplayUrl': 'Display URL',
  'Campaign': 'CampaignName',
  'Ad group': 'AdGroupName',
  'Search term': 'Query',
  'CC': 'Conv. cost',
  'CR': 'Conv. rate',
  'ROAS': 'ROAS',
  'CTR': 'CTR',
  'CampaignName': "Campaign",
  'AdGroupName': "Ad group"

};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  tips: "Semgregate AI Tips & Tricks",
  tipApplyFilter: "Apply Filter!",
  tipsSummary: function tipsSummary(count) {
    return "Our system generated " + count + " " + (count > 1 ? 'tips' : 'tip') + " for you";
  }

};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  changeUserData: {
    title: "Update data",
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number',
    companyName: 'Company name',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    postalCode: 'Postal code',
    taxNumber: 'Tax number',
    country: 'Country',
    city: 'City',
    submit: "Save",
    errors: {},
    done: {
      title: "Update data",
      text: "Data successfully saved."
    }
  },

  logout: {
    title: "Logout",
    working: {
      title: "Logout in progress",
      text: "Please wait..."
    },
    done: {
      title: "Logout",
      text: "You have been successfully logged out."
    },
    login: "Login again"
  }

};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  title: "Search words analyzer",

  dialog: {
    loadView: {
      title: "Load query with filters"
    },
    saveView: {
      title: "Save query with filters"
    }
  },

  saveCSV: "CSV",
  saveTSV: "TSV",
  computing: {
    title: "Computing...",
    text: "Please wait."
  },
  filtering: {
    title: "Filtering...",
    text: "Please wait."
  },
  empty: "No results found",
  failed: "Processing failed.",

  query: {
    title: "Query",
    filterResults: "Filter results",
    columns: "Words Columns",
    number: "Words count:",
    min: "Min",
    max: "Max",
    isNotNumber: "Input is not a number!",
    ignoreSpecial: "Ignore special characters",
    ignoreCase: "Ignore case"

  },

  filename: "file: ",

  endInfo: {
    'download': function download(_ref) {
      var allRows = _ref.allRows,
          visibleRows = _ref.visibleRows;
      return "There is " + (allRows - visibleRows) + " more words. You can download full table.";
    },
    'premium': function premium(_ref2) {
      var allRows = _ref2.allRows,
          visibleRows = _ref2.visibleRows;
      return "There is " + (allRows - visibleRows) + " more words. To see them all you need premium account.";
    }
  }

};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof window == 'undefined') {
  module.exports = {
    baseHref: __webpack_require__.i({"NODE_ENV":"production"}).BASE_HREF
  };
} else {
  module.exports = {
    baseHref: location.protocol + '//' + location.host
  };
}

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {



/***/ }),
/* 359 */
/***/ (function(module, exports) {



/***/ }),
/* 360 */
/***/ (function(module, exports) {



/***/ }),
/* 361 */
/***/ (function(module, exports) {



/***/ }),
/* 362 */
/***/ (function(module, exports) {



/***/ }),
/* 363 */
/***/ (function(module, exports) {



/***/ }),
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-e3fdb2f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  "data-v-3e253f8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  "data-v-0d381038",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  "data-v-87b09e2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  "data-v-59e6df1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  "data-v-5d7c8166",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  "data-v-6cf71407",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-aaef55da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-5031e5e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  "data-v-65d985d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  "data-v-fbae35a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  "data-v-040ccfbb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  "data-v-116e178c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  "data-v-01f73163",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  "data-v-6a097357",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  "data-v-8818292c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(328)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  "data-v-51b6f342",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  "data-v-75a69611",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  "data-v-dfc3ea58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  "data-v-464199f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  "data-v-d14b38a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-f83fa208",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  "data-v-7912b981",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  "data-v-828a02b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  "data-v-78ee6d04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  "data-v-08407604",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  "data-v-12833f38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(334)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  "data-v-627d013d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  "data-v-7e9a5988",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  "data-v-f66d7170",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  "data-v-97495e3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  "data-v-0a42a45d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-register",
    class: {
      guest: true
    }
  }, [(false) ? _c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.state == 'loading') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().loading.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading.text))])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'used' || _vm.state == 'expired' || _vm.state == 'done' || _vm.state == 'notFound' || _vm.state == 'resent') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))]), _vm._v(" "), (_vm.state == 'expired') ? _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n().registerLink))])], 1) : _vm._e()]), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n()[_vm.state].exitButton) + "\n      ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v("Confirm Email")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])
}]}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-password"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    ref: "oldPassword",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "oldPassword",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.i18n().oldPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-picker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "prefix-box mdl-card mdl-shadow--2dp",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    }),
    attrs: {
      "ef": "box"
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search-panel"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Country search")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text countries"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      staticClass: "country",
      on: {
        "click": function($event) {
          _vm.countrySelected(country)
        }
      }
    }, [_c('span', {
      staticClass: "countryFlag flag-icon",
      class: 'flag-icon-' + (country.code.toLowerCase())
    }), _vm._v(" "), _c('span', {
      staticClass: "countryName"
    }, [_vm._v(_vm._s(country.name))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-query"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_vm._l((_vm.categories), function(category, index) {
    return _c('div', [_c('label', [_vm._v(_vm._s(_vm.translateColumn(category.columnName)))]), _vm._v(" "), _c('MultiSelect', {
      attrs: {
        "allOption": true,
        "many": "selected",
        "options": category.options,
        "value": _vm.selectedCategories[index].options
      },
      on: {
        "update:value": function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return _vm.updateCategories.apply(void 0, [ index ].concat( args ));
    }
      }
    })], 1)
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n().columns))]), _vm._v(" "), _c('MultiSelect', {
    attrs: {
      "options": _vm.columns,
      "value": _vm.wordsColumns,
      "display": function (c) { return _vm.translateColumn(c); }
    },
    on: {
      "update:value": function($event) {
        _vm.wordsColumns = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "min-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n().number))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "words-number"
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minWords),
      expression: "minWords"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "pattern": "-?[0-9]*(\\.[0-9]+)?",
      "id": "min-words"
    },
    domProps: {
      "value": (_vm.minWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minWords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "min-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n.min))]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().isNotANumber))])]), _vm._v(" "), _c('span', {
    staticClass: "range-to"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxWords),
      expression: "maxWords"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "pattern": "-?[0-9]*(\\.[0-9]+)?",
      "id": "max-words"
    },
    domProps: {
      "value": (_vm.maxWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxWords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "max-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n.max))]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().isNotANumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleSpecialCharacters
    }
  }, [_c('span', [(_vm.ignoreSpecialCharacters) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.ignoreSpecialCharacters) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().ignoreSpecial))])]), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleIgnoreCase
    }
  }, [_c('span', [(_vm.ignoreCase) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.ignoreCase) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().ignoreCase))])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tsv-words"
  }, [_c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [(_vm.analyzer.type == 'words') ? _c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v(_vm._s(_vm.global_i18n().words.title))]) : _vm._e(), _vm._v(" "), (_vm.analyzer.type == 'ads') ? _c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v(_vm._s(_vm.global_i18n().ads.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), (_vm.inputTable) ? _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--expandable"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield__expandable-holder"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": _vm.searchText
    },
    on: {
      "change": function($event) {
        _vm.handleSearchChange($event, true)
      },
      "input": function($event) {
        _vm.handleSearchChange($event, false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.i18n().searchBox))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-grid"
  }, [(_vm.inputTable == null && _vm.state == 'ready') ? _c('div', {
    staticClass: "load-tsv mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card--expand"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().csvOrTsv))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('LoadFile', {
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  }, [_vm._v(">")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.inputFileError) ? _c('div', {
    staticClass: "file-error-holder"
  }, [_c('div', {
    staticClass: "file-error mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().inputError.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().inputError[_vm.inputFileError.type] ? _vm.i18n().inputError[_vm.inputFileError.type](_vm.inputFileError) :
    _vm.inputFileError.type) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("\n            OK\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'parsing' && !_vm.inputFileError) ? _c('div', {
    staticClass: "parsing-holder"
  }, [_c('h3', [_vm._v("Reading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.state == 'parsed') ? _c('div', [(_vm.analyzer.type == 'words') ? _c('div', [_c('WordsAnalyzer', {
    attrs: {
      "inputTable": _vm.inputTable,
      "searchText": _vm.searchText
    },
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.analyzer.type == 'ads') ? _c('div', [_c('AdsAnalyzer', {
    attrs: {
      "inputTable": _vm.inputTable,
      "searchText": _vm.searchText
    },
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  })], 1) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon",
    attrs: {
      "for": "search"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-email",
    class: {
      guest: !_vm.loggedIn
    }
  }, [(_vm.loggedIn) ? _c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.state == 'loading') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().loading.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading.text))])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'used' || _vm.state == 'expired' || _vm.state == 'done' || _vm.state == 'notFound') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n()[_vm.state].exitButton) + "\n      ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v("Confirm Email")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])
}]}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-file"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("open_in_browser")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().tapOrDrop))])]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "save-view",
    on: {
      "submit": _vm.save
    }
  }, [((_vm.state == 'ready') || (_vm.state == 'working')) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    ref: "fileName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "fileName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "fileName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().fileNamePlaceholder))])]), _vm._v(" "), _c('div', {
    staticClass: "file-list-holder"
  }, [_c('FileList', {
    attrs: {
      "contentType": _vm.contentType
    },
    on: {
      "selected": _vm.selected
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" " + _vm._s(_vm.i18n().saveToCloud) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v(" " + _vm._s(_vm.i18n().download) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e(), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand done"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().fileSaved(_vm.fileName)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand error"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().saveError(_vm.error)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("done")]), _vm._v(" " + _vm._s(_vm.i18n().ok) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nice-selectfield",
    attrs: {
      "id": 'multiselect-' + _vm.uniq
    }
  }, [_c('button', {
    ref: "button",
    staticClass: "nice-select",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("\n    " + _vm._s(_vm.visibleValue)), _c('span', [_vm._v("▾")])])])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "country-input",
    on: {
      "click": _vm.showPrefixMenu
    }
  }, [_c('div', {
    ref: "country",
    staticClass: "mdl-textfield mdl-textfield--floating-label is-upgraded",
    class: {
      'is-invalid': _vm.invalid || (_vm.required && _vm.empty),
        'is-dirty': !_vm.empty
    }
  }, [_c('span', {
    staticClass: "value mdl-textfield__input"
  }, [(!_vm.empty) ? _c('span', {
    staticClass: "countryFlag flag-icon",
    class: 'flag-icon-' + (_vm.liveValue.toLowerCase())
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.name) + "  \n    ")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "more"
  }, [_c('span', [_vm._v("▾")])])
}]}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-expression"
  }, [_c('div', {
    staticClass: "simple-expression",
    class: _vm.definition.classes
  }, [_vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg"
    }, [_c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
    staticClass: "mdl-button add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Add\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-expression"
  }, [_c('div', {
    staticClass: "expression",
    class: _vm.definition.classes
  }, [(_vm.definition.isList) ? _c('label', [_vm._v(_vm._s(_vm.definition.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('select', {
      domProps: {
        "value": _vm.expression.type
      },
      on: {
        "change": _vm.setType
      }
    }, _vm._l((_vm.possibleOperators), function(operator) {
      return _c('option', {
        domProps: {
          "value": operator.name
        }
      }, [_vm._v(_vm._s(operator.title))])
    })) : _vm._e(), _vm._v(" "), _c('filter-expression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.definition.isBinary) ? _c('span', {
    staticClass: "binaryArgs"
  }, [(_vm.definition.left == 'column') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expression.args[0]),
      expression: "expression.args[0]"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.expression.args, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.columns), function(column) {
    return _c('option', {
      domProps: {
        "value": column
      }
    }, [_vm._v(_vm._s(column))])
  })) : _vm._e(), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })), _vm._v(" "), (_vm.definition.right == 'const' || _vm.definition.right == 'regex') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expression.args[1]),
      expression: "expression.args[1]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.expression.args[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expression.args, 1, $event.target.value)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.expression.args.length == 0) ? _c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })) : _vm._e(), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
    staticClass: "mdl-button add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Add\n    ")]) : _vm._e(), _vm._v(" "), (_vm.parent) ? _c('button', {
    staticClass: "mdl-button delete-button",
    on: {
      "click": _vm.deleteThis
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_forever")]), _vm._v(" Delete\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-analyzer"
  }, [(_vm.visibleDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: 'dialog-holder-' + _vm.visibleDialog
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp "
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().dialog[_vm.visibleDialog].title))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), (_vm.visibleDialog == 'saveView') ? _c('div', [_c('SaveView', {
    attrs: {
      "contentType": "ads-view",
      "data": _vm.saveableView
    },
    on: {
      "close": _vm.closeDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDialog == 'loadView') ? _c('div', [_c('LoadView', {
    attrs: {
      "contentType": "ads-view"
    },
    on: {
      "close": _vm.closeDialog,
      "load": _vm.loadView
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.inputTable != null) ? _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stat-head"
  }, [_c('div', {
    staticClass: "stat-title-bar"
  }, [_c('h4', [_vm._v(_vm._s(_vm.inputTable.title) + " "), (_vm.inputTable.fileName) ? _c('span', [_vm._v("[" + _vm._s(_vm.i18n().filename + _vm.inputTable.fileName) + "]")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "export-buttons"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveCSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveTSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n          ")]), _vm._v(" "), _c('LoadFileSmall', {
    on: {
      "file": function (file) { return _vm.$emit('file', file); }
    }
  }, [_vm._v(">")])], 1)]), _vm._v(" "), (_vm.tips.length > 0) ? _c('div', {
    staticClass: "stat-prompt-panel"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [(_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.tipsVisible = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")])]) : _vm._e(), _vm._v(" "), (!_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.tipsVisible = true; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().tips))])]), _vm._v(" "), (_vm.tipsExpanded) ? _c('div', _vm._l((_vm.tips), function(tip, tipId) {
    return _c('div', {
      staticClass: "prompt mdl-card__supporting-text",
      class: tip.name
    }, [_c('p', [_vm._v("\n                " + _vm._s(tip.text) + "\n              ")]), _vm._v(" "), (tip.filter) ? _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
      on: {
        "click": function($event) {
          _vm.showTip(tip)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.i18n().tipApplyFilter) + "\n              ")]) : _vm._e()])
  })) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statTopBarHolder"
  }, [_c('TopBar', {
    attrs: {
      "query": _vm.query,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames,
      "categories": _vm.categories,
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "enableFilter": _vm.enableFilter,
      "filterExpanded": _vm.filterExpanded,
      "tips": _vm.tips,
      "tipsExpanded": _vm.tipsExpanded
    },
    on: {
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "update:filterExpanded": function($event) {
        _vm.filterExpanded = $event
      },
      "update:tipsExpanded": function($event) {
        _vm.tipsExpanded = $event
      },
      "showTip": _vm.showTip,
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stat-lower"
  }, [_c('AdsLeftBar', {
    attrs: {
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "query": _vm.query,
      "categories": _vm.categories,
      "enableFilter": _vm.enableFilter,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames
    },
    on: {
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [(_vm.state == 'computing' || _vm.state == 'filtering') ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'done' && _vm.limitedVisibleTable.rows.length == 0) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().empty))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'failed') ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().failed))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'wrongType') ? _c('div', {
    staticClass: "error-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().wrongType.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().wrongType.text))])]) : _vm._e(), _vm._v(" "), (_vm.limitedVisibleTable && _vm.limitedVisibleTable.rows.length > 0) ? _c('div', {
    staticClass: "table-space"
  }, [_c('AdsTable', {
    attrs: {
      "table": _vm.limitedVisibleTable,
      "sortColumn": _vm.sortColumn,
      "sortAsc": _vm.sortAsc,
      "rowHeight": _vm.query.aggregateUrls ? 111 : 91,
      "firstColumnWidth": 650,
      "endInfo": _vm.tableEndInfo
    },
    on: {
      "toggleSort": _vm.toggleSort
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.testEnvironment) ? _c('div', {
    staticClass: "testSettings"
  }, [_c('b', [_vm._v("Test Settings:")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "maxRows"
    }
  }, [_vm._v("maxRows:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxVisibleRows),
      expression: "maxVisibleRows"
    }],
    attrs: {
      "type": "text",
      "id": "maxRows"
    },
    domProps: {
      "value": (_vm.maxVisibleRows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxVisibleRows = $event.target.value
      }
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-table"
  }, [(_vm.table) ? _c('div', {
    staticClass: "table-holder",
    on: {
      "scroll": _vm.handleTableScroll
    }
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('thead', {
    style: ({
      top: _vm.tableScrollY + 'px'
    })
  }, [_c('tr', _vm._l((_vm.table.columnNames), function(columnName, colId) {
    return _c('th', {
      staticClass: "sort",
      class: [{
        desc: _vm.sortColumn == columnName && !_vm.sortAsc,
        asc: _vm.sortColumn == columnName && _vm.sortAsc,
        'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId] != 'number'
      }, 'col-' + _vm.table.columnTypes[colId]],
      on: {
        "click": function($event) {
          _vm.toggleSort(columnName)
        }
      }
    }, [_c('span', {
      attrs: {
        "id": _vm.generateId('th-' + columnName)
      }
    }, [_vm._v(_vm._s(_vm.table.displayColumnNames[colId]))]), _vm._v(" "), _c('div', {
      staticClass: "mdl-tooltip",
      attrs: {
        "data-mdl-for": _vm.generateId('th-' + columnName)
      }
    }, [_vm._v("\n              " + _vm._s(_vm.table.displayColumnNames[colId]) + "\n            ")])])
  })), _vm._v(" "), (_vm.showSummary) ? _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("\n            Summary:\n          ")]), _vm._v(" "), _vm._l((_vm.table.columnNames.slice(1)), function(columnName, colId) {
    return _c('td', {
      class: [{
        'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId + 1] != 'number'
      }, 'col-' + _vm.table.columnTypes[colId + 1], _vm.generateClass(_vm.table.columnNames[colId + 1])]
    }, [_c('span', {
      attrs: {
        "id": _vm.generateId('sum-' + columnName)
      }
    }, [_vm._v(_vm._s(_vm.cellText(_vm.table.summary[colId + 1])))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', {
    style: ({
      marginTop: (_vm.tableMargins[0] + _vm.tableTopHeight) + 'px',
      marginBottom: _vm.tableMargins[1] + 'px'
    })
  }, _vm._l((_vm.visiblePart), function(row, vRowId) {
    return _c('tr', {
      key: _vm.visiblePartRowsRange[0] + vRowId
    }, _vm._l((row), function(cell, colId) {
      return _c('td', {
        key: colId,
        class: [{
            'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId] != 'number',
            found: _vm.foundMap[(_vm.visiblePartRowsRange[0] + vRowId) + '-' + (colId)]
          },
          'col-' + _vm.table.columnTypes[colId],
          _vm.generateClass(_vm.table.columnNames[colId])
        ]
      }, [(_vm.table.columnTypes[colId] != 'ad') ? _c('span', {
        attrs: {
          "id": _vm.generateId('td-' + (_vm.visiblePartRowsRange[0] + vRowId) + '-' + colId),
          "title": _vm.cellText(cell)
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.cellText(cell)) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.table.columnTypes[colId] == 'ad') ? _c('div', {
        staticClass: "ad",
        attrs: {
          "id": _vm.generateId('td-' + (_vm.visiblePartRowsRange[0] + vRowId) + '-' + colId),
          "title": cell.title
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                    " + _vm._s(cell.title) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v("\n                    " + _vm._s(cell.text) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "url"
      }, [_vm._v("\n                    " + _vm._s(cell.url) + "\n                  ")])]) : _vm._e()])
    }))
  }))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [(_vm.tips.length > 0) ? _c('div', {
    staticClass: "stat-prompt-panel"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [(_vm.tipsExpanded) ? _c('div', _vm._l((_vm.tips), function(tip, tipId) {
    return _c('div', {
      staticClass: "prompt mdl-card__supporting-text",
      class: tip.name
    }, [_c('p', [_vm._v("\n            " + _vm._s(tip.text) + "\n          ")]), _vm._v(" "), (tip.filter) ? _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
      on: {
        "click": function($event) {
          _vm.$emit('showTip', tip)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.i18n().tipApplyFilter) + "\n          ")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (!_vm.tipsExpanded) ? _c('div', [_c('div', {
    staticClass: "mdl-card__supporting-text summary"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().tipsSummary(_vm.tips.length)) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tipsHideButton"
  }, [(_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:tipsExpanded', false); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")])]) : _vm._e(), _vm._v(" "), (!_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:tipsExpanded', true); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.enableFilter) ? _c('div', {
    staticClass: "filterHolder"
  }, [_c('TopFilterExpression', {
    attrs: {
      "expression": _vm.filter,
      "columns": _vm.calculatedColumnNames,
      "applied": !!_vm.appliedFilter,
      "filterExpanded": _vm.filterExpanded
    },
    on: {
      "update:expression": _vm.handleFilterUpdate,
      "apply": function($event) {
        _vm.$emit('applyFilter')
      },
      "update": function($event) {
        _vm.$emit('updateFilter')
      },
      "clear": function($event) {
        _vm.$emit('clearFilter')
      },
      "update:filterExpanded": function (value) { return _vm.$emit('update:filterExpanded', value); }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-expression mdl-grid"
  }, [_c('div', {
    staticClass: "top-expression mdl-card mdl-shadow--2dp mdl-cell--12-col",
    class: [_vm.definition.classes, {
      expanded: _vm.filterExpanded
    }]
  }, [_c('div', {
    staticClass: "filterHideButton"
  }, [(_vm.filterExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:filterExpanded', false); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")])]) : _vm._e(), _vm._v(" "), (!_vm.filterExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:filterExpanded', true); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]) : _vm._e()]), _vm._v(" "), (_vm.filterExpanded) ? _c('div', {
    staticClass: "args"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg mdl-grid"
    }, [_c('TopFilterAndBlock', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.filterExpanded) ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [(!_vm.applied) ? _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        _vm.$emit('apply')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().apply) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.applied) ? _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        _vm.$emit('update')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().update) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.applied) ? _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        _vm.$emit('clear')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().clear) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.filterExpanded) ? _c('div', [_c('div', {
    staticClass: "mdl-card__supporting-text summary"
  }, [_vm._v("\n        " + _vm._s(_vm.applied ? _vm.i18n().summary.activeFilter : _vm.i18n().summary.filter) + "\n        "), _vm._l((_vm.expression.args), function(group) {
    return _c('span', [_c('b', [_vm._v(_vm._s(group.type == 'and' ? 'include:' : 'exclude:'))]), _vm._v(" "), _vm._l((group.args), function(andpart, aindex) {
      return _c('span', [_vm._v("\n             "), (aindex > 0) ? _c('b', [_vm._v("and")]) : _vm._e(), _vm._v(" "), (andpart.args.length > 1) ? _c('b', [_vm._v("(")]) : _vm._e(), _vm._v(" "), _vm._l((andpart.args), function(orpart, oindex) {
        return _c('span', [_vm._v("\n               "), (oindex > 0) ? _c('b', [_vm._v("or")]) : _vm._e(), _vm._v(" "), _c('u', [_vm._v(_vm._s(_vm.translateColumn(orpart.args[0])))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.translateOperator(orpart.type)))]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.translateColumn(orpart.args[1])))])])
      }), _vm._v(" "), (andpart.args.length > 1) ? _c('b', [_vm._v(")")]) : _vm._e()], 2)
    })], 2)
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.definition.isList && _vm.filterExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fileList"
  }, [(_vm.deleting && !_vm.working) ? _c('div', {
    staticClass: "deleteDialog"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.i18n().remove.prompt(_vm.deleting)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "yesno"
  }, [_c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(_vm._s(_vm.i18n().remove.yes))]), _vm._v(" "), _c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.cancelDelete
    }
  }, [_vm._v(_vm._s(_vm.i18n().remove.no))])])]) : _vm._e(), _vm._v(" "), (_vm.fileList && !_vm.deleting && !_vm.working) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.fileList), function(file, index) {
    return _c('div', {
      staticClass: "file",
      class: {
        selected: _vm.selected == file
      },
      on: {
        "click": function($event) {
          _vm.select(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("insert_drive_file")]), _vm._v(" "), (_vm.renaming != file) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name))]) : _vm._e(), _vm._v(" "), (!_vm.renaming && !_vm.deleting) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.remove(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.rename(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("create")])])]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "rename"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newName),
        expression: "newName"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newName = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": _vm.finishRename
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done")])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fileList && !_vm.working),
      expression: "!fileList && !working"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }],
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })])])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-query"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_vm._l((_vm.categories), function(category, index) {
    return _c('div', [_c('label', [_vm._v(_vm._s(_vm.translateColumn(category.columnName)))]), _vm._v(" "), _c('MultiSelect', {
      attrs: {
        "allOption": true,
        "many": "selected",
        "options": category.options,
        "value": _vm.selectedCategories[index].options
      },
      on: {
        "update:value": function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return _vm.updateCategories.apply(void 0, [ index ].concat( args ));
    }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleAggregateUrls
    }
  }, [_c('span', [(_vm.aggregateUrls) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.aggregateUrls) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().aggregateUrls))])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-and-block"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "blockTop"
  }, [_c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })), _vm._v(" "), (_vm.parent) ? _c('button', {
    staticClass: "mdl-button delete-button",
    on: {
      "click": _vm.deleteThis
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_forever")]), _vm._v(" Delete\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "andLine"
    }, [_vm._v("AND"), _c('div', {
      staticClass: "line"
    })]) : _vm._e(), _vm._v(" "), _c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        },
        "addAnd": function($event) {
          _vm.addArg(argId)
        }
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "phone-input"
  }, [_c('div', {
    ref: "prefix",
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield prefix",
    class: {
      'is-invalid': _vm.prefixInvalid
    },
    on: {
      "click": _vm.showPrefixMenu
    }
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.prefix.length > 0 ? _vm.prefix : "+??"))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield mdl-textfield--floating-label number"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    ref: "number",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "number",
      "required": _vm.required,
      "pattern": "[0-9 #+-]{3,}"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "number"
    }
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "more"
  }, [_c('span', [_vm._v("▾")])])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    },
    on: {
      "dragenter": _vm.dragEnter
    }
  }, [_c('div', {
    staticClass: "demo-layout mdl-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50",
    class: {
      'is-visible': _vm.drawerVisible
    },
    attrs: {
      "id": "main-drawer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('LeftMenu')], 1) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-100",
    class: {
      'drawer-is-visible': _vm.drawerVisible && _vm.loggedIn
    }
  }, [(_vm.loggedIn) ? _c('button', {
    staticClass: "drawer-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.showDrawer
    }
  }, [(!_vm.drawerVisible) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.drawerVisible) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('router-view')], 1)])]), _vm._v(" "), _c('overlay-component', {
    attrs: {
      "overlayModel": _vm.overlayModel
    }
  }), _vm._v(" "), _c('GlobalDropZone')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-drawer-header"
  }, [_c('img', {
    staticClass: "demo-avatar",
    attrs: {
      "src": "/static/images/voleadstools2_mid.png"
    }
  })])
}]}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "demo-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("home")]), _vm._v("\n    " + _vm._s(_vm.i18n().home) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'csv-words'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("search")]), _vm._v("\n    " + _vm._s(_vm.i18n().csvWordsAnalyzer) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'csv-ads'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("grade")]), _vm._v("\n    " + _vm._s(_vm.i18n().csvAdsAnalyzer) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'account-settings'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("account_box")]), _vm._v("\n    " + _vm._s(_vm.i18n().accountSettings) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("exit_to_app")]), _vm._v("\n    " + _vm._s(_vm.i18n().logout) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.i18n().help))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    class: {
      guest: !_vm.loggedIn
    }
  }, [(_vm.loggedIn) ? _c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready') ? _c('div', {
    staticClass: "orderFormHolder"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp orderForm"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().billingData))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.user_i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.firstName),
      expression: "editedUserData.firstName"
    }],
    ref: "firstName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "firstName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.lastName),
      expression: "editedUserData.lastName"
    }],
    ref: "lastName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "lastName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().lastName))])]), _vm._v(" "), _c('PhoneInput', {
    staticClass: "phoneNumber field",
    attrs: {
      "value": _vm.editedUserData.phoneNumber,
      "required": _vm.required,
      "invalid": _vm.phoneNumberInvalid,
      "label": _vm.user_i18n().phoneNumber
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "phoneNumber", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.companyName),
      expression: "editedUserData.companyName"
    }],
    ref: "companyName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "companyName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().companyName))])]), _vm._v(" "), _c('CountryInput', {
    staticClass: "country field",
    attrs: {
      "value": _vm.editedUserData.country,
      "required": _vm.required,
      "invalid": _vm.countryInvalid,
      "label": _vm.user_i18n().country
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "country", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.city),
      expression: "editedUserData.city"
    }],
    ref: "city",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "city",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().city))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine1),
      expression: "editedUserData.addressLine1"
    }],
    ref: "addressLine1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine1"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().addressLine1))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine2),
      expression: "editedUserData.addressLine2"
    }],
    ref: "addressLine2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine2"
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine2"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().addressLine2))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.postalCode),
      expression: "editedUserData.postalCode"
    }],
    ref: "postalCode",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "postalCode"
    },
    domProps: {
      "value": (_vm.editedUserData.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "postalCode"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().postalCode))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.taxNumber),
      expression: "editedUserData.taxNumber"
    }],
    ref: "taxNumber",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "taxNumber"
    },
    domProps: {
      "value": (_vm.editedUserData.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "taxNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "taxNumber"
    }
  }, [_vm._v(_vm._s(_vm.user_i18n().taxNumber))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().productData))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "prevButton mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().back) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "nextButton mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.buy
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().next) + "\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('h4', [_vm._v("\n          Semgregate Gold  -  250 USD / month\n        ")])])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "premium-overlay-holder",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("\n          clear\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().text))])])])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiSelectPicker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    })
  }, [_c('ul', {}, _vm._l((_vm.visibleOptions), function(option, index) {
    return _c('li', {}, [(option != _vm.i18n().all) ? _c('span', {
      staticClass: "checkbox",
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [(_vm.isSelected(option)) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.isSelected(option)) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option == _vm.i18n().all) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [(_vm.liveValue.length == _vm.options.length) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (_vm.liveValue.length != _vm.options.length) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label",
      attrs: {
        "id": 'multiselect-' + _vm.uniq + '-' + index
      },
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.display(option)) + "\n        ")])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-select",
    attrs: {
      "id": 'multiselect-' + _vm.uniq
    }
  }, [_c('button', {
    ref: "button",
    staticClass: "nice-select",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.visibleValue)), _c('span', [_vm._v("▾")])])])
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-table"
  }, [(_vm.table) ? _c('div', {
    ref: "holder",
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "header-scroller"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      transform: ("translate(" + (-_vm.scrollLeft) + "px, 0px)")
    })
  }, [_c('div', {
    ref: "firstHeadRow",
    staticClass: "header-row"
  }, _vm._l((_vm.table.columnNames), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell header-cell",
      class: [{
        'non-numeric': _vm.table.columnTypes[colId] != 'number',
        'sort-desc': _vm.sortColumn == columnName && !_vm.sortAsc,
        'sort-asc': _vm.sortColumn == columnName && _vm.sortAsc
      }],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      }),
      on: {
        "click": function($event) {
          _vm.toggleSort(columnName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.table.displayColumnNames[colId]) + "\n          ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "cell non-numeric"
  }, [_vm._v("\n            Summary:\n          ")]), _vm._l((_vm.table.columnNames.slice(1)), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell",
      class: [{
          'non-numeric': _vm.table.columnTypes[colId + 1] != 'number'
        },
        _vm.generateClass(_vm.table.columnNames[colId + 1])
      ],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      })
    }, [_vm._v("\n            " + _vm._s(_vm.cellText(_vm.table.summary[colId + 1])) + "\n          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "body-holder",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    style: ({
      height: _vm.topMargin + 'px'
    })
  }), _vm._v(" "), _vm._l((_vm.renderedRows), function(row, rowId) {
    return _c('div', {
      key: rowId + _vm.renderedRowsRange.begin,
      staticClass: "row",
      style: ({
        height: _vm.rowHeight + 'px'
      })
    }, _vm._l((row), function(cell, colId) {
      return _c('div', {
        staticClass: "cell",
        class: [{
            'non-numeric': _vm.table.columnTypes[colId] != 'number'
          },
          _vm.generateClass(_vm.table.columnNames[colId])
        ],
        style: ({
          width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
        }),
        on: {
          "mouseover": function (event) { return _vm.handleMouseOver(event, cell, colId); },
          "mouseout": _vm.handleMouseOut
        }
      }, [(_vm.table.columnTypes[colId] != 'ad') ? _c('span', {
        staticClass: "expandable"
      }, [_vm._v("\n              " + _vm._s(_vm.cellText(cell)) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.table.columnTypes[colId] == 'ad') ? _c('div', {
        staticClass: "ad"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(cell.title) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v("\n                " + _vm._s(cell.text1 || '\u00A0') + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v("\n                " + _vm._s(cell.text2 || '\u00A0') + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "url"
      }, [_vm._v("\n                " + _vm._s(cell.url) + "\n              ")])]) : _vm._e()])
    }))
  }), _vm._v(" "), (_vm.endInfo && _vm.bottomMargin == 0) ? _c('div', {
    staticClass: "endInfo",
    class: _vm.endInfo.type
  }, [_c('div', {
    staticClass: "endInfoText"
  }, [_vm._v("\n            " + _vm._s(_vm.endInfo.text) + "\n          ")]), _vm._v(" "), (_vm.endInfo.type == 'download') ? _c('div', [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveCSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveTSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      height: _vm.bottomMargin + 'px'
    })
  })], 2)]), _vm._v(" "), (_vm.extender) ? _c('div', {
    staticClass: "extender",
    class: [{
      'non-numeric': _vm.table.columnTypes[_vm.extender.colId] != 'number'
    }],
    style: ({
      left: _vm.extender.x + 'px',
      top: _vm.extender.y + 'px',
      'min-width': _vm.extender.w + 'px',
      'padding-left': _vm.extender.paddingLeft,
      'height': _vm.rowHeight + 'px'
    })
  }, [(_vm.table.columnTypes[_vm.extender.colId] != 'ad') ? _c('span', [_vm._v("\n        " + _vm._s(_vm.cellText(_vm.extender.cell)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.table.columnTypes[_vm.extender.colId] == 'ad') ? _c('div', {
    staticClass: "ad"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.extender.cell.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n          " + _vm._s(_vm.extender.cell.text) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "url"
  }, [_vm._v("\n          " + _vm._s(_vm.extender.cell.url) + "\n        ")])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-view"
  }, [((_vm.state == 'ready') || (_vm.state == 'working')) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "file-list-holder"
  }, [_c('FileList', {
    attrs: {
      "contentType": _vm.contentType
    },
    on: {
      "selected": _vm.selected
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.selectedFile
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")]), _vm._v(" " + _vm._s(_vm.i18n().loadFromCloud) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "upload"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")]), _vm._v(" " + _vm._s(_vm.i18n().upload) + "\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e(), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand done"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().loaded(_vm.fileName)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand error"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n().loadError(_vm.error)))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'error' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("done")]), _vm._v(_vm._s(_vm.i18n().ok) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-form"
  }, [(_vm.state == 'resent' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text({
    email: _vm.email
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.state != 'resent' && _vm.state != 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), (_vm.error == 'registrationNotConfirmed') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.i18n().resendButton))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.register
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    ref: "firstName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "firstName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    ref: "lastName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "lastName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().lastName))])]), _vm._v(" "), _c('PhoneInput', {
    staticClass: "phoneNumber",
    attrs: {
      "value": _vm.phoneNumber,
      "required": _vm.required,
      "invalid": _vm.phoneNumberInvalid,
      "label": _vm.i18n().phoneNumber
    },
    on: {
      "update:value": function($event) {
        _vm.phoneNumber = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.i18n().email))])]), _vm._v(" "), (_vm.passwordTooSimple) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v(_vm._s(_vm.i18n().passwordTooSimple))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.i18n().password))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    ref: "password2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.recaptchaSiteKey
    },
    on: {
      "verify": _vm.verified
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-analyzer"
  }, [(_vm.visibleDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: 'dialog-holder-' + _vm.visibleDialog
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp "
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().dialog[_vm.visibleDialog].title))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), (_vm.visibleDialog == 'saveView') ? _c('div', [_c('SaveView', {
    attrs: {
      "contentType": "words-view",
      "data": _vm.saveableView
    },
    on: {
      "close": _vm.closeDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDialog == 'loadView') ? _c('div', [_c('LoadView', {
    attrs: {
      "contentType": "words-view"
    },
    on: {
      "close": _vm.closeDialog,
      "load": _vm.loadView
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.inputTable != null) ? _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stat-head"
  }, [_c('div', {
    staticClass: "stat-title-bar"
  }, [_c('h4', [_vm._v(_vm._s(_vm.inputTable.title)), (_vm.inputTable.fileName) ? _c('span', [_vm._v("[" + _vm._s(_vm.i18n().filename + _vm.inputTable.fileName) + "]")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "export-buttons"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveCSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveTSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n          ")]), _vm._v(" "), _c('LoadFileSmall', {
    on: {
      "file": function (file) { return _vm.$emit('file', file); }
    }
  }, [_vm._v(">")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "statTopBarHolder"
  }, [_c('TopBar', {
    attrs: {
      "query": _vm.query,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames,
      "categories": _vm.categories,
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "enableFilter": _vm.enableFilter,
      "filterExpanded": _vm.filterExpanded,
      "tips": _vm.tips,
      "tipsExpanded": _vm.tipsExpanded
    },
    on: {
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "update:filterExpanded": function($event) {
        _vm.filterExpanded = $event
      },
      "update:tipsExpanded": function($event) {
        _vm.tipsExpanded = $event
      },
      "showTip": _vm.showTip,
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stat-lower"
  }, [_c('WordsLeftBar', {
    attrs: {
      "query": _vm.query,
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames,
      "categories": _vm.categories,
      "enableFilter": _vm.enableFilter
    },
    on: {
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [(_vm.state == 'computing' || _vm.state == 'filtering') ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'done' && _vm.limitedVisibleTable.rows.length == 0) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().empty))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'failed' && _vm.limitedVisibleTable.rows.length == 0) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().failed))])]) : _vm._e(), _vm._v(" "), (_vm.limitedVisibleTable && _vm.limitedVisibleTable.rows.length > 0) ? _c('div', {
    staticClass: "table-space"
  }, [_c('BigTable2', {
    attrs: {
      "table": _vm.limitedVisibleTable,
      "sortColumn": _vm.sortColumn,
      "sortAsc": _vm.sortAsc,
      "endInfo": _vm.tableEndInfo
    },
    on: {
      "toggleSort": _vm.toggleSort
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.testEnvironment) ? _c('div', {
    staticClass: "testSettings"
  }, [_c('b', [_vm._v("Test Settings:")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "maxRows"
    }
  }, [_vm._v("maxRows:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxVisibleRows),
      expression: "maxVisibleRows"
    }],
    attrs: {
      "type": "text",
      "id": "maxRows"
    },
    domProps: {
      "value": (_vm.maxVisibleRows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxVisibleRows = $event.target.value
      }
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-or-block"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "orLine"
    }, [_vm._v("OR")]) : _vm._e(), _vm._v(" "), _c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    }), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addArg
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")]), _vm._v(" OR\n      ")]) : _vm._e(), _vm._v(" "), (_vm.definition.isList && argId + 1 == _vm.expression.args.length) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addOuterAnd
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")]), _vm._v(" AND\n      ")]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-table"
  }, [(_vm.table) ? _c('div', {
    ref: "holder",
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "header-scroller"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      transform: ("translate(" + (-_vm.scrollLeft) + "px, 0px)")
    })
  }, [_c('div', {
    ref: "firstHeadRow",
    staticClass: "header-row"
  }, _vm._l((_vm.table.columnNames), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell header-cell",
      class: [{
        'non-numeric': _vm.table.columnTypes[colId] != 'number',
        'sort-desc': _vm.sortColumn == columnName && !_vm.sortAsc,
        'sort-asc': _vm.sortColumn == columnName && _vm.sortAsc
      }],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      }),
      on: {
        "click": function($event) {
          _vm.toggleSort(columnName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.table.displayColumnNames[colId]) + "\n          ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "cell non-numeric"
  }, [_vm._v("\n            Summary:\n          ")]), _vm._l((_vm.table.columnNames.slice(1)), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell",
      class: [{
          'non-numeric': _vm.table.columnTypes[colId + 1] != 'number'
        },
        _vm.generateClass(_vm.table.columnNames[colId + 1])
      ],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      })
    }, [_vm._v("\n            " + _vm._s(_vm.cellText(_vm.table.summary[colId + 1])) + "\n          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "body-holder",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    style: ({
      height: _vm.topMargin + 'px'
    })
  }), _vm._v(" "), _vm._l((_vm.renderedRows), function(row, rowId) {
    return _c('div', {
      key: rowId + _vm.renderedRowsRange.begin,
      staticClass: "row"
    }, _vm._l((row), function(cell, colId) {
      return _c('div', {
        staticClass: "cell",
        class: [{
            'non-numeric': _vm.table.columnTypes[colId] != 'number'
          },
          _vm.generateClass(_vm.table.columnNames[colId])
        ],
        style: ({
          width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
        }),
        on: {
          "mouseover": _vm.handleMouseOver,
          "mouseout": _vm.handleMouseOut
        }
      }, [_c('span', {
        staticClass: "expandable"
      }, [(colId == 0) ? _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent copy-words",
        on: {
          "click": function($event) {
            _vm.copyText(_vm.cellText(cell))
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_copy")])]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.cellText(cell)) + "\n            ")])])
    }))
  }), _vm._v(" "), (_vm.endInfo && _vm.bottomMargin == 0) ? _c('div', {
    staticClass: "endInfo",
    class: _vm.endInfo.type
  }, [_c('div', {
    staticClass: "endInfoText"
  }, [_vm._v("\n            " + _vm._s(_vm.endInfo.text) + "\n          ")]), _vm._v(" "), (_vm.endInfo.type == 'download') ? _c('div', [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveCSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveTSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      height: _vm.bottomMargin + 'px'
    })
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.extender) ? _c('div', {
    staticClass: "extender",
    class: [{
      'non-numeric': _vm.extender.nonNumeric
    }],
    style: ({
      left: _vm.extender.x + 'px',
      top: _vm.extender.y + 'px',
      'min-width': _vm.extender.w + 'px',
      'padding-left': _vm.extender.paddingLeft
    })
  }, [_vm._v(_vm._s(_vm.extender.text))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-user-data"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done' && _vm.state != 'loading') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.firstName),
      expression: "editedUserData.firstName"
    }],
    ref: "firstName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "firstName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.lastName),
      expression: "editedUserData.lastName"
    }],
    ref: "lastName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "lastName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().lastName))])]), _vm._v(" "), _c('PhoneInput', {
    staticClass: "phoneNumber field",
    attrs: {
      "value": _vm.editedUserData.phoneNumber,
      "required": _vm.required,
      "invalid": _vm.phoneNumberInvalid,
      "label": _vm.i18n().phoneNumber
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "phoneNumber", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.companyName),
      expression: "editedUserData.companyName"
    }],
    ref: "companyName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "companyName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().companyName))])]), _vm._v(" "), _c('CountryInput', {
    staticClass: "country field",
    attrs: {
      "value": _vm.editedUserData.country,
      "required": _vm.required,
      "invalid": _vm.countryInvalid,
      "label": _vm.i18n().country
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "country", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.city),
      expression: "editedUserData.city"
    }],
    ref: "city",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "city",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.i18n().city))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine1),
      expression: "editedUserData.addressLine1"
    }],
    ref: "addressLine1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().addressLine1))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine2),
      expression: "editedUserData.addressLine2"
    }],
    ref: "addressLine2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine2"
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().addressLine2))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.postalCode),
      expression: "editedUserData.postalCode"
    }],
    ref: "postalCode",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "postalCode"
    },
    domProps: {
      "value": (_vm.editedUserData.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "postalCode"
    }
  }, [_vm._v(_vm._s(_vm.i18n().postalCode))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.taxNumber),
      expression: "editedUserData.taxNumber"
    }],
    ref: "taxNumber",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "taxNumber"
    },
    domProps: {
      "value": (_vm.editedUserData.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "taxNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "taxNumber"
    }
  }, [_vm._v(_vm._s(_vm.i18n().taxNumber))])])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.dataEdited,
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-prefix-picker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "prefix-box mdl-card mdl-shadow--2dp",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    }),
    attrs: {
      "ef": "box"
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search-panel"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Country search")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text countries"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      staticClass: "country",
      on: {
        "click": function($event) {
          _vm.countrySelected(country)
        }
      }
    }, [_c('span', {
      staticClass: "countryFlag flag-icon",
      class: 'flag-icon-' + (country.code.toLowerCase())
    }), _vm._v(" "), _c('span', {
      staticClass: "countryPrefix"
    }, [_vm._v(_vm._s(country.dial_code))]), _vm._v(" "), _c('span', {
      staticClass: "countryName"
    }, [_vm._v(_vm._s(country.name))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-page"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))]), _vm._v(" "), (_vm.state == 'done') ? _c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    attrs: {
      "to": {
        name: 'login'
      },
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().login) + "\n      ")]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "mdl-grid demo-content"
  }, [_c('div', {
    staticClass: "demo-charts mdl-color--white mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-grid"
  }, [_c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "font-size": "0.2",
      "dy": "-0.07"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-graphs mdl-shadow--2dp mdl-color--white mdl-cell mdl-cell--8-col"
  }, [_c('svg', {
    staticClass: "demo-graph",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 500 250"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#chart"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "demo-graph",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 500 250"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#chart"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "fixed",
      "left": "-1000px",
      "height": "-1000px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1"
    }
  }, [_c('defs', [_c('mask', {
    attrs: {
      "id": "piemask",
      "maskContentUnits": "objectBoundingBox"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.49",
      "fill": "white"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.40",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "piechart"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 0.5 0.5 0.5 0 A 0.5 0.5 0 0 1 0.95 0.28 z",
      "stroke": "none",
      "fill": "rgba(255, 255, 255, 0.75)"
    }
  })])])]), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "fixed",
      "left": "-1000px",
      "height": "-1000px"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 500 250"
    }
  }, [_c('defs', [_c('g', {
    attrs: {
      "id": "chart"
    }
  }, [_c('g', {
    attrs: {
      "id": "Gridlines"
    }
  }, [_c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "27.3",
      "x2": "468.3",
      "y2": "27.3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "66.7",
      "x2": "468.3",
      "y2": "66.7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "105.3",
      "x2": "468.3",
      "y2": "105.3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "144.7",
      "x2": "468.3",
      "y2": "144.7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "184.3",
      "x2": "468.3",
      "y2": "184.3"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Numbers"
    }
  }, [_c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 29.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 69)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("400")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 109.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("300")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 149)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("200")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 188.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 0 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 78 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 154.6667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 232.1667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 309 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 386.6667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 464.3333 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_5"
    }
  }, [_c('polygon', {
    attrs: {
      "opacity": "0.36",
      "stroke-miterlimit": "10",
      "points": "0,223.3 48,138.5 154.7,169 211,88.5\n            294.5,80.5 380,165.2 437,75.5 469.5,223.3 \t"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_4"
    }
  }, [_c('polygon', {
    attrs: {
      "stroke-miterlimit": "10",
      "points": "469.3,222.7 1,222.7 48.7,166.7 155.7,188.3 212,132.7\n            296.7,128 380.7,184.3 436.7,125 \t"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-cards mdl-cell mdl-cell--4-col mdl-cell--8-col-tablet mdl-grid mdl-grid--no-spacing"
  }, [_c('div', {
    staticClass: "demo-updates mdl-card mdl-shadow--2dp mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--12-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card--expand mdl-color--teal-300"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Updates")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--grey-600"
  }, [_vm._v("\n          Non dolore elit adipisicing ea reprehenderit consectetur culpa.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Read More")])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-separator mdl-cell--1-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-options mdl-card mdl-color--deep-purple-500 mdl-shadow--2dp mdl-cell mdl-cell--4-col mdl-cell--3-col-tablet mdl-cell--12-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--blue-grey-50"
  }, [_c('h3', [_vm._v("View options")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox1"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Click per object")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox2"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Views per object")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox3"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Objects selected")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox4"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox4"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Objects viewed")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-color-text--blue-grey-50",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Change location")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("location_on")])])])])
}]}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password"
  }, [(_vm.state == 'loading') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().loading.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading.text))])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'used' || _vm.state == 'expired' || _vm.state == 'done' || _vm.state == 'notFound') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'loging'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n()[_vm.state].loginButton) + "\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-left-bar mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [(false) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent expand",
    on: {
      "click": _vm.toggleQueryExpand
    }
  }, [(_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")]) : _vm._e(), _vm._v(" "), (!_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "query-controls"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('load')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.queryExpand),
      expression: "queryExpand"
    }],
    staticClass: "mdl-card__supporting-text query-panel"
  }, [_c('div', [_c('WordsQuery', {
    attrs: {
      "columns": _vm.wordsColumnNames,
      "categories": _vm.categories,
      "query": _vm.query
    },
    on: {
      "update:query": _vm.handleQueryUpdate
    }
  })], 1), _vm._v(" "), _c('div', [_c('Checkbox', {
    attrs: {
      "checked": _vm.enableFilter,
      "label": _vm.i18n().filterResults
    },
    on: {
      "update:checked": _vm.handleEnableFilterUpdate
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-left-bar mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent bar_button",
    on: {
      "click": _vm.toggleQueryExpand
    }
  }, [(_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")]) : _vm._e(), _vm._v(" "), (!_vm.queryExpand) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "bar-controls"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function($event) {
        _vm.$emit('load')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.queryExpand),
      expression: "queryExpand"
    }],
    staticClass: "mdl-card__supporting-text query-panel"
  }, [_c('AdsQuery', {
    attrs: {
      "categories": _vm.categories,
      "query": _vm.query
    },
    on: {
      "update:query": _vm.handleQueryUpdate
    }
  }), _vm._v(" "), _c('div', [_c('Checkbox', {
    attrs: {
      "checked": _vm.enableFilter,
      "label": _vm.i18n().filterResults
    },
    on: {
      "update:checked": _vm.handleEnableFilterUpdate
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-file-small"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("unarchive")]), _vm._v(_vm._s(_vm.i18n().load) + "\n  ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-logic-block"
  }, [_c('div', {
    staticClass: "expression",
    class: _vm.definition.classes
  }, [(_vm.definition.isList) ? _c('label', [_vm._v(_vm._s(_vm.definition.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('select', {
      domProps: {
        "value": _vm.expression.type
      },
      on: {
        "change": _vm.setType
      }
    }, _vm._l((_vm.possibleOperators), function(operator) {
      return _c('option', {
        domProps: {
          "value": operator.name
        }
      }, [_vm._v(_vm._s(operator.title))])
    })) : _vm._e(), _vm._v(" "), _c('top-filter-logic-block', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.definition.isBinary) ? _c('span', {
    staticClass: "binaryArgs"
  }, [(_vm.definition.left == 'column') ? _c('SingleSelect', {
    attrs: {
      "value": _vm.expression.args[0],
      "options": _vm.columns,
      "display": function (c) { return _vm.translateColumn(c); }
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.expression.args, 0, $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('SingleSelect', {
    attrs: {
      "value": _vm.operatorObject(_vm.expression.type),
      "options": _vm.possibleOperators,
      "display": function (c) { return _vm.translateOperator(c); }
    },
    on: {
      "update:value": _vm.setType
    }
  }), _vm._v(" "), (_vm.definition.right == 'const' || _vm.definition.right == 'regex') ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expression.args[1]),
      expression: "expression.args[1]"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "v"
    },
    domProps: {
      "value": (_vm.expression.args[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expression.args, 1, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "v"
    }
  }, [_vm._v("Value")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.expression.args.length == 0) ? _c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })) : _vm._e(), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
    staticClass: "mdl-button add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Add\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-and-block mdl-card__supporting-text"
  }, [(_vm.parent) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent delete-button",
    on: {
      "click": _vm.deleteThis
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_forever")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block "
  }, [_c('div', {
    staticClass: "blockLeft"
  }, [_c('SingleSelect', {
    attrs: {
      "value": _vm.operatorObject(_vm.expression.type),
      "options": _vm.possibleOperators,
      "display": function (o) { return _vm.i18n().operators[o.title] || 'i18n:' + o.title; }
    },
    on: {
      "update:value": _vm.setType
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "blockArgs"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "andLine"
    }, [_vm._v(_vm._s(_vm.i18n().andLine)), _c('div', {
      staticClass: "line"
    })]) : _vm._e(), _vm._v(" "), _c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        },
        "addAnd": function($event) {
          _vm.addArg(argId)
        }
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', [(_vm.checked) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.checked) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-settings"
  }, [_c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.i18n().title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('ChangeUserData'), _vm._v(" "), _c('ChangePassword'), _vm._v(" "), _c('ChangeEmail')], 1)])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [(_vm.state == 'reset' || _vm.state == 'resent') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text({
    email: _vm.email
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.state != 'reset' && _vm.state != 'resent') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), (_vm.error == 'wrongPassword') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(_vm._s(_vm.i18n().resetButton))]) : _vm._e(), _vm._v(" "), (_vm.error == 'registrationNotConfirmed') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.i18n().resendButton))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.login
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.i18n().email))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.i18n().password))])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().registerText) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n().registerLink))])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiSelectPicker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    })
  }, [_c('ul', {}, _vm._l((_vm.visibleOptions), function(option, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.set(option)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.display(option)))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-or-block"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "orLine"
    }, [_vm._v(_vm._s(_vm.i18n().orLine))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "orRow"
    }, [_c('div', {
      staticClass: "expr"
    }, [_c('TopFilterLogicBlock', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [(_vm.parent) ? _c('button', {
      staticClass: "mdl-button delete-button",
      on: {
        "click": function($event) {
          _vm.deleteArg(argId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]) : _vm._e(), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addArg
      }
    }, [_vm._v(" " + _vm._s(_vm.i18n().or) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.definition.isList && argId + 1 == _vm.expression.args.length) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addOuterAnd
      }
    }, [_vm._v(" " + _vm._s(_vm.i18n().and) + "\n          ")]) : _vm._e()])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-email"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text({
    email: _vm.newEmail
  })) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    ref: "newEmail",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "newEmail",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newEmail"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }],
    ref: "currentPassword",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "currentPassword",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "currentPassword"
    }
  }, [_vm._v(_vm._s(_vm.i18n().currentPassword))])])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
	return new Worker(__webpack_require__.p + "ee72ec452deaaea2777a.worker.js");
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
	return new Worker(__webpack_require__.p + "797aa449f90eb2b5503b.worker.js");
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
	return new Worker(__webpack_require__.p + "a40e8413410242802a91.worker.js");
};

/***/ })
],[220]);


// WEBPACK FOOTER //
// static/js/app.f02d0a4b52fbc17cd69c.js